export default {
  diet: {
    title: "Dietas",
    buttonNewDiet: "Nova dieta",
    table: {
      title: "Lista de Dietas",
      columns: {
        status: "Status",
        description: "Dieta",
        phosphorus: "Fósforo (mg)",
        nitrogen: "Nitrogênio (mg)",
        tdn: "NDT (g)",
        cp: "Proteína Bruta (g)",
        calcium: "Cálcio (mg)",
        cost: "Custo (R$/Kg)",
      },
    },
    drawerTitle: "Cadastro de Dieta",
    drawerTitleEdit: "Editar Dieta",
    drawerSubTitle: "Complete os campos abaixo para criar uma nova dieta",
    drawerSubTitleEdit: "Complete os campos abaixo para editar a dieta",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      name: "Identificação da dieta",
      namePlaceHolder: "Nome da dieta",
      pasture: "Forrageira",
      pasturePlaceHolder: "Qual é a forrageira da dieta?",
      pastureNoSelection: "Nenhum",
      supplements: "Suplementos/Concent.",
      supplementsPlaceHolder:
        "Qual são os Suplemento/Concent. inseridos na dieta?",
      cost: "Custo da Dieta (R$/Kg)",
      costPlaceHolder: "Qual o custo da dieta em R$/Kg?",
      phosphorus: "Fósforo (mg)",
      phosphorusPlaceHolder: "Qual a quantidade de Fósforo?",
      nitrogen: "Nitrogênio (mg)",
      nitrogenPlaceHolder: "Qual a quantidade de Nitrogênio?",
      calcium: "Cálcio (mg)",
      calciumPlaceHolder: "Qual a quantidade de Cálcio?",
      tdn: "NDT (g)",
      tdnPlaceHolder: "Qual a quantidade de NDT?",
      cp: "Proteína Bruta (g)",
      cpPlaceHolder: "Qual a quantidade de Proteína Bruta?",
      status: "Status da dieta",
      error: {
        requiredPastureSupplement: {
          title: "Erro",
          message:
            "A Forrageira ou pelo menos um Suplemento/Concent. deve ser selecionado",
        },
      },
    },
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar dieta e adicionar nova",
    },
  },
  pasture: {
    title: "Forrageiras",
    buttonNewPasture: "Nova Forrageira",
    table: {
      title: "Lista de Forrageiras",
      columns: {
        status: "Status",
        description: "Forrageira",
        phosphorus: "Fósforo (mg)",
        nitrogen: "Nitrogênio (mg)",
        tdn: "NDT (g)",
        cp: "PB (g)",
        calcium: "Cálcio (mg)",
        cost: "Custo (animal/ha)",
        entryHeight: "Alt. Entrada",
        exitHeight: "Alt. Saída",
        growthSpeed: "Veloc. Cresc.",
        yield: "Rendimento",
      },
    },
    drawerTitle: "Cadastro de Forrageira",
    drawerTitleEdit: "Editar Forrageira",
    drawerSubTitle: "Complete os campos abaixo para criar uma nova forrageira",
    drawerSubTitleEdit: "Complete os campos abaixo para editar a forrageira",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      groupFarmVisibility: "Quem irá utilizar a forrageira?",
      name: "Identificação",
      namePlaceHolder: "Nome da forrageira",
      pastureType: "Nome científico",
      fertilized: "Adubado",
      notFertilized: "Não adubado",
      cost: "Custo",
      costPlaceHolder: "Medida: R$",
      cp: "PB: Proteína Bruta",
      cpPlaceHolder: "Medida: g",
      fdn: "FDN: Fibra em detergente neutro",
      fdnPlaceHolder: "Medida: %",
      tdn: "NDT: Nutrientes Digest. Totais",
      tdnPlaceHolder: "Medida: g",
      phosphorus: "Fósforo",
      phosphorusPlaceHolder: "Medida: g/kg",
      nitrogen: "Nitrogênio",
      nitrogenPlaceHolder: "Medida: mg/kg",
      calcium: "Cálcio",
      calciumPlaceHolder: "Medida: g/kg",
      zinc: "Zinco",
      zincPlaceHolder: "Medida: mg/kg",
      sodium: "Sódio",
      sodiumPlaceHolder: "Medida: g/kg",
      formation: "Formação",
      formationPlaceHolder: "Medida: dias",
      rest: "Descanso",
      restPlaceHolder: "Medida: dias",
      entryHeight: "Altura ideal de Entrada",
      entryHeightPlaceHolder: "Medida: cm",
      exitHeight: "Altura ideal de Saída",
      exitHeightPlaceHolder: "Medida: cm",
      growthRate: "Taxa de Crescimento",
      growthRatePlaceHolder: "Medida: kg/ha/dia",
      leafDensityProduction: "Produção MS Foliar",
      leafDensityProductionPlaceHolder: "Medida: t/ha/corte",
      growthSpeed: "Taxa de Crescimento",
      growthSpeedPlaceHolder: "Medida: kg MS/㎡/dia",
      yield: "Rendimento",
      yieldPlaceHolder: "Medida: kg MS/㎡",
      status: "Status da forrageira",
      nutritionalData: "DADOS NUTRICIONAIS",
      capacity: "CAPACIDADE",
      maximumConsumption: "Consumo máximo",
      minimumConsumption: "Consumo mínimo",
      radiogroup: {
        farm: "Somente esta fazenda",
        group: "Fazendas do grupo",
      },
      fda: "FDA",
      lignin: "Lignina",
      ee: "Extrato Etéreo",
      maximumHeight: "Altura Máxima",
      maximumHeightPlaceHolder: "Altura Máxima",
    },
    modal: {
      confirmation: {
        title: "Troca do Tipo da Forrageira",
        message:
          "Ao confirmar a troca do tipo da forrageira os valores de altura ideal de entrada, altura ideal de saída e estações climáticas serão alterados. Deseja continuar?",
        confirmButton: "Confirmar",
        cancelButton: "Cancelar",
      },
    },
    errorConsumptionMaximumLessThanMinimum:
      "O consumo máximo deve ser maior que o consumo mínimo",
    errorEntryHeightLessThanExitEntryHeight:
      "A altura ideal de entrada deve ser maior que a altura ideal de saída",
    errorNecessaryOneSeason:
      "É necessário ter pelo menos uma estação informado",
    errorFertilizedSeasonInfoIncomplete:
      "Informe ou mantenha pendente os dados da forrageira adubado em todos os períodos climáticos",
    errorUnfertilizedSeasonInfoIncomplete:
      "Informe ou mantenha pendente os dados da forrageira não adubado em todos os períodos climáticos",
    errorPastureInfoForAllSeasonsIncomplete:
      "Informe ou mantenha pendente os dados da forrageira adubado e não adubado em todos os períodos climáticos",
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar forrageira e adicionar nova",
    },
  },
  breed: {
    title: "Raças",
    buttonNewBreed: "Nova raça",
    table: {
      title: "Lista de Raças",
      columns: {
        status: "Status",
        geneticGroup: "Grupo Genético",
        description: "Descrição",
        name: "Raça",
        asymptoticWeight: "Peso Assintótico(kg)",
        estimatedMaximumAge: "Idade adulta",
        correctionFactor: "Fator de Correção",
        maturationRate: "Taxa de Maturação",
      },
      menu: {
        parameters: "Parâmetros",
      },
    },
    drawerTitle: "Cadastro de Raça",
    drawerTitleEdit: "Editar Raça",
    drawerSubTitle: "Complete os campos abaixo para criar uma nova raça",
    drawerSubTitleEdit: "Complete os campos abaixo para editar a raça",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      name: "Identificação da Raça",
      namePlaceHolder: "Nome da raça",
      description: "Descrição",
      descriptionPlaceHolder: "Descrição da raça",
      geneticGroup: "Grupo Genético",
      geneticGroupPlaceHolder: "Selecione o Grupo Genético",
      status: "Status do raça",
    },
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar raça e adicionar novo",
      save_and_add_parameters: "Criar raça e configurar paramêtros",
    },
    drawerParametersTitle: "Parâmetros da Raça",
    formParameters: {
      asymptoticWeight: "Peso assintótico",
      asymptoticWeightPlaceHolder: "Defina o peso",
      theoricalCurve: "Curva teórica",
      estimatedMaximumAge: "Idade Adulta",
      estimatedMaximumAgePlaceHolder: "Idade Adulta",
      correctionFactor: "Fator de Correção",
      correctionFactorPlaceHolder:
        "Fator de Correção para cálculo da curva da raça",
      maturationRate: "Taxa de Maturação",
      maturationRatePlaceHolder:
        "Taxa de maturação para cálculo da curva da raça",
      status: "Status dos parâmetros da raça",
      extimatedCurveTitle: "CURVA ESTIMADA DE CRESCIMENTO",
      genetic: "GENÉTICA",
      diet: "DIETA",
      gestationDivider: "Tempo de Gestação",
      minGestationTime: "Mínimo",
      medGestationTime: "Médio",
      maxGestationTime: "Máximo",
    },
  },
  handlingOperation: {
    title: "Operações",
    buttonNewPasture: "Nova operação",
    table: {
      title: "Lista de Operações",
      columns: {
        status: "Status",
        operation: "Operação",
        action: "Ação",
      },
    },
    drawerTitle: "Cadastro de Operação",
    drawerTitleEdit: "Editar Operação",
    drawerSubTitle: "Complete os campos abaixo para criar um nova operação",
    drawerSubTitleEdit: "Complete os campos abaixo para editar a operação",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      name: "Operação",
      namePlaceHolder: "Nome da operação",
      action: "Ação",
      actionPlaceHolder: "Selecione a ação do procedimento",
      recurrence: "Recorrência",
      recurrenceAmount: "Qtd.",
      quarantine: "Quarêntena",
      quarantineAmount: "Digite a quantidade de dias",
      breed: "Raça",
      breedPlaceHolder: "Selecione as raças",
      gender: "Sexo",
      genderPlaceHolder: "Selecione",
      age: "Idade",
      weight: "Peso",
      dontExecuteOperation: "Não executar operação em animais que estão em:",
      inQuarantine: "Quarentena",
      inPregnancy: "Prenhez",
      operationCost: "Custo da operação",
      noCost: "Sem custo",
      haveCost: "Com custo(defina o custo no manejo)",
      status: "Status do operação",
    },
    parameters: "PARÂMETROS",
    limitations: "LIMITAÇÕES",
    errors: {
      recurrenceMinAndMaxDayCanBeNull: {
        title: "Erro",
        message:
          "O número mínimo e máximo de dias da recorrência não pode estar em branco.",
      },
      recurrenceQtdCanBeNull: {
        title: "Erro",
        message:
          "A quantidade de vezes da recorrência não pode estar em branco.",
      },
    },
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar operação e adicionar nova",
    },
  },
  handling: {
    title: "Manejos",
    tabs: {
      pending: "Pendentes",
      finalized: "Finalizados",
      dietStrategies: "Estratégias de dieta",
      vacinations: "Veterinários",
      handlingReproduction: "Reprodução",
      animalWeightHistory: "Pesagens e Medições",
      picketSupplementSupply: "Fornecimento",
      troughFeedingAssessment: "Leitura de Cocho",
    },
    vacinations: {
      buttonNew: "Nova Aplicação",
      form: {
        titleEdit: "Editar Aplicação",
        titleCreateNew: "Nova Aplicação",
        dividerTitle: "APLICAÇÃO ANTERIOR",
        animalId: "Animal",
        lastDailyWeight: "Última pesagem",
        handlingNumber: "Animal",
        veterinarySupplementId: "Produto",
        veterinarySupplementApplicationType: "Forma de Aplicação",
        veterinarySupplementApplicationValue: "Dose",
        applicationQuantity: "Qtde Aplicada",
        applicationUnit: "Unidade",
        applicationDay: "Data Aplicação",
      },
      table: {
        title: "Veterinários",
        columns: {
          animalName: "Animal",
          veterinarySupplementName: "Nome",
          type: "Tipo",
          applicationDate: "Data",
          applicationQuantity: "Quantidade",
          applicationUnit: "Unidade",
          last_weight: "Última Pesagem",
          last_weight_date: "Data da Última Pesagem",
          last_comment: "Último Comentário",
          last_comment_date: "Data do Último Comentário",
        },
      },
    },
  },
  payments: {
    title: "Pagamentos",
    ui: {
      monthlyMovementTitle: "Acompanhe sua movimentação mensal",
      invoiceDescriptionTitle: "Descrição da fatura",
      valuePrefix: "Valor",
      viewBoleto: "Visualizar Boleto",
      sendByEmail: "Enviar por E-mail",
      secondCopy: "2º Via",
      paymentMethodTitle: "Como você prefere pagar?",
      newCreditCard: "Novo cartão de crédito",
      boleto: "Boleto",
      changeDueDateTitle: "Altere a data de vencimento",
      currentDueDatePrefix: "Atualmente sua fatura vence no",
      dueDatePlaceholder: "Informe aqui a data de vencimento",
      creditCardTitle: "Cartão de Crédito",
      cardHolderName: "Nome do titular/portador",
      cardNumber: "Número do Cartão",
      cardExpiryDate: "Data do vencimento",
      cardSecurityCode: "Código de segurança",
      periodFrom: "De",
      bovexoServices: "Serviços referente à BovExo",
      cardLastDigitsPrefix: "Final:",
      noInvoicesAvailable: "Não há faturas disponíveis para consulta",
    },
    messages: {
      holderNameRequired: "Nome do titular/portardor é obrigatório.",
      invalidCPF: "CPF inválido.",
      invalidCardNumber: "Número do Cartão inválido.",
      invalidExpirationDate: "Data do Vencimento inválida.",
      invalidSecurityCode: "Código de segurança inválido.",
      paymentMethodUpdated: "Forma de pagamento atualizada com sucesso",
      invalidCardData: "Dados do cartão inválidos",
      paymentMethodError:
        "Ocorreu um erro durante a atualização da forma de pagamento",
      dueDayUpdated: "Data de vencimento atualizada com sucesso",
      dueDayError: "Ocorreu um erro durante a atualização do dia de vencimento",
    },
  },
  parameters: {
    title: "Parâmetros",
    tabs: {
      general: "Gerais",
      breed: "Raças",
      diet: "Dietas",
      supplement: "Suplementos/Concent.",
      pasture: "Forrageira",
      alert: "Alertas",
      benchmark: "Benchmarks",
      marketAnalysis: "Curva de Preços",
      cost: "Custos",
      activity: "Atividades",
      boitelPrice: "Boitel - Diárias",
      integration: "Integrações",
      financial: "Financeiro/Custos",
      reproduction: "Reprodução",
      reproductionParameter: "Parâmetros",
      semen: "Sêmens",
      inseminators: "Inseminadores",
      supplie: "Insumos",
      animal: "Animais",
      deathReasons: "Causa Mortis",
      unit: "Unidades",
      veterinary: "Veterinários",
      commercialization: "Comercialização",
      quota: "Cotas",
      multipleBull: "Touro Múltiplo",
      reproductiveProtocol: "Protocolos",
      feedFactory: "Fábrica de Ração",
      handlingParameters: "Manejos",
      farmDayScaleTreatmentParameter: "Escala de Tratos",
      farmReadFeederTreatmentParameter: "Leitura de Cocho",
      wagonAutomation: "Misturador",
      ageRange: "Faixa Etária",
      handlingAlerts: "Alertas de Manejo",
      measurement: "Medições",
      stock: "Estoque",
      others: "Outros",
    },
  },
  boitelPrice: {
    title: "Boitel - Diárias",
    buttonNew: "Novo",
    table: {
      title: "Boitel - Diárias",
      columns: {
        name: "Nome",
        farmName: "Nome da Fazenda",
        validity: "Vigência",
        status: "Status",
      },
    },
  },
  integrationPartners: {
    table: {
      title: "Integrações",
      columns: {
        status: "Situação",
        system: "Sistema",
        authType: "Tipo Autenticação",
      },
    },
    authType: {
      Token: "Token",
      UserAndPassword: "Usuário e Senha",
      UserAndPasswordAndCompany: "Usuário, senha e empresa",
      ApiKey: "Chave de API",
    },
  },
  imports: {
    title: "Importações",
    tabs: {
      animal: "Animais",
      weight: "Pesagens e Medições",
      supplement: "Suplementos",
      financialTransactions: "Mov. Financeiras",
      animalCoverages: "Coberturas e DG's",
      suppliersClients: "Fornecedores/Clientes",
      animalBirths: "Partos e Perdas",
      vaccinations: "Veterinários",
      picketSupplementSupplyFeedReader: "Fornecimento/Leitura de Cocho",
    },
    status: {
      queue: "Aguardando",
      processing: "Processando",
      processed: "Processado",
      deleting: "Deletando",
      error: "Erro",
    },
    animal: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Animais",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberAlerted: "Alertas",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Animais",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            handlingNumber: "Identificação do Animal",
            message: "Motivo",
            alert: "Alertas",
          },
        },
      },
    },
    weight: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Pesagens e Medições",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Pesagens",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            weight: "Peso",
            handlingNumber: "Identificação do Animal",
            aol: "AOL",
            aol100Kg: "AOL/100Kg",
            ratio: "RATIO",
            marmoreio: "MARMOREIO",
            egs: "EGS",
            message: "Motivo",
          },
        },
      },
    },
    supplement: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Suplementos",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Suplementos",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            name: "Identificação do Suplemento",
            message: "Motivo",
          },
        },
      },
    },
    picketSupplementSupplyFeedReader: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Fornecimento e Leitura de Cocho",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseImported: "Importados",
        collapseNotImported: "Não Importados",
        records: "registros",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        types: {
          supply: "Fornecimento",
          feedReader: "Leitura de Cocho",
          supplyAndFeedReader: "Fornecimento e Leitura de Cocho",
        },
        table: {
          columns: {
            rowNumber: "Linha Excel",
            picket: "Piquete/Baia",
            date: "Data",
            type: "Tipo",
            message: "Motivo",
            alert: "Alertas",
          },
        },
      },
    },
    suppliersClients: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Fornecedores/Clientes",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Fornecedores/Clientes",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            name: "Nome do Fornecedor/Cliente",
            message: "Motivo",
          },
        },
      },
    },
    financialTransactions: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Mov. Financeiras",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Mov. Financeiras",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            name: "Identificação da Mov. Financeira",
            message: "Motivo",
          },
        },
      },
    },
    animalCoverages: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Coberturas e DG's",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Coberturas e DG’s",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            name: "Identificação da Cobertura",
            message: "Motivo",
          },
        },
      },
    },
    animalBirths: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Partos e Perdas",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          numberUpdated: "Atualizados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        collapseAnimals: "Partos e Perdas",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            handlingNumber: "Identificação do Animal",
            message: "Motivo",
            alert: "Alertas",
          },
        },
      },
    },
    vaccinations: {
      buttonImport: "Importar",
      table: {
        title: "Lista de Importações de Veterinários",
        columns: {
          status: "Status",
          fileName: "Arquivo",
          date: "Data",
          total: "Total",
          numberImported: "Importados",
          numberError: "Erros",
          numberDuplicated: "Duplicados",
          message: "Mensagem",
        },
      },
      details: {
        breadCumbsImportLog: "Importações",
        breadCumbsImportLogDetails: "Detalhes da Importação",
        imported: "Importados",
        notImported: "Não Importados",
        vaccinations: "veterinários",
        fileNameTitle: "Arquivo",
        statusTitle: "Status",
        dateTitle: "Data",
        table: {
          columns: {
            rowNumber: "Linha Excel",
            animalName: "Animal",
            veterinarySupplementName: "Vacina/Medicamento",
            applicationDate: "Data de Aplicação",
            applicationQuantity: "Quantidade",
            message: "Motivo",
            alert: "Alertas",
          },
        },
      },
    },
  },
  benchmark: {
    title: "Benchmarks",
    buttonNewBenchmark: "Novo benchmark",
    table: {
      title: "Lista de Benchmarks",
      columns: {
        status: "Status",
        description: "Benchmark",
      },
    },
    drawerTitle: "Cadastro de Benchmark",
    drawerTitleEdit: "Editar Benchmark",
    drawerSubTitle:
      "Complete os campos abaixo para cadastrar um novo benchmark",
    drawerSubTitleEdit: "Complete os campos abaixo para editar o benchmark",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      name: "Nome",
      namePlaceHolder: "Identificação",
      status: "Status do benchmark",
      groupFarmVisibility: "Quem irá visualizar o benchmark?",
      radiogroup: {
        farm: "Esta fazenda",
        group: "Fazendas do grupo",
      },
      harvestDivider: "SAFRAS",
    },
    errorAtLeastOneKPIValue:
      "Informar pelo menos um valor para qualquer Indicadores (KPIs)",
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar benchmark e adicionar novo",
    },
  },
  marketAnalysis: {
    title: "Curva de Preços",
    buttonNewMarketAnalysis: "Nova Curva de Preços",
    table: {
      title: "Lista de Curva de Preços",
      columns: {
        status: "Status",
        type: "Tipo",
        description: "Nome",
        baseline: "Padrão",
      },
    },
    type: {
      bovexo: "BovExo",
      progressive: "Progressivo",
      linear: "Linear",
      free: "Livre",
    },
  },
  feedFactoryParameters: {
    errorLoad: "Erro ao carregar os parâmetros da Fábrica de Ração.",
    errorSave: "Erro ao salvar os parâmetros da Fábrica de Ração.",
    successSave: "Parâmetros da Fábrica de Ração salvos com sucesso.",
    form: {
      useFullMixerCapacity: "Usar capacidade total do misturador",
      defaultWagon: "Misturador padrão",
      standardCostPerBatch: "Custo fixo por batida",
      perBatch: "/batida",
    },
  },
  feedFactory: {
    tabs: {
      rawMaterials: "Matérias Primas",
      supplements: "Receitas",
      productionOrders: "Ord. Produção",
      production: "Produção",
      feedingAutomation: "Automação de Tratos",
    },
    buttonNewRawMaterial: "Nova Matéria-Prima",
  },
  feedingAutomation: {
    emptyText:
      "Nenhuma fabricação recebida da automação de tratos no período selecionado.",
    filters: { period: "Período" },
    situation: {
      open: "Aberta",
      finished: "Concluída",
      cancelled: "Cancelada",
    },
    launchType: { automatic: "Automático", manual: "Manual" },
    stockStatus: {
      Pending: "Aguardando",
      Processing: "Em processamento",
      Applied: "No estoque",
      AppliedWithoutBalance: "Saldo negativo",
      Blocked: "Pendente",
      Reversed: "Estornada",
    },
    stockStatusHelp: {
      Pending:
        "A baixa dos ingredientes e a entrada da ração ainda não foram geradas.",
      Applied: "Os ingredientes já saíram do estoque e a ração já entrou.",
      AppliedWithoutBalance:
        "O consumo foi registrado, mas o estoque não tinha todo o ingrediente.",
      Blocked: "Não foi possível movimentar o estoque desta fabricação.",
      Reversed:
        "A fabricação foi cancelada e as movimentações foram estornadas.",
    },
    stockReason: {
      MANUFACTURE_WITHOUT_RECIPE:
        "A fabricação chegou sem receita. Confira o planejamento de fase enviado pelo parceiro.",
      RECIPE_NOT_FOUND:
        "A receita desta fabricação não foi encontrada nesta fazenda.",
      RECIPE_WITHOUT_STOCK_ITEM:
        "A receita {{name}} não tem item de estoque para receber a produção. Crie o item na edição da receita.",
      INGREDIENT_NOT_FOUND:
        "O ingrediente {{name}} não foi encontrado nesta fazenda.",
      INGREDIENT_WITHOUT_STOCK_ITEM:
        "O ingrediente {{name}} não tem item de estoque. Crie o item na edição da receita.",
      INGREDIENT_STOCK_ITEM_NOT_FOUND:
        "O item de estoque do ingrediente {{name}} não foi encontrado nesta fazenda.",
      STOCK_ITEM_WITHOUT_UNIT:
        "O item de estoque de {{name}} está sem unidade de medida.",
      INGREDIENT_WITHOUT_COST:
        "Não há custo para movimentar o ingrediente {{name}}. Lance uma entrada no estoque dele.",
      MANUFACTURE_WITHOUT_QUANTITY:
        "A fabricação chegou sem quantidade fabricada.",
      MANUFACTURE_WITHOUT_INGREDIENT:
        "A fabricação chegou sem ingrediente consumido.",
      MANUFACTURE_WITHOUT_DATE: "A fabricação chegou sem data.",
      MANUFACTURE_ALREADY_IN_STOCK:
        "Esta fabricação já tem movimentação de estoque gerada.",
      INSUFFICIENT_BALANCE:
        "O consumo da fabricação foi registrado normalmente, mas o estoque de {{name}} não tinha saldo suficiente e ficou negativo. Lance a entrada que está faltando para o saldo voltar a bater.",
      UNEXPECTED_ERROR:
        "Erro inesperado ao movimentar o estoque desta fabricação.",
    },
    flags: {
      leftover: "Sobra",
      substituted: "Substituído",
      changed: "Alterado",
      realized: "Realizado",
    },
    columns: {
      day: "Dia",
      manufactures: "Fabricações",
      manufactureDatetime: "Data e hora",
      time: "Hora",
      treatNumber: "Trato",
      supplementName: "Receita",
      wagonName: "Misturador",
      situation: "Situação",
      stockStatus: "Estoque",
      quantityPlanned: "Planejado (kg)",
      quantityManufactured: "Fabricado (kg)",
      quantityManufacturedDryMatter: "MS fabricada (kg)",
      deviationPercent: "Desvio",
    },
    details: {
      title: "Fabricação · Trato",
      manufactureDatetime: "Data e hora:",
      supplementName: "Receita:",
      wagonName: "Misturador:",
      quantityPlanned: "Planejado:",
      quantityManufactured: "Fabricado:",
      quantityManufacturedDryMatter: "MS fabricada:",
      deviationPercent: "Desvio:",
      launchType: "Lançamento:",
      externalImportCode: "Código externo:",
      stockStatus: "Estoque:",
      observation: "Observação:",
      noIngredients: "Nenhum ingrediente informado nesta fabricação.",
      columns: {
        ingredient: "Ingrediente",
        quantityPlanned: "Planejado (kg)",
        quantityRealized: "Realizado (kg)",
        deviationPercent: "Desvio",
        flags: "Marcadores",
      },
    },
    messages: {
      errorLoad: "Erro ao carregar as fabricações da automação de tratos.",
    },
  },
  production: {
    buttonPrint: "Imprimir ficha",
    loadingBatches: "Carregando as batidas...",
    noBatchesYet: "Nenhuma batida executada ainda.",
    missingStockAlert:
      "Estas ordens foram calculadas com falta de insumo: {{codes}}. Confira o estoque antes de produzir.",
    columns: {
      batches: "Batidas",
      plannedDryMatter: "Planejado (kg MS)",
      producedDryMatter: "Produzido (kg MS)",
      realizedTotalCost: "Custo realizado",
    },
    batchColumns: {
      number: "Batida",
      date: "Data",
      plannedOriginalMatter: "Planejado (MO)",
      produced: "Produzido (MO)",
      producedDryMatter: "Produzido (MS)",
      deviation: "Desvio (MO)",
    },
    ingredientColumns: {
      name: "Insumo",
      planned: "Planejado (kg MO)",
      realized: "Usado (kg MO)",
      deviation: "Desvio (MO)",
    },
    noIngredients: "Nenhum ingrediente registrado nesta batida.",
    menu: {
      executeBatch: "Executar batida",
      closePartial: "Encerrar parcial",
      print: "Imprimir ficha",
    },
    details: {
      title: "O.P.",
      date: "Data:",
      targetDryMatter: "MS Alvo:",
      batches: "Batidas:",
      totalCost: "Custo total:",
      costPerKg: "Custo/kgMS:",
      realizedCost: "Custo realizado:",
      batchLabel: "Batida",
      executed: "Executada",
      planned: "Planejada",
      columns: {
        sequence: "Seq.",
        batchNumber: "Lote",
        mixingTime: "Tempo",
        ingredient: "Insumo",
        plannedOriginalMatter: "MO Plan.",
        realizedOriginalMatter: "MO Real",
      },
    },
    batch: {
      title: "Executar",
      batchLabel: "Batida",
      order: "Ordem",
      recipe: "Receita",
      plannedPerBatch: "Planejado por batida",
      manufactureDate: "Data da produção",
      observation: "Observação",
      ingredients: "Insumos",
      totalUsed: "Total usado:",
      execute: "Executar",
      columns: {
        ingredient: "Insumo",
        batch: "Lote",
        planned: "Planejado (kg)",
        realized: "Usado (kg)",
        deviation: "Desvio",
      },
    },
    messages: {
      errorLoad: "Erro ao carregar as ordens de produção.",
      successExecute: "Batida executada com sucesso.",
      errorExecute: "Erro ao executar a batida.",
      confirmClosePartial: "Confirma o encerramento parcial desta ordem?",
      confirmClosePartialDetail: "As batidas pendentes não serão produzidas.",
      successClosePartial: "Ordem encerrada parcialmente.",
      errorClosePartial: "Erro ao encerrar a ordem parcialmente.",
      nothingToPrint:
        "Selecione ao menos uma ordem na lista para imprimir a ficha.",
      errorPrint: "Erro ao gerar a ficha de impressão.",
    },
  },
  productionOrder: {
    buttonNew: "Nova Ordem",
    table: {
      columns: {
        code: "Código",
        supplementName: "Receita",
        wagonName: "Misturador",
        targetDryMatterKg: "Alvo (kg MS)",
        plannedDryMatterKg: "Planejado (kg MS)",
        numberOfBatches: "Batidas",
        totalCost: "Custo total",
        costPerKgDryMatter: "Custo/kg MS",
        productionDate: "Data de produção",
        status: "Status",
      },
    },
    status: {
      Calculated: "Calculada",
      Scheduled: "Programada",
      InProgress: "Em processo",
      ClosedTotal: "Encerrada total",
      ClosedPartial: "Encerrada parcial",
      Cancelled: "Cancelada",
    },
    menu: {
      schedule: "Programar",
      cancel: "Cancelar ordem",
    },
    form: {
      titleCreateNew: "Nova Ordem de Produção",
      titleEdit: "Editar Ordem de Produção",
      titleDetails: "Ordem de Produção",
      supplement: "Receita",
      wagon: "Misturador",
      productionDate: "Data de produção",
      targetDryMatterKg: "Alvo (kg de MS)",
      useFullMixerCapacity: "Usar capacidade total do misturador",
      observations: "Observações",
      buttonCalculate: "Calcular batidas",
      resultTitle: "Resultado do cálculo",
      numberOfBatches: "Nº de batidas",
      dryMatterPerBatchKg: "Capacidade do misturador (MS)",
      originalMatterPerBatchKg: "Capacidade do misturador (MO)",
      plannedDryMatterKg: "MS planejada",
      plannedOriginalMatterKg: "MO total",
      inputCost: "Custo dos insumos",
      manufacturingCost: "Custo de fabricação",
      totalCost: "Custo total",
      costPerKgDryMatter: "Custo por kg de MS",
      itemsTitle: "Ingredientes",
      items: {
        supplementName: "Insumo",
        dryMatterPercentage: "Teor de MS (%)",
        plannedDryMatterKg: "kg de MS",
        plannedOriginalMatterKg: "kg de MO",
        batch: "Lote",
        availableQuantity: "Saldo",
        unitCost: "Custo unitário",
        totalCost: "Custo total",
      },
      noBatch: "Sem lote",
      expiresAt: "vence em",
      mustCalculate: "Calcule as batidas antes de salvar.",
    },
    warnings: {
      title: "Avisos",
      targetAdjusted:
        "O alvo foi ajustado de {{informed}} para {{adjusted}} kg de MS para completar todas as batidas do misturador.",
      missingStock:
        "Saldo insuficiente de {{name}}: a ordem precisa de {{required}} kg e há {{available}} kg em estoque. A ordem será criada normalmente.",
      partialBatch:
        "Cada batida fica com {{batch}} kg de MS, {{missing}} kg abaixo da capacidade do misturador. Para produzir com todas as batidas cheias, use {{suggested}} kg de MS.",
      missingCost:
        "{{name}} está sem custo cadastrado e sem entrada no estoque. O custo dele entrou como zero, e o custo total da ordem está subestimado.",
      expiredBatch:
        "O lote {{batch}} de {{name}} está vencido desde {{expiration}}.",
      acknowledge: "Estou ciente",
      acknowledged: "Ciente",
      pending:
        "Confirme a ciência de todos os avisos para salvar a ordem. Pendentes: {{count}}.",
    },
    errors: {
      NEGATIVE_COST:
        "O custo de {{name}} está negativo e não pode ser movimentado no estoque. Registre uma entrada com o custo correto antes de executar a batida.",
      RECIPE_NOT_FOUND: "Receita não encontrada nesta fazenda.",
      SUPPLEMENT_NOT_FORMULATED:
        "O item selecionado não é uma receita formulada.",
      RECIPE_INACTIVE: "A receita {{name}} está inativa.",
      RECIPE_WITHOUT_INGREDIENTS: "A receita {{name}} não tem ingredientes.",
      RECIPE_WITHOUT_DRY_MATTER:
        "A receita {{name}} não tem matéria seca para produzir.",
      WAGON_NOT_FOUND: "Misturador não encontrado nesta fazenda.",
      WAGON_INACTIVE: "O misturador {{name}} está inativo.",
      WAGON_WITHOUT_CAPACITY:
        "O misturador {{name}} não tem capacidade cadastrada. Informe a capacidade em Parâmetros de Manejo.",
      FEED_FACTORY_PARAMETERS_NOT_CONFIGURED:
        "Os parâmetros da Fábrica de Ração não estão preenchidos. Informe o custo fixo por batida em Parâmetros.",
      INGREDIENT_NOT_FOUND: "Um ingrediente da receita não foi encontrado.",
      INGREDIENT_WITHOUT_STOCK_ITEM:
        "O ingrediente {{name}} não tem item de estoque. Vincule um item de estoque a ele na guia Receitas ou no menu Estoque.",
      INGREDIENT_STOCK_ITEM_NOT_FOUND:
        "O item de estoque do ingrediente {{name}} não foi encontrado nesta fazenda.",
      INGREDIENT_WITHOUT_DRY_MATTER_PERCENTAGE:
        "O ingrediente {{name}} não tem o teor de matéria seca preenchido.",
      SUPPLEMENT_REQUIRED: "Informe a receita.",
      WAGON_REQUIRED: "Informe o misturador.",
      TARGET_DRY_MATTER_REQUIRED:
        "Informe o alvo em kg de matéria seca, maior que zero.",
      PRODUCTION_DATE_REQUIRED: "Informe a data de produção.",
      REQUEST_REQUIRED: "Não foi possível ler os dados da ordem.",
      ONLY_CALCULATED_CAN_BE_UPDATED:
        "Só é possível editar uma ordem com status Calculada.",
      ONLY_CALCULATED_CAN_BE_DELETED:
        "Só é possível excluir uma ordem com status Calculada.",
      ONLY_CALCULATED_CAN_BE_SCHEDULED:
        "Só é possível programar uma ordem com status Calculada.",
      ONLY_CALCULATED_OR_SCHEDULED_CAN_BE_CANCELLED:
        "Só é possível cancelar uma ordem com status Calculada ou Programada.",
    },
    readiness: {
      title: "Esta receita ainda não pode gerar ordem de produção",
      withoutStockItem:
        "Sem item de estoque: {{names}}. Vincule um item de estoque a cada um pelo menu Estoque.",
      withoutDryMatter:
        "Sem teor de matéria seca: {{names}}. Preencha o teor de MS no cadastro do suplemento.",
    },
    messages: {
      errorLoad: "Erro ao carregar as ordens de produção.",
      errorCalculate: "Erro ao calcular as batidas.",
      successSave: "Ordem de produção salva com sucesso.",
      errorSave: "Erro ao salvar a ordem de produção.",
      successSchedule: "Ordem de produção programada com sucesso.",
      errorSchedule: "Erro ao programar a ordem de produção.",
      successCancel: "Ordem de produção cancelada com sucesso.",
      errorCancel: "Erro ao cancelar a ordem de produção.",
      successDelete: "Ordem de produção excluída com sucesso.",
      errorDelete: "Erro ao excluir a ordem de produção.",
      confirmDelete: "Confirma a exclusão desta ordem de produção?",
      confirmSchedule: "Confirma a programação desta ordem de produção?",
      confirmCancel: "Confirma o cancelamento desta ordem de produção?",
      noRecipes:
        "Nenhuma receita disponível. Cadastre uma formulação na guia Receitas.",
    },
  },
  supplement: {
    title: "Suplementos/Concent.",
    buttonNewSupplement: "Novo Suplemento/Concent.",
    buttonNewSupplementFormulated: "Nova Formulação",
    table: {
      title: "Lista de Suplementos/Concent.",
      columns: {
        status: "Status",
        description: "Suplemento/Concent.",
        industrialName: "Nome Industrial",
        supplierName: "Fornecedor",
        createdAt: "Data de Criação",
        userName: "Responsável",
        version: "Versão",
        cp: "PB: Proteína Bruta",
        tdn: "NDT: Nutrientes Digest. Totais",
        npn: "NNP - Equivalente Proteico (Máx)",
        dryMatterPercentage: "MS: Matéria Seca",
        phosphorus: "Fósforo",
        nitrogen: "Nitrogênio",
        calcium: "Cálcio",
        zinc: "Zinco",
        sodium: "Sódio",
        additiveEffect: "Efeito Aditivo",
        fda: "FDA",
        lignin: "Lignina",
        ee: "Extrato Etéreo",
        supplementGroupName: "Grupo",
        supplementSubGroupName: "Sub-Grupo",
        supplementPresentationName: "Apresentação",
        potassium: "Potássio",
        sulfur: "Enxofre",
        fdn: "FDN",
        pdr: "PDR",
        pndr: "PNDR",
        em: "EM",
        fef: "FEF",
        fdnfe: "FDNfe",
      },
    },
    drawerTitle: "Cadastro de Suplemento/Concent.",
    drawerTitleEdit: "Editar Suplemento/Concent.",
    drawerSupplementFormulatedTitle: "Cadastro Formulação",
    drawerSupplementFormulatedTitleEdit: "Editar Formulação",
    drawerSubTitle:
      "Complete os campos abaixo para cadastrar um novo Suplemento/Concent.",
    drawerSubTitleEdit:
      "Complete os campos abaixo para editar o Suplemento/Concent.",
    drawerSupplementFormulatedSubTitle:
      "Complete os campos abaixo para cadastrar uma nova formulação",
    drawerSupplementFormulatedSubTitleEdit:
      "Complete os campos abaixo para editar a formulação",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      stockItemsDivider: "ITENS DE ESTOQUE",
      supplementType: "Ração/mistura ou Suplemento ?",
      supplementTypeHelp:
        "Ração/Mistura: Dieta pronta, produzida na própria fazenda. Suplementos: Produto adquirido e fornecido de forma pura.",
      supplementClassification: "Qual a classificação do Suplemento/Ração ?",
      supplementClassificationHelp: {
        title_0: "Suplemento Mineral",
        description_0:
          " quando possuir na sua composição, macro e/ou micro elemento mineral, podendo apresentar, no produto final, um valor menor que quarenta e dois porcento de equivalente protéico.",
        title_1: "Suplemento Mineral Protéico",
        description_1:
          " quando possuir na sua composição, macro e/ou micro elemento mineral, pelo menos 20% de proteína bruta (PB) e fornecer, no mínimo, 30 gramas de proteína bruta (PB) por 100 Kg de PV.",
        title_2: "Suplemento Mineral Protéico Energético",
        description_2:
          " quando possuir na sua composição, macro e/ou micro elemento mineral, pelo menos 20% de proteína bruta, fornecer, no mínimo, 30 gramas de proteína bruta e 100 gramas de nutrientes digestíveis totais (NDT) por 100 Kg de PV.",
        source: "*Conforme Mapa - IN12 de 30 de novembro de 2004.",
      },
      originalSupplement: "Matéria/Suplemento Original",
      name: "Nome genérico",
      namePlaceHolder: "Identificação",
      importCode: "Código de importação",
      mixingTime: "Tempo de Mistura",
      mixingTimeHelp:
        "Tempo total de mistura, em minutos: é a soma dos tempos informados nos ingredientes da receita.",
      stabilityRange: "Faixa de Estabilidade",
      stabilityRangeHelp:
        "Informe a Faixa de Estabilidade da Matéria-Prima para início da contagem para seguir para o próximo ingrediente no misturador.",
      stabilityTime: "Tempo de Estabilidade",
      stabilityTimeHelp:
        "Informe o Tempo de Estabilidade da Matéria-Prima após a adição, em minutos.",
      inclusionOrder: "Sequência de Mistura",
      itemMixingTime: "Tempo de mistura (min)",
      createStockItem: "Criar item de estoque",
      createStockItemHelp:
        "Crie um item de estoque quando o produto da receita for armazenado. Receita servida direto no cocho não precisa de item de estoque novo.",
      stockItem: "Item de estoque",
      stockItemEditHelp:
        "O item de estoque vinculado à receita não é editado aqui. Para alterá-lo, use o menu Estoque.",
      stockItemGroupRecipeHelp:
        "Esta receita é compartilhada por todas as fazendas do grupo. Os itens de estoque são por fazenda, por isso nem o item da receita nem os dos ingredientes podem ser criados ou vinculados a partir dela.",
      rationStockItemTitle: "Item de estoque da ração",
      rationStockItemHelp:
        "Produto final desta receita. Necessário quando a ração é armazenada antes de ir ao cocho.",
      ingredientsStockItemsTitle: "Itens de estoque dos ingredientes",
      ingredientsStockItemsHelp:
        "Matérias-primas da receita, consumidas do estoque a cada batida.",
      stockItemInternalId: "Identificação",
      stockItemAbbreviation: "Abreviação",
      stockItemUnit: "Unidade de medida",
      ingredient: "Ingrediente",
      stockItemGroupItem: "Grupo",
      stockItemItemGroup: "Subgrupo",
      baseAmount: "A cada",
      observations: "Observações",
      observationsPlaceHolder: "Observações da receita",
      industrialName: "Nome Industrial",
      industrialNamePlaceHolder: "Nome industrial",
      supplierName: "Fornecedor",
      supplierNamePlaceHolder: "Nome do fornecedor",
      status: "Status do Suplemento/Concent.",
      nutritionalDataDivider: "DADOS NUTRICIONAIS",
      capacityDivider: "QUANTIDADES POR MODO DE OFERTA",
      sustenanceCapacity: "QUANTIDADES POR MODO DE OFERTA",
      restrictionsDivider: "RESTRIÇÕES",
      restrictions: "RESTRIÇÕES",
      information: 'Todas as informações são referentes a "Animal/dia"',
      sustenanceCapacityDrawerTitle:
        "Quantidades por Modo de Oferta do Suplemento/Concent.",
      minimumAmount: "Qtd Mín",
      maximumAmount: "Qtd Máx",
      minimum: "Mínimo",
      maximum: "Máximo",
      ratio: "Proporção",
      cost: "Custo",
      costPlaceHolder: "Medida: R$",
      cp: "PB: Proteína Bruta",
      cpPlaceHolder: "Medida: g/kg",
      tdn: "NDT: Nutrientes Digest. Totais",
      tdnPlaceHolder: "Medida: g/kg",
      npn: "NNP - Equivalente Proteico (Máx)",
      npnPlaceHolder: "Medida: g/kg",
      dryMatterPercentage: "MS: Matéria Seca",
      phosphorus: "Fósforo",
      phosphorusPlaceHolder: "Medida: g/kg",
      nitrogen: "Nitrogênio",
      nitrogenPlaceHolder: "Medida: mg/kg",
      calcium: "Cálcio",
      calciumPlaceHolder: "Medida: g/kg",
      zinc: "Zinco",
      zincPlaceHolder: "Medida: mg/kg",
      sodium: "Sódio",
      sodiumPlaceHolder: "Medida: g/kg",
      potassium: "Potássio",
      sulfur: "Enxofre",
      voluntaryConsumption: "Consumo Voluntário",
      minimumVoluntaryConsumptionPlaceHolder: "Informe",
      maximumVoluntaryConsumptionPlaceHolder: "Informe",
      pure: "Oferta Puro",
      mix: "Oferta Mistura",
      recommendedTrough: "Cocho Recomendado",
      recommendedTroughPlaceHolder: "Informe",
      groupFarmVisibility: "Quem irá utilizar o Suplemento/Concent.?",
      radiogroup: {
        farm: "Esta fazenda",
        group: "Fazendas do grupo",
      },
      additiveEffect: "Efeito Aditivo",
      additiveEffectPlaceHolder: "Medida: g/dia",
      additiveEffectHelp:
        "Alguns suplementos minerais possuem aditivos em sua formulação que potencializam o ganho de peso dos animais, podendo o fornecedor indicar um ganho incremental (g/dia), somando ao ganho previsto calculado (Pasto + Suplemento) ou indicar por um aumento % do total de Proteína Bruta (PB) a ser considerado no calculo.",
      fda: "FDA",
      fdaPlaceHolder: "Medida: g/kg",
      lignin: "Lignina",
      ligninPlaceHolder: "Medida: g/kg",
      ee: "Extrato Etéreo",
      eePlaceHolder: "Medida: %/MS",
      supplementGroupId: "Grupo",
      supplementSubGroupId: "Sub-Grupo",
      supplementPresentationId: "Apresentação",
      nitrogenPercentage: "Nitrogênio",
      calciumPercentage: "Ca", // Ca %
      phosphorusPercentage: "P", // P %
      zincPercentage: "Zn", // Zn %
      potassiumPercentage: "K", // K %
      sodiumPercentage: "Na", // Na %
      sulfurPercentage: "S", // S % (Enxofre)
      fdn: "FDN", // FDN
      pdr: "PDR(%PB)", // PDR/%PB
      pndr: "PNDR(%PB)", // PNDR/%PB
      em: "EM(Mcal/kg)", // EM (Mcal/kg)
      fef: "FEF", // FEF %
      fdnfe: "FDNfe", // FDNfe %
    },
    formFarmRestrictions: {
      title: "Restrições",
      reproductiveStatusList: "Status Reprodutivos",
      minSupplementOfferedPerDay: "Oferta Mínima (/dia)",
      maxSupplementOfferedPerDay: "Oferta Máxima (/dia)",
      maxDays: "Dias Máximos",
      age: "Idade(meses)",
      liveWeight: "PV(kg)",
      minimum: "Min.",
      maximum: "Max.",
      male: "Machos",
      female: "Fêmeas",
      calf: "Bezerros",
      heifer: "Novilhas",
      reproductiveStatusOptions: {
        castrated_male: "Machos Castrados", // macho castrado
        pregnant_female: "Fêmeas Gestando", // femea gestando
        anestrous_female: "Fêmeas Anestro", // femea anestro
        lactating_female: "Fêmeas Lactante", // femea lactante
        lactating_calf: "Bez/Nov Lactante", // bez/nov lactante
        supplemented_animals: "Animais Suplementados", // animais suplementados
        breeding_males: "Machos Reprodutores", // machos reprodutores
        dairy_cows: "Vacas Leiteiras", // vacas leiteiras
        animals_on_pasture: "Animais a Pasto", // animais a pasto
      },
    },
    confirmClearNutritionalData:
      "Você está deselecionando a Matéria/Suplemento Original, deseja limpar os dados referentes?",
    errorVoluntaryConsumptionMaximumLessThanMinimum:
      "O consumo recomendado pelo fornecedor máximo deve ser maior ou igual ao consumo mínimo",
    errorPureMaximumLessThanMinimum:
      "A Oferta Puro máxima deve ser maior ou igual a Oferta Pura mínima",
    errorPureMaximumTroughLessThanMinimumTrough:
      "O valor máximo de Cocho recomendado para Oferta Puro deve ser maior ou igual ao valor mínimo",
    errorMixMaximumLessThanMinimum:
      "A Oferta Mistura máxima deve ser maior ou igual a Oferta Mistura mínima",
    errorMixMaximumTroughLessThanMinimumTrough:
      "O valor máximo de Cocho recomendado para Oferta Mistura deve ser maior ou igual ao valor mínimo",
    errorNecessarySustenanceCapacity:
      "É necessário informar os dados de quantidades por modo de oferta.",
    errorWrongNpnInput:
      "Atenção! São classificados como Suplementos Minerais, somente produtos com até 42,0 % de NNP - Equivalente Proteico. Por favor, verifique a Classificação deste Suplemento.",
    errorNecessaryFormulatedItems:
      "É necessário informar ao menos uma matéria prima.",
    errorFormulatedItemWithoutRawMaterial:
      "É necessário informar a matéria prima",
    errorFormulatedItemWithoutAmount:
      "É necessário informar a quantidade da matéria prima",
    errorFormulatedItemTotalAmount:
      "A soma das matérias primas em % deve ser exatamente 100%. Soma atual:",
    ingredientWithoutName: "ingrediente sem nome",
    errorIngredientStockItemWithoutGroup:
      "Informe o Grupo e o Subgrupo do item de estoque destes ingredientes: {{names}}.",
    ingredientStockItemsBlockTitle:
      "Alguns ingredientes ainda não têm item de estoque",
    ingredientStockItemsBlockHelp:
      "Ao salvar, o item de estoque destes ingredientes será criado: {{names}}. Informe o Grupo e o Subgrupo de cada um.",
    ingredientStockItemsWillBeCreated:
      "Serão criados {{count}} itens de estoque para os ingredientes:",
    ingredientsWillUseFarmCopy:
      "Estes ingredientes passarão a usar o cadastro da própria fazenda:",
    errorStockItemNotSelected:
      "É necessário selecionar um item de estoque para a receita",
    errorStockItemWithoutInternalId:
      "É necessário informar a identificação do item de estoque",
    errorStockItemWithoutUnit:
      "É necessário informar a unidade de medida do item de estoque",
    errorStockItemWithoutGroup:
      "É necessário informar o grupo e o subgrupo do item de estoque",
    errorFormulatedItemWithItself:
      "A receita não pode ser matéria prima dela mesma",
    errorFormulatedItemWithoutAddedAmount:
      "É necessário informar a quantidade em kg de matéria seca da matéria prima adicionada",
    errorFormulatedItemWithoutBaseAmount:
      "É necessário informar a cada quantos kg de matéria seca da mistura a matéria prima é adicionada",
    errorFormulatedItemWithoutPercentItems:
      "A receita precisa de ao menos uma matéria prima em % para formar a mistura",
    errorFormulatedItemAddedInclusionOrder:
      "A matéria prima adicionada por kg a cada X kg deve ter sequência de mistura posterior às matérias primas em %",
    errorFormulatedItemWithoutOriginalMatterAmount:
      "É necessário informar a quantidade de matéria original.",
    errorFormulatedItemWithDuplicate:
      "É necessário informar a matéria prima apenas uma vez",
    errorVoluntaryConsumptionType:
      "O tipo de consumo voluntário deve ser igual ao campo de Oferta nas restrições",
    successInactivate: "O suplemento foi inativado com sucesso",
    errorInactivate: "O suplemento não foi inativado. Contate o suporte.",
    successActivate: "O suplemento foi ativado com sucesso",
    errorActivate: "O suplemento não foi ativado. Contate o suporte.",
    successSaveFormulated: "Formulação salva com sucesso",
    errorSaveFormulated: "Erro ao salvar a formulação",
    errorSaveFormulatedNutrientsMismatch:
      "Os valores nutricionais da formulação não conferem com as matérias-primas. Alguma matéria-prima pode ter sido alterada: feche, abra a formulação novamente e salve.",
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar Suplemento/Concent. e adicionar novo",
    },
    details: {
      tabs: {
        supplementData: "Suplemento",
        supplementHistory: "Histórico",
      },
      supplementType: "Tipo",
      supplementClassification: "Classificação",
      name: "Nome genérico",
      industrialName: "Nome Industrial",
      supplierName: "Fornecedor",
      ratio: "Proporção",
      cost: "Custo",
      nutritionalDataDivider: "DADOS NUTRICIONAIS",
      tdn: "NDT: Nutrientes Digest. Totais",
      cp: "PB: Proteína Bruta",
      dryMatterPercentage: "MS: Matéria Seca",
      calcium: "Cálcio",
      phosphorus: "Fósforo",
      nitrogen: "Nitrogênio",
      zinc: "Zinco",
      sodium: "Sódio",
      voluntaryConsumption: "Consumo Voluntário",
      pure: "Oferta Puro",
      mix: "Oferta Mistura",
      recommendedTrough: "Cocho Recomendado",
      minimum: "Mínimo",
      maximum: "Máximo",
      information: 'Todas as informações são referentes a "Animal/dia"',
      capacityDivider: "QUANTIDADES POR MODO DE OFERTA",
      sustenanceCapacity: "QUANTIDADES POR MODO DE OFERTA",
      sustenanceCapacityDrawerTitle:
        "Quantidades por Modo de Oferta do Suplemento/Concent.",
      npn: "NNP - Equivalente Proteico (Máx)",
      additiveEffect: "Efeito Aditivo",
      fda: "FDA",
      lignin: "Lignina",
      ee: "Extrato Etéreo",
      supplementGroupId: "Grupo",
      supplementSubGroupId: "Sub-Grupo",
      supplementPresentationId: "Apresentação",
      fdn: "FDN", // FDN
      pdr: "PDR(%PB)", // PDR/%PB
      pndr: "PNDR(%PB)", // PNDR/%PB
      em: "EM(Mcal/kg)", // EM (Mcal/kg)
      fef: "FEF", // FEF %
      fdnfe: "FDNfe", // FDNfe %
      potassium: "Potássio",
      sulfur: "Enxofre",
    },
  },
  lot: {
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    tabs: {
      production: "Produção",
      movementHistory: "Histórico Mov.",
      receipt: "Recebimento",
    },
    production: {
      title: "Lotes de produção",
      buttonNewLot: "Novo lote de produção",
      details: {
        breadCumbsProductionLot: "Lotes em produção",
        breadCumbsLotDetails: "Detalhes do lote ",
        createdAt: "Criação:",
        options: "Opções",
        labelSystem: "ATIVIDADE",
        labelDietStrategy: "ESTRATÉGIA DE DIETA",
        baseline: "Baseline",
        optionalStrategies: "Estratégias opcionais",
        optional: "Opcionais",
        labelAnimals: "ANIMAIS",
        labelAsymptoticWeight: "PESO ASSINTÓTICO",
        labelMarketValuation: "AVALIAÇÃO DE MERCADO",
        labelProductionCost: "Custo de Produção",
        makeValuation: "Fazer avaliação",
        labelWeights: "PESAGENS",
        labelAverageWeight: "PESO MÉDIO:",
        labelAverageWeightGain: "GMD:",
        labelPicket: "PIQUETE / BAIA:",
        labelProductionArea: "ÁREA UTIL:",
        labelTotalArea: "ÁREA TOTAL:",
        labelSupportCapacity: "C. DE SUPORTE:",
        titleAnimals: "Animais",
        titleWeigth: "Peso",
        viewBy: "Visualizar por:",
        tooltipEstimatedCurve:
          'Curva teórica obtida de RAÇA, clique em "Estimar para lote" para definir os valores do Lote',
        rankBy: "Ranquear por:",
        supplementSupply: {
          title: "Fornecimento de Suplemento",
          refreshData: "Atualizar dados",
          hidePanels: "Ocultar painéis",
          showPanels: "Exibir painéis",
          dashboards: {
            perDiet: "Por Dieta",
            totalCost: "Custo total apropriado",
            averageConsumeMO: "Consumo Médio MO",
            averageConsumeMS: "Consumo Médio MS",
            animalCostPerDay: "Custo apropriado",
            totalAnimalCost: "Custo total",
            suffixCabDay: "Cab/dia",
            suffixCab: "Cab",
            columns: {
              diet: "Dieta",
              days: "Dias",
              amountSupplied: "Qtd. Ofertada (kg)",
              cost: "Custo",
            },
          },
          table: {
            columns: {
              date: "Data",
              treatNumber: "N° Trato",
              picketName: "Piquete/Baia",
              supplementName: "Dieta",
              amountAnimals: "Qtde Cab.",
              totalSupplyCost: "Custo",
              treatQuantitySupplied: "Qtde Ofertada (Kg) MO",
              totalSupplementSuppliedInKilosPerAnimal: "Cons. MO/Cab",
              dryMatterPercentage: "%MS",
              totalSupplementSuppliedInDryMatter: "Qtde Ofertada (Kg) MS",
              totalSupplementSuppliedInDryMatterPerAnimal: "Cons. MS/Cab",
            },
          },
        },
      },
      table: {
        columns: {
          lotNumber: "Nº Lote",
          lotName: "Lote",
          salesScenario: "Cenário de Venda",
          dietStrategyName: "Estratégia de Dieta",
          profitCenter: "Atividade",
          createdAtAndEndAt: "Criação / Encerramento",
          status: "Status",
          amount: "Qtd.",
          gdp: "GDP",
          gmd: "GMD",
          diet: "Dieta",
          averageWeight: "Peso médio",
          target: "Alvo",
          picketName: "Piquete/Baia",
        },
      },
      drawer: {
        title: "Criar lote de produção",
        titleEdit: "Editar lote de produção",
        subtitle: "Complete os campos abaixo para criar um lote",
        subtitleEdit: "Complete os campos abaixo para editar um lote",
        form: {
          status: "Status",
          name: "Nome do lote*",
          namePlaceHolder: "Nome do lote",
          identification: "Código de Importação",
          identificationPlaceHolder: "Código de Importação",
          profitCenter: "Atividade*",
          profitCenterPlaceHolder: "Selecione o Atividade",
          asymptoticWeight: "Peso Assintótico",
          carcassHarnessing: "Aproveitamento de Carcaça",
          informPlaceHolder: "Informe",
          picket: "Piquete / Baia",
          picketMessage:
            "Selecione o piquete / baia se deseja já alocar esse lote",
          picketPlaceHolder: "Selecione o piquete / baia",
          projectionWeightType: "Tipo de projeção de peso",
          projectionWeightTypeDietStrategy: "Estratégia de dieta",
          projectionWeightTypeFarmProjection: "Projeção de ganho de peso",
          weightGainProjection: "Projeção de ganho de peso",
          weightGainProjectionPlaceholder: "Selecione a projeção",
          startWeightGainProjectionDate:
            "Data de início da projeção de ganho de peso",
          dietStrategyBaseLine: "Estratégia de dieta",
          dietStrategyBaseLineMessage:
            "Selecione a estratégia que será utilizada para alimentação dos animais adicionados a este lote",
          dietStrategies: "Estratégia de Dieta - Opcionais",
          dietStrategiesPlaceHolder:
            "Selecione um ou mais estratégias de dieta",
          dietStrategiesTooltip:
            "As estratégias de dieta opcionais selecionadas serão utilizadas futuramente nas simulações de Cenários de compra e venda",
          checkboxSaveAndAddNewAnimals: "Salvar e adicionar animais",
          picketId: "Piquete",
          picketLotEntry: "Data de entrada do Lote",
          breedId: "Raça",
          referenceAcquisitionDate: "Data de aquisição",
          referenceBirthdayDate: "Nascimento animal",
          dismembermentDate: "Data de desmembramento",
          referenceAcquisitionWeight: "Peso médio por animal",
        },
        warningPendingTitle: "Lote pendente",
        warningPendingDescription: "O lote está pendente de aprovação",
        gmdCurve: {
          buttonOpen: "Curva GMD",
          title: "Curva de Crescimento GMD",
          subtitle: "Defina o tipo de ganho médio diário para este lote",
          dividerTitle: "CURVA GMD",
          dividerChart: "GRÁFICO DA CURVA",
          form: {
            startGainWeightDate: "Data de início do ganho de peso",
            startGainWeightDatePlaceholder: "Selecione a data",
            informType: "Tipo de informação",
            informTypePeriod: "Por período",
            informTypeFixed: "Fixo",
            timeUnitReference: "Unidade de tempo",
            timeUnitReferenceDay: "Dia",
            timeUnitReferenceWeek: "Semana",
            fixedGmdWeight: "GMD fixo (kg/dia)",
            fixedGmdWeightPlaceholder: "0,000",
            period: "Período",
            periodPlaceholderDay: "Nº do dia",
            periodPlaceholderWeek: "Nº da semana",
            gmdWeight: "GMD (kg/dia)",
            gmdWeightPlaceholder: "0,000",
            buttonAddPeriod: "Adicionar período",
            buttonDeletePeriod: "Remover",
            buttonConfirm: "Confirmar",
          },
          table: {
            columnPeriod: "Período",
            columnGmdWeight: "GMD (kg/dia)",
            columnActions: "Ações",
          },
          chart: {
            titleX: "Período",
            titleY: "GMD (kg/dia)",
            seriesName: "Curva GMD",
          },
          validation: {
            periodMustBeIncreasing:
              "O período deve ser maior que o período anterior",
            gmdWeightMustBePositive: "O GMD deve ser maior que zero",
            atLeastOnePeriod: "Adicione ao menos um período",
          },
        },
      },
      saveOptions: {
        only_save: "Salvar somente",
        save_and_create_new: "Salvar e adicionar novo Lote",
      },
      addAnimalsPage: {
        listLotProduction: "Lista: Lotes de produção",
        title: "Adicionar animal ao lote",
        descriptionMessage:
          "Selecione os animais na coluna cinza e mova-os para a coluna laranja clicando no botão",
        selectPlaceHolder:
          "Selecione a raça de animais que devem compor o lote",
        listAnimals: "Lista de animais",
        productionLot: "Lote de produção",
        modal: {
          message: "Clique em confirmar para adicionar os animais ao lote",
          lot: "Lote",
          profitCenter: "Atividade",
          amount: "Quantidade",
        },
        error: {
          noAnimalsTitle: "Erro",
          noAnimalsMessage: "É necessário selecionar um ou mais animais",
        },
      },
      dismemberLotPage: {
        listLotProduction: "Lista: Lotes de produção",
        title: "Desmembrar Lote",
        descriptionMessage:
          "Selecione os animais na tabela e clique no botão 'Desmembrar' para realocar os animais",
        profitCenter: "Atividade",
        productionSubSystem: "Subsistema de produção",
        animalsTotal: "Total de Animais",
        animalsSelected: "Animais selecionados",
        dismemberButton: "Desmembrar",
        destinationLots: "Lotes de destino",
        drawer: {
          title: "Desmembrar Lote",
          description:
            "Selecione abaixo se o desmembramento será em um novo lote ou um lote existente",
          newButton: "Novo",
          existingButton: "Existente",
          alertMessage: "A atividade do lote informado difere do lote atual",
          searchInputPlaceHolder: "Pesquise pela identificação de lote",
        },
      },
      tabs: {
        calf: "Reprodução",
        rearingFattening: "Recria/Engorda",
      },
    },
    receipt: {
      title: "Lotes de recebimento",
      buttonNewLot: "Novo",
      collapse: {
        animals: "Animais",
        receiptIn: "Recebidos em",
      },
      table: {
        columns: {
          breed: "Raça",
          gender: "Sexo",
          birthday: "Idade/meses",
          weight: "Peso estimado",
          amount: "Qtd. animais",
          confirmedAmount: "Qtd. animais recebidos",
          purchaseCost: "Custo de aquisição",
          numbers: "Numeração",
        },
        boitelColumns: {
          identification: "Identificação",
          amount: "Qtd. animais",
          breed: "Raça",
          entryDate: "Data de entrada",
          weightRange: "Faixa de peso",
          confirmedAmount: "Qtd. animais recebidos",
          identifiedAmount: "Qtd. animais identificados",
          status: "Situação",
        },
        status: {
          confirmed: "Confirmado",
          pending: "Pendente",
        },
      },
      finalize: {
        title: "Criação de lotes de recebimento",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        buttonFinalize: "FINALIZAR RECEBIMENTO",
        buttonFinalizeCancel: "CANCELAR RECEBIMENTO",
        supplier: "Fornecedor",
        dateReceiving: "Data de recebimento",
        animalsReceived: "Animais recebidos",
        grid: {
          title: "Lote de recebimento",
          animalsInserted: "animais inseridos",
          buttonAddAnimals: "Adicionar animais",
          columns: {
            breed: "Raça",
            gender: "Sexo",
            birthday: "Idade/meses",
            weight: "Peso estimado",
            amount: "Qtd.",
            purchaseCost: "Custo de aquisição",
            numbers: "Numeração",
          },
          deleteBox: {
            description: "Ao confirmar o lote será excluído",
            buttonConfirm: "Confirmar",
            buttonCancel: "Cancelar",
          },
        },
        newLotAnimalsReceipt: {
          title: "Novos animais",
          description: "Preencha os dados do recebimento de animais",
          saveOptions: {
            only_save: "Salvar somente",
            save_and_create_new: "Salvar e criar novo recebimento",
            save_and_handle: "Salvar e fazer manejo",
          },
        },
        newLotItem: {
          title: "Agrupamento de animais",
          description:
            "Agrupe os animais em recebimento de acordo com suas características completando as informações abaixo",
          tabGeneralTitle: "Geral",
          tabNumbersTitle: "Numeração",
          breed: "Raça",
          gender: "Sexo",
          birthday: "Nascimento",
          birthdayPlaceHolder: "Selecionar",
          estimatedWeight: "Peso Estimado",
          estimatedWeightPlaceHolder: "Digite o peso - Kg",
          amount: "Quantidade",
          amoutPlaceHolder: "Digite a quantidade",
          purchaseCost: "Custo de aquisição",
          purchaseCostPlaceHolder: "Digite o custo de aquisição",
          usePrefixedIdentification: "Usar identificação com prefixo",
          animalCost: "Custo animal",
          animalCostPlaceHolder: "Digite o custo do animal",
          shippingCost: "Frete",
          shippingCostPlaceHolder: "Digite o valor do frete",
          commissionAuctionCost: "Comissão Leilão",
          commissionAuctionCostPlaceHolder: "Digite o valor da comissão",
          fees: "Outras Taxas",
          feesPlaceHolder: "Digite o valor das outras taxas",
          totalAnimalCost: "Custo Total Animal",
          totalAnimalCostPlaceHolder: "Custo total calculado automaticamente",
          initialIdentificationSequence: "Sequência inicial de identificação",
          initialIdentificationSequencePlaceHolder:
            "Digite a sequência inicial",
          initialIdentificationSequenceExample:
            "Exemplo: Se inserir 'ABC123', os animais serão identificados como ABC124, ABC125, ABC126...",
          rangeDescription:
            "Adicione o número dos animais que possuem as características",
          range: "Intervalos",
          numbersInserted: "Números inseridos",
          animalFarmFunction: "Finalidade",
          animalReproductionCategory: "Categoria",
          saveOptions: {
            only_save: "Salvar somente",
            create_new: "Salvar e criar nova entrada de animais",
          },
        },
        errors: {
          noAnimalsAdd: {
            title: "Nenhum animal adicionado",
            description:
              "É necessário adicionar a quantidade informada de animais",
          },
          amountAnimalsInLotItenBiggerThanAmountAnimalsReceveid: {
            title: "Quantidade de animais maior",
            description:
              "A quantidade de animais inserida é maior do que a informada no lote de recebimento",
          },
          amountAnimalsInLotItenLessThanAmountAnimalsReceveid: {
            title: "Quantidade de animais menor",
            description:
              "A quantidade de animais inserida é menor do que a informada no lote de recebimento",
          },
          amountAnimalsInLotItenBiggerThanAmountReported: {
            title: "Quantidade de animais inválida",
            description:
              "A quantidade de animais inserida é maior do que a informada na quantidade do lote",
          },
        },
      },
      supplier: {
        title: "Entrada de Animais - Compra",
        buttonNext: "Próximo",
        buttonBack: "Voltar",
        titleBox: "Cadastro de Recebimento",
        messageError: "Preencha todos os campos obrigatórios *",
        supplierTitle: "Fornecedor",
        supplierComboBoxPlaceHolder: "Selecionar",
        lotName: "Nome do Lote",
        lotNameInputPlaceHolder: "Nome do Lote de recebimento",
        dateTitle: "Data de entrada",
        datePlaceHolder: "Selecionar",
        shouldCreateLotEntry: "Lançar e criar animais?",
        buttonToday: "HOJE",
        qtyAnimalsTitle: "Quantidade de animais",
        qtyAnimalsInputPlaceHolder: "Quantidade de animais",
        receiptNameTitle: "Número de Recebimento",
        supplierInformationsTitle: "Dados do Fornecedor",
        documentTitle: "CNPJ",
        responsibleTitle: "Responsável",
        emailTitle: "E-mail",
        contactTitle: "Contato",
        addressTitle: "Endereço",
      },
      messages: {
        successDeleteMessage: "Lote de recebimento excluído com sucesso",
        errorDeleteMessage:
          "Erro ao excluir o lote de recebimento. Contate o suporte.",
      },
    },
  },
  picket: {
    status: {
      break: "Descanso",
      pasturage: "Pastejo",
      renovation: "Reforma",
      maintenance: "Manutenção",
      leased: "Arrendado",
      deleted: "Excluído",
      active: "Ativo",
      inactive: "Inativo",
    },
    dashboards: {},
    propertyType: {
      own: "Próprio",
      foreign: "Arrendado",
    },
    tabs: {
      picket: "Piquete/Baia",
      retreat: "Retiro/Linha",
      map: "Mapa",
    },
    title: "Lista de piquetes / baias",
    buttonNewPicket: "Novo piquete / baia",
    table: {
      columns: {
        picketName: "Piquete / Baia",
        totalAndProductionArea: "Área total/útil",
        propertyType: "Tipo",
        profitCenterName: "Atividade",
        lotName: "Lote",
        status: "Status",
        // inAndOutLot: "Entrada/Saída de lote",
        inAndOutLot: "Entrada de lote",
        supportCapacity: "Capac. suporte",
        averageWeight: "Peso médio",
        gmd: "GMD",
        amountAnimals: "Qtd.",
      },
    },
    pastureTable: {
      title: "Estados dos Pastos",
      titleTooltip:
        "O Gráfico Estado dos Pastos, apresenta diferentes visões para que possa acompanhar e planejar as movimentações de animais entre piquetes, de forma a otimizar o uso das pastagens." +
        " - Estoque MS: Apresenta a disponibilidade (%) de MS da forrageira utilizada, conforme a estação climática e consumo dos animais presentes no Piquete. Diariamente é executado a rotina de recalculo, para atualizar a estimativa de disponibilidade dos próximos 30 dias." +
        " - Taxa de Oferta: Apresenta a relação de Oferta e Consumo de Matéria Seca (MS) da forrageira disponível no piquete, exibindo a quantidade de dias em que o Lote de animais poderá ficar no piquete, de acordo com o estoque de MS disponível e consumo previsto dos animais.",
      columns: {
        picketName: "Piquete",
        status: "Status",
        days: "Dias acumulados",
        lotation: "Taxa de lotação",
      },
      tableType: {
        dryStockOption: "Estoque MS",
        OfferRateOption: "Taxa de Oferta",
      },
    },
    drawerTitle: "Cadastro de Piquete / Baia",
    drawerTitleEdit: "Editar Piquete",
    drawerTitleEditIntensiveSubSystem: "Editar Baia",
    drawerSubTitle:
      "Complete os campos abaixo para criar um novo piquete / baia",
    drawerSubTitleEdit:
      "Complete os campos abaixo para editar o piquete / baia",
    drawerAllocateLotTitle: "Alocação de lote no piquete / baia",
    drawerAllocateLotSubTitle: "Alocação de lote no piquete / baia",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    searchInputPlaceHolder:
      "Pesquise pela identificação do lote e pressione ENTER.",
    alertLotWithProfitCenterDifferent:
      "O piquete / baia receberá a atividade do lote selecionado!",
    detail: {
      name: "Identificação",
      productionSubSystem: "Subsistema",
      supplierId: "Fornecedor",
      supplierDivider: "FORNECEDOR",
      sustenanceCapacityDivider: "CAPACIDADE DE SUPORTE",
      pastureDivider: "FORRAGEIRA",
      infrastructureDivider: "INFRAESTRUTURA",
      pasture: "Forrageira",
      pastureDailyCost: "Custo diário",
      pastureAnimalCapacity: "Ocupação por animal",
      pastureArea: "Área disponível",
      pastureLeafDensity: "Densidade foliar",
      pastureFertilized: "Adubado",
      pastureCurrentHeight: "Altura atual do capim",
      pastureCurrentHeightDate: "Data da altura atual",
      pastureGrowthSpeed: "Velocidade Crescimento",
      troughSpacePerAnimal: "Espaço de cocho por animal",
      totalTroughSpace: "Espaço total de cocho",
      drinkingFountain: "Espaço total do bebedouro",
      lotId: "Lote",
      leaseCost: "Custo do arrendamento",
      profitCenterId: "Atividade",
      profitCenterType: "Tipo",
      pastureId: "Tipo de forrageira",
      moreInformationButton: "MAIS INFORMAÇÃO",
    },
    form: {
      name: "Identificação do piquete / baia",
      namePlaceHolder: "Identificação do piquete / baia",
      importCode: "Código de importação",
      automacaoTratosDivider: "Integração com Automação de Tratos",
      initialTag: "Tag Inicial",
      finalTag: "Tag Final",
      integrationCode: "Código de Integração",
      propertyType: "O piquete / baia é interno ou terceirizado?",
      productionSubSystem: "Subsistema de produção",
      productionSubSystemPlaceHolder: "Selecione o Sistema",
      supplierId: "Fornecedor",
      supplierIdPlaceHolder: "Selecione o fornecedor",
      sustenanceCapacity: "CAPACIDADE DE SUPORTE",
      alocateLotTitle: "ALOCAR LOTE DE PRODUÇÃO",
      infrastructureDivider: "INFRAESTRUTURA",
      lotId: "Lote",
      lotIdPlaceHolder: "Selecione um lote",
      lotStartDate: "Entrada do lote atual",
      oldLotEndDate: "Saída do lote antigo",
      leaseMonthlyCost: "Custo do arrendamento",
      profitCenterId: "Atividade utilizada",
      profitCenterIdPlaceHolder: "Selecione a atividade",
      status: "Status do picket",
      sustenanceCapacityDrawerTitle: "Capacidade de Suporte do Piquete",
      sustenanceCapacityDrawerTitleIntensiveSubSystem:
        "Capacidade de Suporte da Baia",
      drinkingFountain: "Espaço total do bebedouro",
      troughSpacePerAnimal: "Espaço de cocho por animal",
      totalTroughSpace: "Espaço total de cocho",
      pastureDivider: "FORRAGEIRA",
      pastureId: "Forrageira",
      pastureIdPlaceHolder: "Selecione o tipo de forrageira",
      pastureAnimalCapacity: "Ocupação por animal",
      pastureArea: "Área disponível",
      pastureLeafDensity: "Densidade foliar",
      pastureFertilized: "Adubado",
      pastureDailyCost: "Custo diário ",
      pastureDailyCostTooltip:
        "Ao informar algum valor neste campo, o mesmo será utilizado na Estratégia de Dieta, independente da Estação Climática. Se nenhum valor for informado, será utilizado o Custo cadastrado em Pasto referente à cada Estação Climática.",
      pastureCurrentHeight: "Altura atual do capim",
      pastureCurrentHeightDate: "Data da altura atual",
      pastureGrowthSpeed: "Velocidade Crescimento",
      observation: "Observações",
      error: {
        requiredPastureId: {
          title: "Dados inválidos",
          message:
            "Selecione o tipo de forrageira quando subsistema de produção for Intensivo ou Semi-Intensivo",
        },
        requiredSupplierId: {
          title: "Dados inválidos",
          message:
            "Selecione o fornecedor quando o tipo de picket for Terceiro",
        },
        supplementConsumptionMeasureTypeInvalid: {
          title: "Dados inválidos",
          message: "Tipo de medida inválida para Tipo de Consumo selecionado",
        },
        productionSubSystemDifferentFromPicketProductionSubSystem: {
          title: "Dados inválidos",
          message:
            "Não pode alocar este lote, pois o sub-sistema de produção é diferente do piquete / baia",
        },
        sustenanceCapacityNotInformed: {
          title: "Dados inválidos",
          message: "Os dados da Capacidade de Suporte devem ser informados",
        },
      },
    },
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar piquete / baia e adicionar novo",
      save_and_add_lot: "Salvar e adicionar lote ao piquete / baia",
    },
    drawerMaintenance: {
      title: "Colocar piquete / baia em manutenção",
      subtitle:
        "Indique no campo abaixo o tempo que o piquete / baia ficará em manutenção",
      labelAmountDays: "Quantidade de dias",
      finishIn: "Finalizado em:",
      infoMessage: "Você será notificado quando o período for finalizado.",
    },
    drawerRenovation: {
      title: "Colocar piquete / baia em reforma",
      subtitle:
        "Indique no campo abaixo o tempo que o piquete / baia ficará em reforma",
      labelAmountDays: "Quantidade de dias",
      finishIn: "Finalizado em:",
      infoMessage: "Você será notificado quando o período for finalizado.",
    },
    drawerBreakTitle:
      "Você tem certeza que quer colocar este picket em Descanso ?",
    drawerInactivate: "Você tem certeza que quer inativar este piquete ?",
    drawerReactivate: "Você tem certeza que quer reativar este piquete ?",
    drawerDelete: "Você tem certeza de que quer excluir este piquete ?",
  },
  retreat: {
    title: "Lista de retiros",
    buttonNew: "Novo Retiro",
    table: {
      columns: {
        status: "Status",
        retreatName: "Retiro",
        area: "Área",
      },
      expandedColumns: {
        picketName: "Piquete/Baia",
        area: "Área",
        activity: "Atividade",
        status: "Status",
        lot: "Lote",
      },
    },
  },
  profitCenter: {
    title: "Atividades",
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar atividade e adicionar novo",
    },
    table: {
      title: "Lista de atividades",
      columns: {
        name: "Name",
        status: "Status",
        type: "Tipo",
        productionSubSystem: "Subsistema de produção",
      },
    },
    drawerTitle: "Cadastro de Atividade",
    drawerTitleEdit: "Editar Atividade",
    drawerSubTitle: "Complete os campos abaixo para criar uma nova atividade",
    drawerSubTitleEdit: "Complete os campos abaixo para editar a atividade",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    modalCheckbox: "Salvar e adicionar lote ao piquete / baia",
    form: {
      name: "Identificação da atividade",
      namePlaceHolder: "Nome da atividade",
      externalIntegrationCode: "Código Externo",
      productionSubSystem: "Subsistema de produção",
      productionSubSystemPlaceHolder: "Qual é o subsistema de produção?",
      type: "Tipo",
      typePlaceHolder: "Qual é o tipo de atividade?",
      status: "Status da atividade",
    },
  },
  farm: {
    title: "Fazendas",
    table: {
      title: "Lista de fazendas",
      columns: {
        name: "Nome",
        status: "Status",
      },
    },
    drawerTitle: "Cadastro de Fazenda",
    drawerTitleEdit: "Editar Fazenda",
    drawerSubTitle: "Complete os campos abaixo para criar uma nova fazenda",
    drawerSubTitleEdit: "Complete os campos abaixo para editar a fazenda",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      logo: "Informe o logo da sua fazenda",
      confinement: "Confinamento?",
      boitel: "É Boitel ?",
      boitelVisibleToAllSystem:
        "Assinale a caixa, caso você deseje aparecer na lista de Boitel - Diárias para todos usuários BovExo.",
      checkVisibleForAllSystem:
        "Ao assinalar esta caixa, você concorda em adicionar esta fazenda a lista de fornecedores e clientes deste grupo, e permite que esta fazenda seja pesquisada por todos os usuários Bovexo.",
      farmSisbov: "Fazenda ERAS (SISBOV)?",
      farmSisbovInfoTooltip:
        "Ao marcar que a fazenda é ERAS (Estabelecimentos Rurais Aprovados SISBOV), serão habilitados, campos e controles referente a rastreabilidade.",
      name: "Nome fantasia da fazenda",
      namePlaceHolder: "Nome fantasia da fazenda",
      externalIntegrationCode: "Código Externo",
      externalIntegrationCodePlaceHolder: "Código Externo",
      group: "Grupo",
      groupPlaceHolder: "Selecione o grupo",
      companyName: "Razão social",
      companyNamePlaceHolder: "Razão social da fazenda",
      document: "CNPJ",
      documentPlaceHolder: "CNPJ",
      zipCode: "CEP",
      zipCodePlaceHolder: "CEP",
      address: "Endereço",
      addressPlaceHolder: "Estrada, Rodovia, rua....",
      city: "Cidade",
      cityPlaceHolder: "Cidade",
      state: "UF",
      statePlaceHolder: "UF",
      status: "Status da fazenda",
      country: "País",
      countryPlaceHolder: "País",
      totalArea: "Área total",
      rentAreaOutSourced: "Área arrendada para terceiros",
      livestockArea: "Área de Pasto",
      nonProductiveArea: "Área de reserva não produtiva",
      cultivationArea: "Área de cultivo",
      improvementsArea: "Área de melhoria",
      complementAddress: "Complemento",
      complementAddressPlaceHolder: "Complemento",
      farmOwner: "Proprietários",
      weatherStation: "Estação Metereológica",
      weatherStationPlaceHolder: "Estação Metereológica",
    },
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar fazenda e adicionar nova",
    },
    messages: {
      successSubmit: "Fazenda criada/atualizada com sucesso.",
      errorSubmit: "Fazenda não foi criada/atualizada. Contate o suporte.",
      errorFarmDocumentAlreadyExists:
        "Documento da Fazenda já existe em nossa base de dados.",
      errorFarmOwnerDocumentAlreadyExists:
        "Documento do Proprietário já existe em nossa base de dados.",
    },
  },
  farmOwner: {
    title: "Proprietários da Fazenda",
    buttonNew: "Novo",
    table: {
      columns: {
        code: "Cód.",
        name: "Nome",
        document: "CPF/CNPJ",
        participation: "% Part.",
        mainOwner: "Principal ?",
      },
    },
    form: {
      code: "Còdigo",
      name: "Nome",
      document: "CPF/CNPJ",
      participation: "Participação",
      mainOwner: "Principal ?",
    },
  },
  supplier: {
    title: "Fornecedores",
    modalTitle: "Selecione um fornecedor",
    types: {
      supplement: "Suplemento/Concent.",
      technology: "Tecnologia",
      cattleFarmer: "Pecuarista",
      others: "Outros",
      veterinarySupplement: "Insumos Veterinários",
    },
    table: {
      title: "Lista de fornecedores",
      columns: {
        name: "Nome",
        type: "Tipo",
        status: "Status",
        phoneNumber: "Contato",
        email: "Email",
        city_uf: "Cidade/UF",
      },
    },
    export: {
      columns: {
        id: "ID",
        farm_id: "Fazenda",
        name: "Nome",
        type: "Tipo",
        document_type: "Tipo de Documento",
        document: "Documento",
        responsible_name: "Nome do Responsável",
        email: "E-mail",
        phone_number: "Telefone",
        address: "Endereço",
        zip_code: "CEP",
        city_id: "ID da Cidade",
        city_name: "Cidade",
        state_id: "ID do Estado",
        state_name: "Estado",
        farm_status: "Status",
        external_integration_code: "Código de Integração Externa",
      },
    },
    drawerTitle: "Cadastro de Fornecedor",
    drawerTitleEdit: "Editar Fornecedor",
    drawerSubTitle: "Complete os campos abaixo para criar uma nova fornecedor",
    drawerSubTitleEdit: "Complete os campos abaixo para editar o fornecedor",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      name: "Fornecedor",
      namePlaceHolder: "Nome do fornecedor",
      externalIntegrationCode: "Código Externo/Integração",
      externalIntegrationCodePlaceHolder: "Código Externo/Integração",
      type: "Tipo",
      typePlaceHolder: "Tipo do fornecedor",
      phoneNumber: "Contato",
      phoneNumberPlaceHolder: "Telefone para contato",
      document: "CPF/CNPJ",
      documentPlaceHolder: "CPF ou CNPJ",
      email: "Email",
      emailPlaceHolder: "E-mail",
      zipCode: "CEP",
      zipCodePlaceHolder: "CEP",
      address: "Endereço",
      addressPlaceHolder: "Estrada, Rodovia, rua....",
      city: "Cidade",
      cityPlaceHolder: "Cidade",
      state: "UF",
      statePlaceHolder: "UF",
      country: "País",
      countryPlaceHolder: "País",
      status: "Status do fornecedor",
      groupFarmVisibility: "Quem irá utilizar o fornecedor?",
      radiogroup: {
        farm: "Esta fazenda",
        group: "Fazendas do grupo",
      },
    },
    saveOptions: {
      only_save: "Salvar somente",
      save_and_create_new: "Criar fornecedor e adicionar novo",
    },
    messages: {
      cpfInvalid: "CPF incorreto !",
      cpfInvalidDescription: "Por favor, informe um CPF válido.",
      cnpjInvalid: "CNPJ incorreto !",
      cnpjInvalidDescription: "Por favor, informe um CNPJ válido.",
      contactFormatInvalid: "Formato do contato inválido.",
    },
  },
  manufacturer: {
    title: "Fabricantes",
    drawerTitle: "Cadastro de Fabricante",
    drawerSubTitle: "Complete os campos abaixo para criar um novo fabricante",
    validationMessage:
      "Preencha todos os campos obrigatórios com * corretamente",
    form: {
      name: "Nome",
      namePlaceHolder: "Nome do fabricante",
    },
    messages: {
      duplicateName: "Fabricante já cadastrado !",
      duplicateNameDescription:
        "Já existe um fabricante com este nome cadastrado nesta fazenda.",
      createSuccess: "Fabricante criado com sucesso",
      createError: "Não foi possível criar o fabricante",
    },
  },
  clientList: {
    export: {
      columns: {
        name: "Nome",
        type: "Tipo",
        document_type: "Tipo de Documento",
        document: "Documento",
        phone: "Telefone",
        farm_status: "Status",
        zip_code: "CEP",
        address: "Endereço",
        city: "Cidade",
        state: "Estado",
        status: "Status",
      },
    },
  },
  cattleProducer: {
    title: "Produtores",
    table: {
      title: "Lista de produtores",
      columns: {
        name: "Nome",
        document: "Documento",
        status: "Status",
      },
    },
    drawer: {
      title: "Cadastro de Produtor",
      titleEdit: "Editar Produtor",
    },
    form: {
      name: "Nome",
      document: "Documento",
      documentPlaceHolder: "CPF ou CNPJ",
      properties: "Propriedades",
      property: "Propriedade",
      propertyName: "Nome",
      propertyDocument: "Documento",
      addProperty: "Adicionar Propriedade",
      validation: {
        nameRequired: "Nome é obrigatório",
        cpfError: "CPF incorreto!",
        cpfErrorDescription: "Por favor, informe um CPF válido.",
        cnpjError: "CNPJ incorreto!",
        cnpjErrorDescription: "Por favor, informe um CNPJ válido.",
        propertyCpfError: "CPF da propriedade incorreto!",
        propertyCpfErrorDescription:
          "Por favor, informe um CPF válido para a propriedade.",
        propertyCnpjError: "CNPJ da propriedade incorreto!",
        propertyCnpjErrorDescription:
          "Por favor, informe um CNPJ válido para a propriedade.",
      },
    },
    buttons: {
      buttonNew: "Novo Produtor",
    },
    select: {
      placeholder: "Selecione um produtor",
    },
    modal: {
      deleteTitle: "Confirmar exclusão",
      deleteContent: "Tem certeza que deseja excluir este produtor?",
    },
    notifications: {
      createSuccess: "Produtor criado com sucesso",
      createError: "Produtor não foi criado",
      updateSuccess: "Produtor atualizado com sucesso",
      updateError: "Produtor não foi atualizado",
      deleteSuccess: "Produtor excluído com sucesso",
      deleteError: "Produtor não foi excluído",
      error5043Message:
        "Produtor associado a um Contrato. Não será possível excluir.",
    },
  },
  animal: {
    buttonNew: "Novo animal",
    buttonGenerateReport: "Gerar Listagem de Animais",
    buttonGenerateReportInfoTooltip:
      "Selecione um ou vários animal(is) na tabela abaixo para gerar o relatório.",
    buttonGenerateReportERA: "Gerar Relatório de Movimentações",
    listingReportTitle: "Listagem de Animais",
    dashboard: {
      activeAnimals: "ANIMAIS ATIVOS",
      activeLots: "LOTES ATIVOS",
      animalsByGender: {
        title: "Quantidade por sexo",
        female: "Fêmea",
        male: "Macho",
      },
      hidePanels: "Ocultar painéis",
      showPanels: "Exibir painéis",
      extensive: "EXTENSIVO",
      semiIntensive: "SEMI-INTENSIVO",
      intensive: "INTENSIVO",
      gmd: "GMD",
      avgWeight: "Peso médio",
      avgAge: "Idade média",
      animals: "Animais",
      lots: "Lotes",
      noAnimalAlert: "Nenhum alerta de animal nessa data",
      fattenTab: "Recria/Engorda",
      reproductionTab: "Reprodução",
    },
    columns: {
      title: "Lista de animais",
      buttonCompare: "COMPARAR",
      handlingNumber: "Identificação",
      picket: "Piquete / Baia",
      lot: "Lote",
      sisbov: "Sisbov",
      tagId: "Id. Eletrônico",
      breed: "Raça",
      gender: "Sexo",
      birthdayMonths: "Idade",
      weightRanking: "Ranking",
      currentWeight: "Último Peso",
      gdp: "GMD",
      lastDailyWeightDate: "Últ. Pesagem",
      target: "Alvo",
      status: "Status",
      supplier: "Fornecedor",
      reproductionCategory: "Categoria Rep.",
      reproductionStatus: "Situação Rep.",
      reproductionState: "Estado Rep.",
    },
    searchAnimal: {
      label: "Identificação",
      modalTitle: "Selecione um animal",
      fieldLabel: "Campo de pesquisa",
      genderFilter: "Sexo",
      genderAll: "Todos",
      male: "Macho",
      female: "Fêmea",
      handlingNumber: "Identificação",
      sisbov: "Sisbov",
      tagId: "Id. Eletrônico",
      nickname: "Nome",
      registry: "Registro",
    },
    details: {
      animalProductionPageLink: "Animais em produção",
      animalPageDescription: "Detalhes do Animal",
      emptyMessage: "Dados do animal não encontrados",
      bovexoId: "Id Bovexo",
      registry: "Registro",
      sisbov: "SISBOV",
      age: "Nascimento",
      source: "Fornecedor",
      farmOwner: "Proprietário",
      castrated: "Castrado",
      tagId: "Id. Eletrônica",
      sex: "Sexo",
      male: "Macho",
      female: "Fêmea",
      acquisition: "Aquisição",
      handlingNumber: "Identificação",
      weight: "Peso",
      current: "Atual",
      location: "Localização",
      picket: "Piquete / Baia",
      lot: "Lote",
      breed: "Raça",
      weightGain: "Ganho de peso",
      accumulated: "Acumulado",
      lastWeight: "Último peso",
      forSlaughter: "para Abate",
      expected: "Esperado",
      asymptoticWeight: "Peso Assintótico",
      economicReturn: "Retorno econômico",
      currentValue: "Valor atual",
      accumulatedCost: "Custo acumulado",
      animalFarmFunction: "Finalidade",
      animalReproductionCategory: "Categoria",
      margin: "Margem",
      appropriateCosts: "Custos Apropriados",
      femaleSituation: "Situação",
      femaleSituationTime: "Tempo de situação",
      birthForecast: "Previsão de Parto",
      coverageDate: "Data Cobertura",
      coverageType: "Tipo Cobertura",
      coverageSemenOrMaleIdentification: "Touro",
      weightCoverage: "Peso na Cobertura",
      semenDeparture: "Partida",
      observation: "Obs. Cobertura",
      bodyConditionScore: "ECC",
      pregnancyDiagnosisDate: "Data do DG",
      pregnancyDiagnosisResult: "Resultado (DG)",
      pregnancyDiagnosisOvarianEvaluationResult: "Avaliação Ovariana (DG)",
      birthDate: "Parto",
      birthType: "Tipo Parto",
      gestationDays: "Temp. Gestação",
      childsGender: "Sexo Crias",
      childsIds: "Id. Crias",
      childsBirthday: "Peso Nascimento",
      childsStatus: "Situação Atual Crias",
      childsWeaningWeightDate: "Dt. Desmame",
      childsWeaningWeight: "Peso Desmame",
      iep: "Interv. Partos",
      tab: {
        production: "Produção",
        reproduction: "Reprodução",
        genetic: "Genética",
        geneology: "Genealogia",
        evaluation: "Avaliação",
        zoonosis: "Zoonose",
        weighing: "Pesagens",
        dailyWeights: "Pesos diários",
        weightGains: "Ganhos de peso (GMD)",
        measurements: "Medições",
        animalHistory: "Histórico",
      },
      animalHistory: {
        lots: "Histórico de Lotes",
        pickets: "Histórico de Piquetes",
        refresh: "Atualizar",
        lotName: "Lote",
        picketName: "Nome do Piquete",
        activity: "Atividade",
        dietStrategy: "Est. de Dieta",
        entryDate: "Entrada",
        exitDate: "Saída",
        weightIn: "Peso Entrada",
        weightOut: "Peso Saída",
        daysQuantity: "Qtd. de Dias",
      },
      history: {
        title: "Histórico de peso e medições",
        tooltipHistoryWeight:
          "Nesta opção, será apresentadas as pesagens registradas para o animal e o respectivo ganho de peso.\n" +
          "\n" +
          " 1. Pesagens: São exibidos todos os pesos registrados para animal, mesmo que ocorra mais de uma pesagem no mesmo dia, como por exemplo, pesagens de origem de balanças de pesagens dinâmicas.\n" +
          " 2. Pesos Diários: São os pesos que efetivamente serão considerados para o animal, seja para cálculo de GDP ou GMD. Se utilizada balanças de pesagens dinâmicas, que podem registrar mais de um peso no mesmo dia para o mesmo animal, será considerada a regra definida em configuração de Pesos, disponível em [Parâmetros/Gerais].\n" +
          " 3. Ganhos de peso (GMD): refere-se ao GMD, ou seja, o ganho diário entre a pesagem da data e sua anterior.",

        grid: {
          emptyMessage: "Não há histórico de peso registrado",
          emptyMessageMeasurements: "Não há medições registradas",
          in: "Entrada",
          out: "Saída",
          manual: "Manual",
          date: "Data",
          hour: "Hora",
          inOut: "E/S",
          weight: "Peso(kg)",
          eventTitle: "Tipo",
          originEvent: {
            birthday: "Nasc",
            purchase: "Compra",
            weaning: "Desm",
            sale: "Venda",
            transfer: "Transferência",
            weighing: "",
          },
        },
      },
      totalWeight: {
        title: "PESO TOTAL",
        tooltip:
          "Este gráfico compara o último peso do animal com a media dos animais semelhantes no mesmo grupo genético, raça e do mesmo lote",
        graph: {
          currentWeight: "Peso Atual",
          lot: "Lote",
          genetic: "Genética",
          breed: "Raça",
          weight: "Peso",
          type: "Tipo",
          estimated: "Estimado ED",
        },
      },
      averageDailyGain: {
        title: "GANHO MÉDIO DIÁRIO",
        tooltip:
          "Este gráfico compara o último ganho diário de peso do animal com a media dos animais semelhantes no mesmo grupo genético, raça e do mesmo lote",
        graph: {
          currentGain: "Ganho Atual",
          lot: "Lote",
          genetic: "Genética",
          breed: "Raça",
          weight: "Peso",
          type: "Tipo",
          estimated: "Estimado ED",
        },
      },
      dailyWeightGain: {
        title: "EVOLUÇÃO DO PESO E GDP",
        graph: {
          weight: "Peso",
          time: "Dias",
        },
      },
    },
    drawerTitleEdit: "Editar animal",
    drawerSubTitleEdit: "Preencha os dados abaixo para editar um animal",
    drawerSubTitleEditDeathAnimal:
      "Animal em óbito, todos os campos foram desativados",
    drawerAnimalDeathTitle: "Óbito animal",
    animalDeathPopConfirmTitle:
      "Ao confirmar, o animal é considerado em estado de óbito permanente",
    edit: {
      form: {
        nickname: "Nome",
        nicknamePlaceHolder: "Nome",
        registry: "Registro",
        registryPlaceHolder: "Registro",
        sisbov: "SISBOV",
        sisbovPlaceHolder: "SISBOV",
        tagId: "Id. Eletrônica",
        tagIdPlaceHolder: "Id. Eletrônica",
        sex: "Sexo",
        male: "Macho",
        female: "Fêmea",
        acquisition: "Aquisição",
        handlingNumber: "Identificação",
        handlingNumberPlaceHolder: "N. de identificação do animal",
        breed: "Raça",
        breedPlaceHolder: "Selecione uma raça",
        cap: "Animal castrado?",
        birthday: "Data de nascimento",
        birthdayWeight: "Peso Nascimento",
        firstInseminationWeight: "Primeira inserminação",
        weaningWeight: "Peso Desmame",
        weaningDate: "Data Desmame",
        asymptoticWeight: "Peso Assintótico",
        asymptoticWeightInfoTooltip:
          "Peso assintótico é o peso que, com base nas informações que o usuário/produtor possui, sobre o histórico do Animal ou Lote de Animais, (considerando a genética, manejo anterior, interação genótipo-ambiente, frame, entre outras variáveis), acredite ser o potencial limite de peso. Ou seja, acima deste peso, dificilmente este animal ganhará peso, em condições normais.",
        acquisitionDate: "Data de aquisição",
        purchaseCost: "Preço da aquisição",
        acquisitionEstimatedWeight: "Peso aquisição",
        carcassHarnessing: "Aproveitamento da Carcaça",
        animalFarmFunction: "Finalidade",
        animalReproductionCategory: "Categoria",
        sisbovIdentificationDate: "Data Identificação",
        sisbovInsertBNDDate: "Data Inclusão BND",
        sisbovSlaughterDate: "Data Liberação Abate",
        farmOwner: "Proprietário",
      },
      weights: "PESOS",
      receipt: "RECEBIMENTO",
      sale: "VENDA",
    },
    drawerAnimalDiscardTitle: "Descarte do animal",
    discard: {
      motives: {
        Age: "Idade",
        ReproductiveProblems: "Problemas Reprodutivos",
        IllnessesOrPhysicalProblems: "Doenças ou Problemas Físicos",
        BodyCondition: "Condição corporal",
        NegativePregnancy: "Prenhez Negativa",
        MaternalAbility: "Habilidade Materna",
      },
    },
    carcassHarnessingInfoTooltip:
      "O aprov do animal deve ser informado caso tenha uma análise de carcaça por ultrassom. O aproveitamento do Lote e da Estratégia de dieta são expectativas. Quando ambas estão presentes, prevalecem, nesta ordem Animal, Dieta, Lote",
    messages: {
      createdSuccess: "Animal criado com sucesso",
      updatedSuccess: "Animal atualizado com sucesso",
    },
    drawer: {
      title: "Adicionar animal",
      validation: {
        supplierRequired: "Fornecedor não informado",
        supplierRequiredDesc:
          'Informe um fornecedor ou marque a opção "Animal fornecido pela própria fazenda".',
        carcassYieldInvalid: "Aproveitamento de Carcaça inválida",
        carcassYieldInvalidDesc:
          'O valor do campo "Aproveitamento de Carcaça" deve estar entre o intervalo de valores (45% e 60%)',
        datesInvalid: "Datas inválidas",
        datesInvalidDesc1:
          "A Data de Aquisição não pode ser antes da Data de Nascimento.",
        datesInvalidDesc2:
          "A Data de Desmame não pode ser antes da Data de Nascimento.",
        weightsInvalid: "Pesos inválidos",
        birthWeightDesc:
          "O Peso de Nascimento não pode ser maior do que o Peso de Desmame.",
        duplicateIdentification:
          "Existem animais ativos nesta propriedade que possuem essa mesma Identificação.",
      },
      messages: {
        alertTitle: "Alerta",
        animalOver60Months: "O animal possui mais de 60 meses.",
        confirm: "Confirma ?",
        createError: "Erro ao cadastrar",
        createErrorDesc:
          "Não foi possível cadastrar o animal. Contate o suporte",
        updateError: "Houve um erro ao atualizar",
        updateErrorDesc: "Por favor, contacte o administrador.",
        cannotUpdate: "Não é possível atualizar.",
        animalHasEvent:
          "Animal possui evento de {type} posterior à data de morte informada.",
        eventDate: "Data:",
        identifyAnimal: "Atenção! Você deseja identificar este animal?",
        lastAnimalInLot:
          'Atenção! Este é o último animal presente no Lote "{lotName}". Ao confirmar o registro de óbito, o Lote ficará com a situação "Pendente". Se não for mais utilizar este lote, poderá inativá-lo.',
        animalDeadTitle: "Animal em óbito",
        setAsAlive: "Definir animal como vivo",
        animalDiscardedTitle: "Animal descartado",
        discardCauseLabel: "Causa:",
        saleScenarioWarningEdit:
          "Caso o animal estiver em um lote que possua cenário(s) de venda, ao confirmar, reprocesse os cenário(s) para que o animal seja considerado.",
        saleScenarioWarningNew:
          "Caso o animal seja adicionado em um lote que possua cenário(s) de venda, ao confirmar, reprocesse os cenário(s) para que o animal seja considerado.",
      },
      form: {
        ownFarmAnimal: "Animal fornecido pela própria fazenda",
        milkCrossbreed: "Cruzado de leite",
        ageLabel: "Idade (dias/meses/anos)",
        purposeReproduction: "Reprodução",
        purposeFatten: "Engorda",
        firstInsemination: "1a. Inseminação",
        traceabilitySISBOV: "RASTREABIDLIDADE (SISBOV)",
        genealogy: "GENEALOGIA",
        mother: "MÃE",
        father: "PAI",
        supplier: "Fornecedor",
        identification: "Identificação",
        semen: "Sêmen",
        selectProductionLot:
          "Selecione um Lote de Produção já existente para este animal:",
        productionLot: "Lote de produção",
        associateReceiptLot: "Associar o animal a um Lote de Recebimento.",
        receiptLot: "Lote de Recebimento",
      },
      saveOptions: {
        saveOnly: "Salvar somente",
        saveAndAddNew: "Salvar e adicionar novo animal",
      },
      tooltips: {
        reproductionCategoryInfo: "",
      },
    },
    reproduction: {
      tabFemales: "Fêmeas",
      tabMales: "Machos",
      identificationLabel: "Identificação",
      identificationOptions: {
        handlingNumber: "Identificação",
        tagId: "Id. Eletrônica",
        sisbov: "SISBOV",
        nickname: "Nome",
        registry: "Registro",
      },
      radioAnimals: "Animais",
      radioReproductionEvents: "Eventos Reprodutivos",
    },
    ageInputPlaceholders: {
      days: "Dias",
      months: "Meses",
      years: "Anos",
    },
    animalDiscard: {
      descriptionPlaceholder: "Descrição do descarte",
    },
    animalDeath: {
      descriptionPlaceholder: "Descrição da morte",
    },
    curveParameter: {
      drawerTitle: "Parâmetros de animal",
      defineParams: "Defina os parâmetros do lote",
      saveSuccess: "Curva estimada de crescimento salva.",
      saveError: "Houve um erro ao salvar a curva estimada de crescimento.",
    },
  },
  dietStrategy: {
    new: {
      title: "Criação de estratégia",
      message:
        "Selecione o período total da estratégia e defina as dietas e o tempo de execução de cada uma",
      name: "Nome da estratégia",
      namePlaceHolder: "Nome da estrtégia de dieta",
      totalPeriod: "Período total",
      year: "Ano",
      oneYear: "1 ano",
      twoYears: "2 anos",
      threeYears: "3 anos",
      dietAndExecutionTime: "Dietas & tempo de execução",
      dietPlaceHolder: "Selecione uma dieta",
      deleteDietPeriod: "Apagar dieta",
      totalTime: "Tempo total",
      weeks: "Semana(s)",
      buttonAddDiet: "Adicionar Dieta",
      drawerTitle: "Resumo da estratégia",
      start: "Início",
      end: "Fim",
      notification: {
        success: {
          message: "Estratégia de dieta criada!",
          description: "A estratégia foi inclusa no sistema.",
        },
        error: {
          dontHaveName: {
            message: "Erro",
            description:
              "É necessário digitar um nome para a estratégia de dieta !",
          },
          dontHaveDiet: {
            message: "Erro",
            description:
              "Todos os períodos precisam ter uma dieta selecionada.",
          },
        },
      },
    },
    title: "Lista de estratégias de dieta",
    buttonNewDietStrategy: "Nova estratégia",
    table: {
      status: "Status",
      name: "Nome",
      diet: "Dieta",
      totalTime: "Tempo total",
    },
    modal: {
      simple: {
        title: "SubSistema de Produção divergente",
        message:
          "O sub sistema de produção selecionado para este período não corresponde ao sub sistema utilizado no piquete / baia em que o lote está alocado. Para obter uma boa performance é recomendado que ambos utilizem o mesmo sistema.",
        confirmButton: "OK, entendi.",
      },
    },
  },
  weightStrategy: {
    title: "Estratégia de Peso",
    tabs: {
      dietStrategy: "Estratégia de Dieta",
      weightGainProjection: "Projeção de Ganho de Peso",
    },
  },
  generalParameters: {
    weatherSeason: {
      title: "Estações climáticas",
      editMessage:
        "Defina as estações climáticas mais adequadas para a localização da fazenda utilizando a caixa ao lado:",
      table: {
        columnDayMonth: "DIAS/MÊS",
        columnNextSeason: "PRÓXIMA ESTAÇÃO",
        columnMonthSeason: "ESTAÇÃO DO MÊS",
      },
    },
    farmDeathReason: {
      buttonNew: "Novo",
      table: {
        title: "Causa Mortis",
        columns: {
          name: "Nome",
          status: "Situação",
        },
      },
    },
    quotas: {
      buttonNew: "Novo",
      table: {
        title: "Cotas",
        columns: {
          name: "Nome",
          type: "Tipo",
          status: "Situação",
        },
      },
    },
    successParameterUpdated: "Parâmetros alterados com sucesso!",
    errorParameterUpdated: "Ops... os parâmetros não foram alterados",
  },
  cost: {
    tabs: {
      fixedCost: "Imobilizados",
      infrastructureCost: "Infraestrutura e mão de obra",
      operatingVariableCost: "Variáveis operacionais",
      zootechnicalVariableCost: "Zootécnicos",
      sanityCost: "Sanidade",
    },
    form: {
      error:
        'É necessário informa os campos "Valor do Custo" e "Depreciação" nos custos marcados em vermelho',
      growth: "Cria",
      recreateFattenPasture: "R&E - Pasto",
      recreateFattenSemiConfinement: "R&E - Semi-Confinamento",
      recreateFattenConfinement: "R&E - Confinamento",
      area: "Área",
      potentialOccupation: "Ocupação Potencial",
      staticCapacity: "Capacidade Estática",
      staticCapacityTooltip:
        "Os valores deste campo são calculados, multiplicando-se a Área pela Ocupação Potencial.",
      fence: "Cercas",
      costValue: "Valor do Custo",
      depreciationValue: "Depreciação",
      total: "Total",
      amountAnimals: "Qtd. de Cabeças",
      totalDailyCostPerAnimal: "Custo diário por Animal",
      dietCost: "Dieta",
      costProtocol: "Custo de Protocolo",
    },
    costType: {
      FixedCost: "Imobilizados",
      InfrastructureCost: "Infraestrutura e mão de obra",
      OperatingVariableCost: "Variáveis operacionais",
      ZootechnicalVariableCost: "Zootécnicos",
      sanityCost: "Sanidade",
    },
    code: {
      1: "Construção sede e instal.",
      2: "Impostos (ITR, CAN)",
      3: "Seguros",
      4: "Formação de pastos",
      5: "Construção de cercas",
      6: "Construção de curral",
      7: "Construção de açudes",
      8: "Aquisição de máquinas e implementos",
      9: "Construção de galpões e instal.",
      10: "Mão de obra operacional",
      11: "Mão de obra técnica prop.",
      12: "Assitência Técnica 3RDS",
      13: "Energia",
      14: "Telefone / Internet",
      15: "ERP",
      16: "Contador",
      17: "Manutenção de Instal. e Galpões",
      18: "Manutenção de Máquinas e Equipamentos",
      19: "Combustível e Lubrificantes",
      20: "Manutenção de pastos",
      21: "Adubação",
      22: "Manutenção de Currais e Cercas",
      23: "Aluguel de Pasto",
      24: "Vacinas",
      25: "Vermífugos",
      26: "Medicamentos",
      27: "Identificação",
      28: "Custo com Tropa & Relacionados",
      29: "Outros custos Adm.",
      30: "Valor do Protocolo",
    },
  },
  saleScenario: {
    error: {
      DietStrategyExpired:
        "Não foi possível processar o cenário de venda, pois o mesmo possui estratégias de dietas vencidas.",
      InternalError: "Houve um erro ao processar o cenário. Contate o suporte.",
    },
  },
  purchaseScenario: {
    error: {
      DietStrategyExpired:
        "Não foi possível processar o Cenário de Compra, pois a Estratégia de Dieta informada está Vencida.",
    },
  },
  movementHistory: {
    title: "Histórico(s) de Movimentações",
    table: {
      columns: {
        originalLotsNames: "Lotes de Origem",
        destinationLotsNames: "Lotes de Destino",
        requestDate: "Data da Movimentação",
        fromDismemberLot: "Desmembramento?",
        fileName: "Nome do arquivo",
        animalHandlingNumber: "Animal",
        lotOriginName: "Lote de Origem",
        lotDestinationName: "Lote de Destino",
        createdAtDate: "Data Registro",
      },
    },
  },
  financial: {
    tabs: {
      costing: "Custeio",
      cashFlow: "Fluxo de Caixa",
      parameters: "Parâmetros",
      transactions: "Movimentações Financeiras",
      animalSell: "Transf/Venda",
      resultCenterAnalysis: "Análise CR/CC",
      bankConciliation: "Conciliação Bancária",
    },
    costType: {
      Growth: "Cria",
      RecreateFattenPasture: "Extensivo",
      RecreateFattenSemiConfinement: "Semi-Intensivo",
      RecreateFattenConfinement: "Intensivo",
      Agriculture: "Agricultura",
      Others: "Outros",
    },
    transactions: {
      title: "Movimentações",
      buttonCreateNewFinancialTransaction: "Novo lançamento",
      buttonExportTransactions: "Exportar movimentações",
      form: {
        title: "Novo lançamento",
        documentNumber: "Nº Doc. Fiscal",
        supplierId: "Fornecedor",
        billingDate: "Data do faturamento",
        expirationDate: "Data do vencimento",
        mainValueCurrency: "Selecione uma moeda",
        mainValue: "Valor Principal",
        fees: "Valor Juros/Multas",
        discount: "Descontos",
        value: "Valor da transação",
        payment: "Pagamento",
        actions: "Ação",
        actionsOptions: {
          launch: "Lançar",
          launchAndSettle: "Lançar e Baixar",
          settle: "Baixar",
        },
        settleDate: "Data da Baixa",
        inCash: "À vista",
        part: "Parcelado",
        financialNatureId: "Natureza",
        financialClassId: "Classe",
        costActivityType: "Atividade",
        description: "Descrição",
        resultCenter: "Centro de Resultado",
        resultCenterApportionmentDefault: "Padrão",
        resultCenterApportionmentCustom: "Redefinir",
        transactionType: "Tipo",
        clientId: "Cliente",
        financialProjectId: "Projeto Financeiro",
        bonus: "Bonificação",
        financialIssueId: "Pendêcia Financeira",
        financialPaymentMethodId: "Forma de Pagamento",
        financialTaxableDeductibleId: "Tributável/Dedutivel IR",
        bankAccountFarmId: "Fonte Pagadora",
        errors: {
          installmentsNotGeneratedError:
            'É necessário gerar as parcelas. Para isso clique na opção "Parcelado" presente no campo "Pagamento".',
        },
      },
      modalInstallments: {
        title: "Gerar parcelas",
        value: "Valor da transação",
        expirationDate: "Data do vencimento",
        installmentTotal: "Nº de Parcelas",
        buttonCalc: "Calcular",
        expireDateRequired:
          "É necessário informar a Data de Vencimento para gerar as parcelas.",
      },
      modalEditInstallment: {
        title: "Editar dados da baixa da parcela",
      },
      table: {
        columns: {
          nature: "Natureza",
          class: "Classe",
          values: "Valores",
          origin: "Origem",
          billingDate: "Data faturamento",
          expirationDate: "Data vencimento",
          installment: "Parcela",
          documentNumber: "Nº Doc. Fiscal",
          value: "Valor",
          bankAccountFarmName: "Fonte Pagadora",
          isPaidPartially: "Parc. Pago",
          isSettled: "Status",
          settleDate: "Data da Baixa",
          financialClassDepreciation: "Alocação",
          valueDepreciation: "Custo Alocação",
          supplierName: "Fornecedor/Cliente",
          costActivityType: "Atividade",
          r: "CR",
          financialProjectName: "Projetos",
          transactionType: "Tipo",
          entityName: "Fornecedor/Cliente",
          financialIssueId: "Pendêcia Financeira",
          financialPaymentMethodId: "Forma de Pagamento",
          financialTaxableDeductibleId: "Tributável/Dedutivel IR",
          bankAccountFarmId: "Fonte Pagadora",
          discount: "Desconto",
          fees: "Juros/Multas",
        },
      },
      modalResultCenterApportionment: {
        title: "Rateio por Centro de Resultado",
      },
    },
    cashFlow: {
      title: "Fluxo de Caixa",
      buttonDisbursementReport: "Relatório de Desembolso",
      buttonCashFlowReport: "Relatório de Fluxo de Caixa",
      buttonCreateBudget: "Novo orçamento",
      filters: {
        status: "Status",
        visualization: "Visualização",
        exibition: "Exibição",
        timeExibition: "Exibição do Tempo",
        timeExibitionOptions: {
          year: "Anual",
          harvest: "Safra",
        },
        harvest: "Safra/Ano",
        costType: "Atividade",
        financialProjectId: "Projeto Financeiro",
        bankAccountFarmId: "Fonte Pagadora",
      },
      table: {
        columns: {
          nature: "Natureza",
          class: "Classe",
          values: "Valores",
        },
      },
    },
    costing: {
      title: "Tabela de Custos",
      filters: {
        visualization: "Visualização",
        timeExibition: "Exibição do Tempo",
        timeExibitionOptions: {
          year: "Anual",
          harvest: "Safra",
        },
        harvest: "Safra/Ano",
        costType: "Atividade",
        financialProjectId: "Projeto Financeiro",
        bankAccountFarmId: "Fonte Pagadora",
      },
      table: {
        columns: {
          nature: "Natureza",
          class: "Classe",
          values: "Valores",
        },
      },
    },
    parameters: {
      tabs: {
        parameters: "Parâmetros",
        costing: "Custeio",
        resultCenter: "Centro de Resultado",
        costCenter: "Centro de Custo",
        financialProject: "Projetos Financeiros",
        additionalControls: "Controles Adicionais",
        financialIssue: "Pendências Financeiras",
        financialPaymentMethod: "Forma de Pagamento",
        financialTaxableDeductible: "Tributável/Dedutível IR",
        bankAccountFarm: "Contas Bancárias",
      },
      generalFinancialParameters: {
        title: "Parâmetros",
        parameter4001: "Utilizar conversão de moedas?",
        parameter4002: "Custos Nutricionais",
        parameter4002Help:
          "Defina se os custos nutricionais serão apropriados aos animais a partir da Estratégia de Dieta ou do Fornecimento",
        parameter4002DietStrategy: "Estratégia de Dieta",
        parameter4002SupplementSupply: "Fornecimento",
        farmConvertions: {
          title: "Moedas",
          buttonNew: "Nova Moeda",
          table: {},
          form: {
            titleNew: "Nova Moeda",
            currency: "Moeda",
            standard: "Colocar como padrâo?",
          },
        },
      },
      costing: {
        title: "Tabela de Parâmetros Custeio",
        table: {
          columns: {
            nature: "Natureza",
            stock: "Controle de Estoque",
            class: "Classe",
            depreciation: "Depreciação (Meses)",
            shouldCost: "Custeio",
            shouldDisbursement: "Desembolso",
            product: "Produto",
            costCenter: "Centro de Custo",
            type: "Tipo",
            expense: "Despesa",
            revenue: "Receita",
            defaultValueChanged: "Valor padrão alterado",
          },
        },
        buttonNew: "Nova classe",
        messages: {
          inactivateSuccess: "Classe financeira inativada com sucesso.",
          inactivateError:
            "Não foi possivel inativar classe financeira. Contate o suporte.",
          activateSuccess: "Classe financeira ativada com sucesso.",
          activateError:
            "Não foi possivel ativar classe financeira. Contate o suporte.",
          resetSuccess:
            "Classe financeira redefinado com sucesso, os valores padrões da BovExo foram restaurados.",
          resetError:
            "Não foi possivel redefinir classe financeira. Contate o suporte.",
          resetDefault: "Redefinir valores padrão",
        },
      },
      resultCenter: {
        title: "Tabela de Centros de Resultados",
        buttonNew: "Novo",
        form: {
          title: "Centros de Resultado",
          labelTitle: "Título:",
          labelType: "Tipo:",
          labelStartDate: "Validade Inicial:",
          labelEndDate: "Validade Final:",
          labelName: "Nome",
          labelCode: "Código",
          labelNameColon: "Nome:",
          labelCodeColon: "Código:",
        },
        financialNatureApportionmentForm: {
          title: "Critérios de Rateio de Despesas/Custos Indiretos",
        },
        messages: {
          deleteSuccess: "Centro de Resultado excluído com sucesso",
          deleteError:
            "Não foi possível excluir o Centro de Resultado. Contate o suporte",
          saveSuccess: "Centro de Resultado criado com sucesso",
          updateSuccess: "Centro de Resultado atualizado com sucesso",
          saveError:
            "Não foi possível salvar o Centro de Resultado. Contate o suporte",
          loadError:
            "Não foi possível carregar o centro de resultado. Contate o suporte",
          apportionmentUpdateSuccess: "Rateio atualizado com sucesso",
          apportionmentUpdateError:
            "Não foi possível atualizar o rateio. Contate o suporte",
          apportionmentLoadError:
            "Não foi possível carregar rateio do centro de resultado. Contate o suporte",
          validateError: "Valores devem fechar 100%",
          finalDateBeforeInitial:
            "A Validade Final não pode ser antes da Validade Inicial.",
          noRetreats: "Não existem retiros cadastrados.",
          noOwners: "Não existem proprietários cadastrados.",
          noActivities: "Atividades não informadas.",
          noItems: "Itens não informados.",
        },
        tableColumns: {
          nome: "Nome",
          tipo: "Tipo",
          status: "Status",
          padrao: "Padrão",
        },
        types: {
          activityType: "Atividades",
          retreat: "Retiros",
          farmOwner: "Proprietários",
          custom: "Manual",
        },
      },
      costCenter: {
        title: "Tabela de Centros de Custos",
        buttonNew: "Novo",
        form: {
          title: "Centros de Custos",
          labelTitle: "Título:",
          labelStartDate: "Validade Inicial:",
          labelEndDate: "Validade Final:",
          labelResultCenter: "Centro de Resultado",
          columnClass: "Classe",
          columnName: "Nome",
          apportionmentAutomatic: "Automático",
          apportionmentNumberOfAnimals: "# Animais",
          apportionmentArea: "Área",
        },
        apportionmentForm: {
          title: "Centros de Custo x Centros de Resultado",
        },
        modal: {
          title: "Centros de Custos",
          table: {
            columns: {
              financialClass: "Classe",
            },
          },
        },
        messages: {
          deleteSuccess: "Centro de Custo excluído com sucesso",
          deleteError:
            "Não foi possível excluir o Centro de Custo. Contate o suporte",
          saveSuccess: "Centro de Custo criado com sucesso",
          updateSuccess: "Centro de Custo atualizado com sucesso",
          saveError:
            "Não foi possível salvar o Centro de Custo. Contate o suporte",
          loadError:
            "Não foi possível carregar o centro de custo. Contate o suporte",
          apportionmentUpdateSuccess: "Rateio atualizado com sucesso",
          apportionmentUpdateError:
            "Não foi possível atualizar o rateio. Contate o suporte",
          apportionmentLoadError:
            "Não foi possível carregar informações do centro de custo. Contate o suporte",
          resultCenterLoadError:
            "Não foi possível carregar informações dos centros de resultado. Contate o suporte",
          finalDateBeforeInitial:
            "A Validade Final não pode ser antes da Validade Inicial.",
          noItems:
            "Não é possível salvar o Centro de Custo sem informar todos os itens",
        },
      },
      farmConvertions: {
        messages: {
          currencyCreated: "Moeda cadastrada com sucesso.",
          currencyAlreadyRegistered: "Moeda já cadastrada !",
          currencyFavorited: "Moeda colocada como padrão com sucesso.",
          currencyActivated: "Moeda ativada com sucesso.",
          currencyInactivated: "Moeda inativada com sucesso.",
        },
      },
    },
    animalSell: {
      title: "Transferência/Venda",
      transferPanelTitle: "Trânsferências",
      buttonNew: "Nova Transf./Venda",
      buttonExport: "Resultado de Vendas",
      form: {
        title: "Transferência/Venda",
        animalSelectionDescription:
          "Selecione os animais na tabela para proceder com a venda.",
        sellDate: "Data de saída",
        client: "Cliente",
        financialNatureId: "Natureza",
        financialClassId: "Classe",
        priceNegotiated: "Valor negociado",
        weightPerAnimal: "Peso médio/animal",
        carcassHarnessing: "Ap. carcaça",
        documentNumber: "Nº Doc. Fiscal",
        supplier: "Fornecedor",
        billingDate: "Data do faturamento",
        expirationDate: "Data do vencimento",
        payment: "Pagamento",
        inCash: "À vista",
        part: "Parcelado",
        resultCenter: "Centro de Resultado",
        resultCenterApportionmentDefault: "Padrão",
        resultCenterApportionmentCustom: "Redefinir",
        totalValue: "Fat. Total",
        AVERAGE_COST: "Custo Méd. Atual",
        AVERAGE_MARKET_VALUE: "Valor Méd. Mercado",
        MARGIN_VALUE: "Margem s/ custo",
        MARGIN_VALUE_INFO_TOOLTIP:
          'O valor do campo "Valor Negociado" será o Custo Méd. Atual mais a margem informada.',
        INPUT_PRICE: "Valor Informado",
        AVERAGE_LAST_WEIGHT: "Peso Med Ult. Pesagem",
        AVERAGE_PROGRESSIVE_WEIGHT: "Peso Med Estimado Atual",
        INPUT_WEIGHT: "Peso informado",
        animalTableColumns: {
          handlingNumber: "Identificação",
          lotName: "Lote",
          picketName: "Piquete/Baia",
          breedName: "Raça",
          gender: "Sexo",
          age: "Idade",
          lastDailyWeight: "Último peso",
          lastDailyWeightDate: "Últ Pesagem",
          weightSell: "Peso venda",
          carcassHarnessing: "Aprov. carcaça",
          pricePerKilo: "Preço/Kg",
          pricePerArroba: "Preço/@",
          priceNegotiated: "Preço venda",
          removeAnimal: "Remover",
          removeSelectedAnimals: "Remover selecionados",
        },
        financialIssueId: "Pendêcia Financeira",
        financialPaymentMethodId: "Forma de Pagamento",
        financialTaxableDeductibleId: "Tributável/Dedutivel IR",
        bankAccountFarmId: "Fonte Pagadora",
        carcassType: {
          PERCENTAGE: "%",
          WEIGHT: "Peso",
        },
      },
      table: {
        columns: {
          origin: "Origem",
          isTransfer: "Transf.",
          documentNumber: "Nº Doc. Fiscal",
          client: "Cliente",
          sellDate: "Dt. Venda",
          amountAnimais: "Qtde Animais",
          gender: "Sexo",
          totalValue: "Valor Total",
          averageValue: "Valor/Cabeça",
          carcassHarnessing: "% Aprov. Carcaça",
          paymentType: "Pagamento",
          financialProjectName: "Projetos",
        },
      },
      transferPanelTable: {
        columns: {
          status: "Status",
          originGroupName: "Grupo Origem",
          originFarmName: "Fazenda Origem",
          amountAnimals: "Qtd. Animais",
        },
      },
      messages: {
        errorAtLeastOneAnimal:
          "É necessário ter pelo menos um animal na venda.",
        selectClientText1:
          "Esta transferência de animais envolverá compensação financeira (pagamento) entre as partes?",
        selectClientText2:
          " Detectamos que esta pode ser uma operação de transferência de animais entre unidades de um mesmo grupo econômico. BovExo não controla os aspectos fiscais/legais da operação, mas, para efeitos de análise de resultado de operações, o valor mínimo que será registrado, para efeitos gerais, é o do custo acumulado dos animais tansacionados.",
        infoTooltipText1:
          "Este valor, será calculado, de acordo com o tipo de Valor Negociado, sendo:",
        infoTooltipText2:
          "Valor/@ Negociado: Corresponde ao peso médio dos animais, transformado em @, ou seja, dividido por 15. A quantidade de @ é multiplicada pelo valor da @ negociado com o comprador, multiplicado pelo aproveitamento de carcaça. Desta forma, se tem o valor médio por animal e multiplicado pela quantidade de animais, chegando assim, no valor de faturamento total.",
        infoTooltipText3:
          "Valor/Kg Negociado: Corresponde ao peso médio dos animais, multiplicando pela quantidade de animais e posteriormente multiplicado pelo valor do Kg informado, chegando assim, no valor de faturamento total.",
        successSubmitCreate:
          "A sua Venda está sendo processada, e logo será concluída.",
        errorSubmitCreate:
          "Não foi possível realizar a venda. Contate o suporte.",
        successSubmitUpdate:
          "A atualização da sua Venda está sendo processada, e logo será concluída.",
        errorSubmitUpdate:
          "Não foi possível atualizar a venda. Contate o suporte.",
        error5032:
          'Atenção! Esta venda não pode ser alterada pois sua movimentação financeira foi "Baixada".',
        modalErrorAnimalsWithPreviousEvents:
          "Animais com eventos posteriores à data de venda informada!",
        modalAlertAnimalsInSaleScenarioText1: "Atenção!",
        modalAlertAnimalsInSaleScenarioText2:
          "Existem animais selecionados, que estão associados a Cenários de Vendas Ativos. Ao confirmar a venda, estes Cenário de Venda, serão reprocessados, gerando um novo resultado, somente para os animais ainda ativos.",
        modalConfirmPriceNegotiatedText1:
          'O valor informado no campo "Valor Negociado" é menor que, gerencialmente, deveria ser atribuído.',
        modalConfirmPriceNegotiatedText2: "Confirma o valor?",
        successOnDelete: "Transferência/Venda deletada com sucesso.",
        errorMessageOnDeleteTransferAlreadyConfirmed:
          "Atenção! Esta venda/transferência já foi confirmada na fazenda Destino.",
        errorMessageOnDelete: "Venda não foi deletada. Contate o suporte.",
        modalConfirmFinancialTransactions:
          "Atualizar Movimentação Financeira desta Venda?",
        modalConfirmExpirationDate:
          "Atenção! Data de Vencimento menor que a de Faturamento.",
        error: "Erro",
        errorNoAnimals: "Não é possível continuar sem informar animais",
        errorAnimalsWithoutSaleWeight:
          "Existem animais sem informação de peso de venda",
        errorCarcassHarnessingRange:
          "% Aprov. carcaça deve estar entre 25% e 75,5%",
        errorCarcassHarnessingGreaterThanWeight:
          "Aprov. carcaça não pode ser maior que o peso do animal",
        errorAnimalsWithoutCarcassHarnessing:
          "Existem animais sem informação de % aprov. carcaça",
        errorAnimalsCarcassHarnessingOutOfRange:
          "Existem animais com % aprov. carcaça fora do intervalo permitido 25% até 75,5%",
        errorAnimalsCarcassWeightOutOfRange:
          "Existem animais com peso de carcaça fora do intervalo permitido",
        errorBillingDateBeforeSellDate:
          "Data de faturamento não pode ser anterior à data de saída.",
        errorInvalidInstallments: "Parcelamento inválido!",
        errorInvalidResultCenter: "Centro de Resultado inválido!",
        errorFinancialProjectAfterBillingDate:
          "O projeto financeiro selecionado inicia depois da data de faturamento. Por favor, selecione outro projeto.",
        errorSaleWithEventsAfterDate:
          "Não é permitido venda de animais com eventos posteriores à data de saída!",
        errorRegisterTransaction: "Não foi possível cadastrar transação.",
        modalAnimalLastEventIdentification: "Identificação",
        modalAnimalLastEventEvent: "Evento",
        modalAnimalLastEventDate: "Data",
        ok: "Ok",
        attention: "Atenção",
        generateDocumentTooltip:
          'Gerar "{documentNumber}" único automaticamente.',
      },
    },
    resultCenterAnalysis: {
      filters: {
        resultCenter: "Centro de Resultado",
        costCenter: "Centro de Custo",
        period: "Período",
        visualization: {
          label: "Visualização",
          costing: "Custeio",
          cashFlow: "Fluxo de Caixa",
        },
        buttonConfirm: "Processar",
      },
      income: {
        title: "Receitas",
        costCenterName: "Centro de Custo",
        total: "Valor Total",
        totalPercentage: "Total (%)",
      },
      expense: {
        title: "Despesas",
        costCenterName: "Centro de Custo",
        total: "Valor Total",
        totalPercentage: "Total (%)",
      },
      total: "Resultado",
    },
    messages: {
      deleteSuccess: "Movimentação deletada com sucesso.",
      deleteError: "Movimentação não foi deletada. Contate o suporte.",
      issueResolved: "Pendêcia da Movimentação resolvida.",
      issueReopened: "Pendêcia da Movimentação reaberta.",
      saveSuccess: "Lançamento financeiro salvo com sucesso.",
      updateSuccess: "Lançamento financeiro atualizado com sucesso.",
      saveError: "Houve um erro ao cadastrar transação. Contate o suporte",
      errorTitle: "Erro ao cadastrar",
      projectAfterBillingDate:
        "O projeto financeiro selecionado inicia depois da data de faturamento. Por favor, selecione outro projeto.",
      budgetExceeded: "Valor Orçado para esta Classe foi ultrapassado.",
      budgetWarningTitle: "Atenção!",
      classNotCosting:
        "Lançamentos associados a esta Classe, não são considerados para o Custeio, somente para gestão do Fluxo de Caixa.",
      classNotCostingTitle: "Atenção",
      errorDateExpiration:
        "Atenção! Data de Vencimento menor que a de Faturamento.",
      errorDateConfirm: "Confirmar",
      errorDateCancel: "Cancelar",
      editingTransaction: "Editando transação",
      resultCenterReinform:
        "Por favor, reinforme o rateio do Centro de Resultados.",
      noAnimalsForSale:
        "Para continuar é necessário selecionar pelo menos 1 animal.",
      resultCenterLoadError: "Nenhum centro de resultado encontrado!",
      deleteTransactionConfirm:
        "Ao excluir este movimento, todos os movimentos relacionados ao Documento e Fornecedor/Cliente também serão excluidos",
      saveErrorTitle: "Erro ao salvar",
      saveInvoiceError: "Erro ao salvar nota fiscal. Contate o suporte.",
    },
    table: {
      rateio: "Rateio",
      parcelas: "Parcelas",
      partialPayment: "Pagto. Parcial",
      issueResolved: "Pend. Resolvida",
      issueReopen: "Reativar Pend.",
      valuePaid: "Valor Pago",
      remainingValue: "Valor residual",
      tagOpen: "Em Aberto",
      tagSettled: "Baixado",
      tagConciliated: "Conciliado",
      tagPartialConciliated: "Parc. Conciliado",
      tagExternal: "Externo",
      tagConversion: "Conversão",
      tagPending: "Pendente",
      tagStandard: "Padrão",
      settle: "Baixar",
      removeSettle: "Remover baixa(s)",
      tooltipSettle: "Selecione uma ou mais movimentações para dar baixa",
      tooltipRemoveSettle:
        "Selecione uma ou mais movimentações para remover as baixas",
    },
    apportionmentActivity: {
      title: "Rateio por Atividades",
      totalValue: "Valor total",
      apportionmentType: "Tipo de rateio",
      byHead: "Por Cabeça",
      byPercentage: "Percentual",
    },
    resultCenter: {
      editedLabel: "(Editado)",
      numberOfAnimals: "# Animais",
      area: "Área",
    },
    financialNatureApportionmentForm: {
      natureza: "Natureza",
      rateio: "Rateio",
      numberOfAnimals: "# Animais",
      area: "Área",
      automatic: "Automático",
    },
    resultCenterApportionment: {
      loadError:
        "Não foi possível carregar informações dos centros de resultado. Contate o suporte",
      apportionmentTypeRequired: "Tipo de rateio não informado.",
      apportionmentSumError: "Somatório do rateio deve ser 100%.",
    },
    bankConciliation: {
      statement: {
        fileLoaded: "Arquivo carregado com sucesso",
        fileError: "Erro ao enviar o arquivo",
        fileErrorBankNotRegistered:
          "Erro ao processar o arquivo. Banco não cadastrado.",
        fileErrorAccountNotRegistered:
          "Erro ao processar o arquivo. Conta Bancária não cadastrada.",
        fileErrorAlreadyImported:
          "Erro ao processar o arquivo. Arquivo já foi importado no sistema.",
        statementSaved: "Extrato salvo com sucesso",
        statementSaveError: "Erro ao salvar o extrato",
        selectFile: "Selecione um arquivo",
        selectRecord: "Selecione ao menos um registro para continuar",
      },
    },
    settleModal: {
      messages: {
        fetchError: "Erro ao buscar movimentações financeiras",
        settleSuccess:
          "As movimentações financeiras foram atualizadas e baixadas",
        settleError:
          "Não foi possível baixar as movimentações financeiras. Contate o suporte.",
        unsettleSuccess:
          'As movimentações financeiras foram atualizadas e seu status atualizado para "Em Aberto"',
        unsettleError:
          "Não foi possível atualizar as movimentações financeiras. Contate o suporte.",
        selectFirst: "Você precisa selecionar as movimentações primeiro.",
        dateIncompatibleError:
          "Data da Baixa não compatível com a data de faturamento de {{count}} Mov. Financeira(s).",
        alreadySettledWarningTitle: "Atenção",
        alreadySettledWarningContent:
          "As movimentações que já estavam baixadas, serão atualizadas. Deseja continuar?",
        alreadySettledWarningOk: "Não",
        alreadySettledWarningCancel: "Sim",
        selectOnlySettledError:
          'Por favor, selecione somente movimentações com o status "Baixado".',
        selectOnlyNotPartiallyPaidError:
          "Por favor, selecione somente movimentações que não foram pagas parcialmente.",
        errorTitle: "Erro",
        warningTitle: "Atenção",
      },
    },
    financialClass: {
      messages: {
        saveSuccess: "Classe financeira criada com sucesso.",
        updateSuccess: "Classe financeira atualizada com sucesso.",
        saveError:
          "Erro ao criar/atualizar Classe financeira. Contate o suporte.",
        warningTitle: "Ao confirmar, os itens abaixo devem ser considerados:",
        warningContent:
          'Atualize as informações dessa nova Classe em "Centro de Custo X Centro de Resultado" para todos os Centro de Custos em Parâmetros > Custeio > Centro de Custo, caso contrário, os custos e movimentações desta Classe não serão apropriados.',
      },
    },
    financialProject: {
      messages: {
        alreadyExists:
          "Atenção! Já existe um projeto cadastrado com este nome.",
        saveSuccess: "Projeto Financeiro cadastrado/atualizado com sucesso.",
        saveError: "Erro ao salvar o Projeto Financeiro. Contate o suporte.",
      },
    },
    financialCashFlowBudget: {
      title: "Novo orçamento",
      form: {
        monthYear: "Mês/Ano*",
        activities: "Atividades*",
        defaultCurrency: "Moeda padrão",
        total: "Total:",
        insertUntilMonthYear: "Inserir/Atualizar até Mês/Ano",
      },
      messages: {
        dateError:
          'O mês e o ano do campo "Inserir/Atualizar até Mês/Ano" tem que ser maior que o mês e ano de inicio.',
        valueError: 'É necessário informar um valor para alguma "Classe".',
        saveSuccess: "Orçamento cadastrado com sucesso",
        saveError: "Erro ao cadastrar orçamento. Contate o suporte.",
      },
    },
    importFinancialTransactionNote:
      "Obs. Caso não seja informado um N° de Documento, o sistema irá gerar um número aleatório.",
    importSelectCurrencyLabel: "Selecione a moeda da importação",
    import: {
      messages: {
        templateGenerating:
          "O seu template para importação está sendo gerado e logo será feito o download. Aguarde o download.",
        templateError: "Houve um erro ao gerar template. Contate o suporte.",
        importedAndUpdated:
          "Movimentações financeiras importadas e atualizadas",
        importedAndUpdatedDesc:
          'Houve algumas mov. financeiras que foram atualizadas/inseridas. Acesse o menu "Importações" aba "Mov. Financeiras" para ver os detalhes.',
        imported: "Movimentações financeiras importadas",
        partiallyImported: "Movimentações financeiras importadas parcialmente",
        partiallyImportedDesc:
          'Houve algumas mov. financeiras que não foram importadas. Acesse o menu "Importações" aba "Mov. Financeiras" para ver os detalhes.',
        processedWithError: "Arquivo processado com erro !",
        processedWithErrorDesc:
          'Todos as mov. financeiras não foram importados. Acesse o menu "Importações" aba "Mov. Financeiras" para ver os detalhes.',
        importError: "Erro ao importar",
        importErrorDesc: "Nenhuma mov. financeira foi incluído.",
      },
    },
    partialPayment: {
      messages: {
        saveSuccess: "Foi salvo o pagamento parcial com sucesso.",
        saveError:
          "Não foi possível salvar o pagamento parcial. Contate o suporte.",
        valueExceedsError:
          'O valor do campo "Valor Pag. Parcial" deve ser menor que o valor de {{value}} da movimentação financeira original.',
      },
    },
    export: {
      messages: {
        dateError:
          "Data de vencimento não pode ser anterior à data de faturamento.",
        exportError: "Error interno. Contate o suporte!",
      },
    },
    dashboard: {
      form: {},
      messages: {
        loadError: "Erro ao retornar resultado do painel financeiro!",
        projectsNotFound: "Nenhum projeto financeiro encontrado!",
        resultCenterNotFound: "Nenhum centro de resultado encontrado!",
        costCenterNotFound: "Nenhum centro de custo encontrado!",
      },
    },
  },
  costs: {
    messages: {
      depreciationRequired:
        "É obrigatório informar o valor da Depreciação nos custos que foram preenchidos com o seu valor.",
    },
  },
  costType: {
    AllTypes: "Todos",
    Growth: "Cria",
    RecreateFattenPasture: "R&E - Pasto",
    RecreateFattenSemiConfinement: "R&E - Semi-Confinamento",
    RecreateFattenConfinement: "R&E - Confinamento",
    Agriculture: "Agricultura",
    Others: "Outros",
  },
  buttons: {
    assign: "Atribuir",
    back: "Voltar",
    next: "Próximo",
    save: "Salvar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    login: "Logar",
    buttonNewProfitCenter: "Nova atividade",
    buttonNewFarm: "Nova fazenda",
    buttonNewSupplier: "Novo fornecedor",
    yes: "Sim",
    no: "Não",
    putToDeath: "Colocar em óbito",
    allocateLot: "Alocar lote",
    download: "Download",
    processWeights: "Processar pesagens",
    processAnimals: "Processar animais",
    processSupplements: "Processar suplementos",
    processVaccinations: "Processar veterinários",
    edit: "Editar",
    editing: "Editando",
    addInfo: "Informar dados",
    delete: "Deletar",
    useAsFavorite: "Utilizar como favorito",
    generate: "Gerar",
    putToDiscard: "Descartar",
    process: "Processar",
    accept: "Aceitar",
    reject: "Rejeitar",
    clickInEdit: 'Clique em <span className="red">"editar"</span>',
    updateTable: "Atualizar tabela",
    viewAll: "Visualizar todos",
    add: "Adicionar",
    close: "Fechar",
    activate: "Ativar",
    inactivate: "Inativar",
  },
  topbar: {
    title: "Administração  ",
    group: {
      title: "Grupos",
      subtitle: "Selecione um grupo",
      submenus: {
        farm: "Fazenda(s)",
        add_farm: "ADICIONAR FAZENDA",
      },
    },
    question: {
      title: "Dúvidas",
      submenus: {},
    },
    notification: {
      title: "Notificações",
      submenus: {},
      footer: "Ver todos",
    },
    add: {
      title: "Adicionar",
      submenus: {
        profit_center: "Atividade",
        picket: "Piquete / Baia",
        picketSupplementSupply: "Novo/Editar Fornecimento",
        user: "Usuário",
        balance: "Balança",
        sell_and_buy: "Cenário de compra e venda",
        animal: "Animal",
        lotProduction: "Lote de produção",
        buy: "Compra",
        birth: "Nascimento",
        importAnimalsWeights: "Importar pesagens",
        importAnimals: "Importar animais",
        importSupplements: "Importar suplementos",
        importFinancialTransactions: "Importar mov. financeiras",
        importSuppliersClients: "Importar fornecedores/clientes",
        importAnimalCoverage: "Importar coberturas e DG's",
        importAnimalBirth: "Importar partos e perdas",
        importVaccinations: "Importar veterinários",
        downloadBovManager: "Dowload BovManager",
      },
    },
    language: {
      title: "Tradução",
      submenus: {
        pt_br: "Português - BR",
        en: "Inglês - US",
        es: "Espanhol - ES",
      },
    },
    user: {
      title: "Usuário",
      submenus: {
        edit_profile: "Editar perfil",
        change_user: "Trocar usuário",
        change_password: "Trocar senha",
        add_new_user: "Adicionar usuário",
        signout_application: "Sair do Aplicativo",
      },
    },
    search: {
      title: "Pesquisa",
      submenus: {
        user: "Usuário",
        profit_center: "Atividade",
        picket: "Piquete / Baia",
        balance: "Balança",
        animal: "Animal",
        buy: "Compra",
        birth: "Nascimento",
      },
    },
  },
  table: {
    menu: {
      makeStandard: "Definir como Padrão",
      edit: "Editar",
      details: "Detalhes",
      delete: "Excluir",
      inactivate: "Inativar",
      activate: "Ativar",
      addAnimalsToLotProduction: "Adicionar animais",
      dismemberLotProduction: "Desmembrar Lote",
      allocateLotToPicket: "Alocar lote ao piquete / baia",
      putPicketInMaintenance: "Fazer manutenção",
      putPicketInBreak: "Descansar",
      putPicketInRenovation: "Reformar",
      setBaseline: "Definir como Padrão",
      movePickets: "Mov. Piquetes/Baias",
      classify: "Classificar",
    },
  },
  error: {
    formError: "Por favor, preencha os campos obrigatórios(*) corretamente.",
    noGroupSelected: "Selecione um grupo no menu superior",
    sisbovInvalidTitle: "Sisbov inválido",
    sisbovInvalidMessage: "O número SISBOV deve conter no mínimo 15 caracteres",
  },
  notifications: {
    types: {
      newObject: "Novo objeto",
      purchase: "Compra",
      sale: "Venda",
      alert: "Alerta",
      warning: "Aviso",
      other: "Outro",
    },
    drawer: {
      title: "Suas notificações e alertas",
      buttonVilualizeAll: "MARCAR TODOS COMO LIDA",
      buttonLoadOldNotifications: "Carregar antigas",
      notificationsNotRead: "notificações não lidas",
      tabNotificationTitle: "Notificações",
      tabAlertTitle: "Alertas",
    },
  },
  sessionExpired: {
    title: "Sua sessão expirou!",
    message:
      "Para manter sua conta segura, periodicamente checamos sua presença,faça login novamente",
    titleAlmostExpired: "Sua sessão irá expirar em breve!",
    messageAlmostExpired:
      "Para manter sua conta segura, periodicamente checamos sua presença, não esqueça de salvar o que esta fazendo antes da sessão expirar",
    buttonLogout: "Deslogar agora",
    buttonConfirm: "Ok, entendi",
    toExpire: "para expirar...",
  },
  sidebar: {
    home: "Home",
    farm: "Fazendas",
    profit_center: "Atividades",
    picket: "Retiros/Piquetes",
    lot: "Lotes",
    animal: "Animais",
    decision: "Decisões",
    parameters: "Parâmetros",
    imports: "Importações",
    administration: "Administração",
    suppliers: "Fornecedores",
    operations: "Operações",
    breed: "Raças",
    handling: "Manejos",
    diet: "Dietas",
    pasture: "Pastos",
    supplement: "Suplementos/Concent.",
    adminAndUser: "Colaboradores da fazenda",
    userInvite: "Convites de acesso",
    client: "Clientes",
    cattleProducer: "Produtores",
    payment: "Pagamentos",
    supplierManagement: "Gestão de fornecedores",
    financial: "Movimentações Financeiras",
    stock: "Estoque de Insumos",
    feedFactory: "Fábrica de Ração",
    report: "Relatórios",
  },
  languages: {
    pt_br: "PT",
    en: "IN",
    es: "ES",
  },
  status: {
    active: "Ativo",
    inactive: "Inativo",
    dismembered: "Desmembrado",
    pendingData: "Dados pendentes",
    informedData: "Dados informados",
    pending: "Pendente",
    processing: "Processando",
    completed: "Completado",
    refused: "Rejeitado",
    error: "Erro",
    transfer: "Transferido",
    dead: "Morto",
    sold: "Vendido",
    processed: "Processado",
    bovexo: "Bovexo",
    confirmed: "Confirmado",
    classified: "Classificado",
  },
  productionSubSystem: {
    semiIntensive: "Semi-Intensivo",
    intensive: "Intensivo",
    extensive: "Extensivo",
    SI: "Semi-Intensivo",
    I: "Intensivo",
    E: "Extensivo",
    Extensive: "Extensivo",
    SemiIntensive: "Semi-Intensivo",
    Intensive: "Intensivo",
  },
  productionSystem: {
    fatten: "Engorda",
    create: "Cria",
    recreate: "Recria",
  },
  kpi: {
    capacity: "Lotação",
    production: "Produção",
    cost: "Custo",
    margin: "Margem",
    gdp: "GPD",
    enjoy: "Desfrute",
    carbonFootprint: "Pegada Carbônica",
    disbursement: "Desembolso Cab/Mês",
    weanCalf: "Kg Bez. Desm / Kg Vaca",
    iep: "IEP",
    reproductiveEfficiency: "Eficiência Reprodutiva",
    weanCalfCost: "Custo Bezerro Desmamado",
    discardedCows: "Vacas Descartadas",
    assetValue: "Valor do Ativo",
    incrementalMargin: "Margem Incremental",
    tooltips: {
      tooltipCapacity:
        "A Lotação é a relação (em %) da quantidade atual de cabeças alocadas e a capacidade total, conforme definido no cadastro das baias de confinamento.",
      tooltipEnjoy:
        "A taxa de desfrute mede a capacidade do rebanho em gerar excedente (@) em um determinado espaço de tempo.",
      tooltipProduction: "Quantidade de @ produzida por hectare/ano.",
      tooltipGDP: "Ganho de Peso Diário, desde a entrada no animal da Fazenda.",
      tooltipMargin: "Margem de lucro esperada por @ produzida.",
      tooltipCost: "Custo de Produção da @.",
      tooltipCarbonFootprint:
        "Meta de emissão máxima em Kg de CO₂E por Kg de Ganho de Peso.",
      tooltipDisbursement:
        "Desembolso Cabeça/Mês dos animais atualmente em cada subsistema de produção.",
      tooltipAssetValue: "Valor ativo.",
      tooltipIncrementalMargin: "Margem incremental.",
      tooltipWeanCalf:
        "Indicador da proporção do peso dos animais na desmama, em relação às fêmeas de reprodução aptas a reprodução. São consideradas, como aptas, as fêmeas de finalidade “Reprodução” e que atendam os parâmetros reprodutivos.",
      tooltipIEP:
        "Intervalo entre partos das fêmeas de reprodução, que tenham parido ao menos 2 vezes (Secundíparas)",
      tooltipReproductiveEfficiency:
        "Eficiência Reprodutiva final das fêmeas expostas, considerando a Taxa de Prenhez (TP), Taxa de nascimento (TN) e Taxa de Desmama (TD).",
      tooltipWeanCalfCost:
        "Custo do bezerro desmamado, incluindo todos os custos incorridos pela vaca e pelo bezerro.",
      tooltipDiscardedCows: "% de vacas descartadas no período.",
    },
  },
  zipCodeValid: "CEP encontrado",
  zipCodeInvalid: "CEP não encontrado",
  defaultSelectPlaceholder: "Selecione uma opção",
  defaultMultiSelectPlaceholder: "Selecione uma ou mais opções",
  defaultDatePickerPlaceholder: "Selecione uma data",
  defaultPlaceholder: "Informe um valor",
  filters: {
    applyFilter: "APLICAR FILTRO",
    cleanFilter: "Limpar filtro",
    filterBy: "Filtrar por",
    filterByOptions: {
      age: "Idade",
      gender: "Sexo",
      breed: "Raça",
      supplier: "Fornecedores",
      farmOwner: "Proprietários",
    },
    compareBy: "Comparar por",
    value: "Valor(es)",
    male: "Macho",
    female: "Fêmea",
    min: "Mínimo",
    max: "Máximo",
    equal: "Igual",
    greaterThan: "Maior igual que",
    lessThan: "Menor igual que",
    between: "Entre",
  },
  groupAndFarmModal: {
    hello: "Olá",
    groupSelectedLabel: "Selecione um grupo de fazendas",
    groupSelectedPlaceHolder: "Selecione um grupo",
    farmSelectedLabel: "Selecione uma fazenda",
    farmSelectedPlaceHolder: "Selecione uma fazenda",
    buttonAccessFarm: "Acessar fazenda",
  },
  importAnimalWeights: {
    title: "Importar histórico de pesagens e medições",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com as pesagens deste lote, <strong>faça a importação</strong> em seguida e clique em processar pesagens</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
    importType: {
      label: "Selecione o tipo de importação:",
      weights: "Importar Pesagens",
      weightsAndMeasurements: "Importar Pesagens e Medições",
    },
  },
  importAnimals: {
    title: "Importar animais ao lote de produção",
    message:
      '<p class="message">Selecione um lote de produção, faça <strong>download do template abaixo, complete a planilha</strong> com os animais que compõe o lote, <strong>faça a importação</strong> em seguida e clique em processar animais</p>',
    messageForDifferentsLots:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com os animais e seus respectivos lotes, <strong>faça a importação</strong> em seguida e clique em processar animais</p>',
    messageForIdentifyAnimals:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com os animais e seus respectivos lotes e códigos de lote de recebimento, <strong>faça a importação</strong> em seguida e clique em processar animais</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
    helpMessage:
      'Importar animais por lote e fornecedor: Informe na planilha o Lote e Fornecedor para cada animal. Desta forma, é possível importar animais de diferentes fornecedores e para mais de um Lote de Produção. O Fornecedor e o Lote de Produção devem ser cadastrados previamente, sendo que deverá ser utilizado na planilha o campo "Identificação do Lote" para o Lote de Produção, enquanto para o Fornecedor, informe o "CPF/CNPJ" de seu cadastro.\nImportar animais para um único lote e fornecedor: Selecione um Lote de Produção e um Fornecedor já cadastrado. Se o animal a ser importado é de origem da própria fazenda, selecione a opção "Animal(is) fornecido(s) pela própria fazenda".',
  },
  invoiceUploadViewer: {
    buttons: {
      loadXml: "Carregar Xml",
      loadPdf: "Carregar Pdf",
      viewDocument: "Visualizar Documento",
    },
    errors: {
      parseXml:
        "Não foi possível ler o arquivo XML. Verifique se é uma NF-e válida.",
      parsePdf:
        "Não foi possível ler o arquivo PDF. Verifique se é uma DANFE válida.",
    },
    drawer: {
      title: "Documento Fiscal",
      emitter: {
        title: "Emitente",
        razaoSocial: "Razão Social",
        nomeFantasia: "Nome Fantasia",
        cnpj: "CNPJ",
        ie: "Inscrição Estadual",
        municipioUf: "Município/UF",
      },
      identification: {
        title: "Identificação da NF-e",
        accessKey: "Chave de Acesso",
        protocol: "Protocolo",
        status: "Status SEFAZ",
        number: "Número",
        series: "Série",
        issueDate: "Data de Emissão",
        exitEntryDate: "Data Saída/Entrada",
        operationNature: "Natureza da Operação",
      },
      recipient: {
        title: "Destinatário",
        razaoSocial: "Razão Social",
        cnpj: "CNPJ/CPF",
        municipioUf: "Município/UF",
      },
      taxes: {
        title: "Cálculo do Imposto",
        products: "Valor Produtos",
        freight: "Valor Frete",
        insurance: "Valor Seguro",
        discount: "Desconto",
        ipi: "Valor IPI",
        icms: "Valor ICMS",
        pis: "Valor PIS",
        cofins: "Valor COFINS",
        others: "Outras Desp.",
        total: "Total da NF",
      },
      items: {
        title: "Itens",
        code: "Código",
        description: "Descrição",
        ncm: "NCM",
        cfop: "CFOP",
        unit: "Un.",
        quantity: "Qtd.",
        unitValue: "Vl. Unit.",
        totalValue: "Vl. Total",
        empty: "Sem itens",
      },
    },
  },
  error404: {
    title: "ERRO 404",
    subTitle: "Página não encontrada",
    button: "Ir à Home",
  },
  months: {
    january: "Janeiro",
    jan: "Jan",
    february: "Fevereiro",
    feb: "Feb",
    march: "Março",
    mar: "Mar",
    april: "Abril",
    apr: "Abr",
    may: "Maio",
    mmay: "Mai",
    june: "Junho",
    jun: "Jun",
    july: "Julho",
    jul: "Jul",
    august: "Agosto",
    aug: "Ago",
    september: "Setembro",
    sep: "Sep",
    october: "Outubro",
    oct: "Out",
    november: "Novembro",
    nov: "Nov",
    december: "Dezembro",
    dec: "Dez",
  },
  notInformed: "Não informado",

  Profile: {
    drawerTitle: "Dados Pessoais",
    form: {
      fullName: "Nome Completo",
    },
  },
  scenarePage: {
    title: "Cenários Boitel",
    table: {
      column: {
        clientID: "Client ID",
        name: "Nome Cenário",
        createdAt: "Data Criação",
        updatedAt: "Data Ult. Atualiz.",
        status: "Status",
        labelStatus: {
          hired: "Contratado",
          saved: "Salvo",
        },
      },
      detailsRow: {
        rangeWeight: "Faixa Peso",
        amountAnimals: "Qtde Animais",
        entryDate: "Data Entrada",
        exitDay: "Data Saída",
        daysOfStay: "Qtd Diárias",
        dailyPrice: "Preço Dia",
        dietStrategy: "Dieta",
        carcassHarnessing: "Aprov. Carcaça - %",
        totalIncome: "Receita Total",
        incomeForCab: "Receita/Cab",
        marginForCab: "Lucro/Cab",
      },
    },
  },
  boitelContractsPage: {
    title: "Contratos",
    buttonNewContract: "Novo Contrato",
    buttonExportContractsReport: "Exportar Relatório de Contratos",
    buttonExportContractsSaleResultReport:
      "Exportar Relatório de Resultado de Venda",
    table: {
      menu: {
        selectAnimals: "Selecionar Animais",
      },
      column: {
        identificationContract: "Número Contrato",
        customerName: "Produtor",
        dateContract: "Data Contrato",
        finalDateContract: "Prazo Contrato",
        status: "Status",
        statusOptions: {
          vigente: "Vigente",
          encerrado: "Encerrado",
          pendente: "Pendente",
          erro: "Erro",
        },
        amountAnimals: "Qtd. Animais",
        selectedAnimals: "Animais Selec.",
        animalGender: "Sexo Animais",
        animalGenderOptions: {
          vaca: "Vaca",
          V: "Vaca",
          novilha: "Novilha",
          N: "Novilha",
          machoInteiro: "Macho Inteiro",
          I: "Macho Inteiro",
          machoCastrado: "Macho Castrado",
          C: "Macho Castrado",
        },
        entryWeight: "Peso Entrada",
        contractDays: "Dias Cont.",
        consecutiveDays: "Dias Cor.",
        fileUrl: "Arquivo",
        contractType: "Tipo Contrato",
        contractTypeOptions: {
          daily: "Diária",
          dryMatterConsume: "Cons. MS",
          arrobaProduction: "@ Produz.",
          partnership: "Parceria",
        },
      },
    },
    detailsDrawer: {
      title: "Detalhes do Contrato Boitel",
      tabs: {
        general: "Informações Gerais",
        animals: "Animais Selecionados",
      },
      errorLoadingAnimals: "Erro ao carregar animais.",
      emptyAnimals: "Nenhum animal selecionado para este contrato.",
    },
    deleteModal: {
      title: "Confirmar exclusão",
      content: "Tem certeza que deseja excluir este contrato?",
      success: "Contrato excluído com sucesso",
      error: "Erro ao excluir contrato",
    },
    selectAnimals: {
      title: "Selecionar Animais do Contrato",
      relateButton: "Relacionar",
      footerTotalSelected: "Animais selecionados para o contrato:",
      herdsColumn: "Conjunto",
      summaryTitle: "Resumo por conjunto",
      animalsLabel: "animais",
      cardEdit: "Editar",
      cardDelete: "Excluir",
      deleteConfirmTitle: "Excluir relacionamento",
      deleteConfirmText:
        "Deseja excluir o relacionamento deste conjunto com o contrato?",
      relateDrawerEditTitle: "Editar relacionamento do conjunto",
      noAnimalsToSave: "Nenhum animal relacionado para salvar.",
      saveSuccess: "Animais do contrato salvos com sucesso.",
      saveError: "Erro ao salvar animais do contrato.",
      errorLoadingAnimals: "Erro ao carregar animais.",
      relateDrawer: {
        title: "Relacionar animais ao conjunto",
        selectHerd: "Conjunto do contrato",
        selectHerdPlaceholder: "Selecione o conjunto",
        selectHerdRequired: "Selecione um conjunto.",
        entryDateType: "Data de entrada",
        entryDateSingle: "Data única para todos",
        entryDatePerAnimal: "Data específica por animal",
        entryDate: "Data de Entrada",
        entryDateRequired: "Informe a data de entrada.",
        entryDateAllRequired:
          "Informe a data de entrada para todos os animais.",
        selectedAnimalsList: "Animais selecionados",
        validationExceedsAmount:
          "A quantidade de animais selecionados ultrapassa a quantidade do conjunto.",
        validationNoSlots:
          "Não há vagas suficientes no conjunto para os animais selecionados.",
        validationBreedMismatch:
          "Existem animais com raças diferentes do previsto no conjunto selecionado.",
      },
    },
    form: {
      titleCreate: "Novo Contrato",
      titleEdit: "Editar Contrato",
      successCreate: "Contrato criado com sucesso",
      successUpdate: "Contrato atualizado com sucesso",
      errorSave: "Erro ao salvar contrato",
      carcassPercentageRangeError: "% Aprov. Carcaça deve estar entre 40 e 70.",
      errorLoading: "Erro ao carregar contrato",
      sections: {
        contractData: "Dados do Contrato",
        client: "Cliente",
        herd: "Rebanho",
        contractType: "Tipo Contrato",
      },
      identificationContract: "Identificação Contrato",
      identificationContractPlaceholder: "Digite a identificação do contrato",
      contractDate: "Data",
      contractDateTooltip: "Data de início de vigência do contrato.",
      initialDateContract: "Data Inicial",
      initialDateContractTooltip:
        "Data prevista de início da entrada dos Lotes de Animais.",
      fileUrl: "Arquivo",
      uploadFile: "Selecionar arquivo",
      cattleProducer: "Produtor",
      multipleFarm: "Fazenda",
      cattleProducerFarm: "Fazenda do Produtor",
      cattleProducerFarmPlaceholder: "Selecione a fazenda",
      cattleProducerFarmRequired:
        "É preciso selecionar uma fazenda do produtor",
      cattleProducerRequired: "É preciso selecionar um produtor",
      addHerd: "Adicionar Rebanho",
      herdsRequired: "É necessário adicionar pelo menos um rebanho",
      contractType: "Tipo",
      contractTypePlaceholder: "Selecione o tipo de contrato",
      herds: {
        cjt: "CJTO",
        amountAnimals: "Qtd",
        amountAnimalsPlaceholder: "Quantidade",
        breed: "Raça",
        breedPlaceholder: "Selecione a raça",
        gender: "Sexo/Categoria",
        genderPlaceholder: "Selecione o gênero",
        genderOptions: {
          vaca: "Vaca",
          novilha: "Novilha",
          machoInteiro: "Macho Inteiro",
          machoCastrado: "Macho Castrado",
        },
        weightAverage: "Peso Médio",
        weightAveragePlaceholder: "Peso médio",
        useSisbov: "Sisbov",
        trace: "Id. Individual?",
        entryDate: "Data Entrada",
        farm: "Fazenda",
        farmPlaceholder: "Selecione a fazenda",
        supplement: "Dieta",
        supplementPlaceholder: "Selecione a dieta",
      },
      herdForm: {
        title: "Adicionar/Editar Rebanho",
      },
      dailyContract: {
        cjt: "CJTO",
        amountAnimals: "Qtd. Animais",
        numberOfDays: "N° Diárias",
        numberOfDaysPlaceholder: "Número de diárias",
        protocolValue: "Protocolo Sanitário",
        protocolValuePlaceholder: "Valor protocolo",
        fixedValue: "Valor Fixo",
        fixedValuePlaceholder: "Valor fixo",
        dietValue: "Valor Dieta",
        dietValuePlaceholder: "Valor dieta",
        otherValue: "Outros",
        otherValuePlaceholder: "Outros valores",
        dailyValue: "Valor Diária",
        dailyValuePlaceholder: "Valor diária",
        observation: "Observação",
        observationPlaceholder: "Digite uma observação",
        prevCost: "Custo Previsto",
      },
      dryMatterConsumeContract: {
        measurement: "Medição",
        preFixed: "Pré-Fixado",
        provision: "Fornecimento",
        report: "Informe",
        cjto: "Cjto",
        unique: "Única",
        cjt: "CJTO",
        averageOffer: "Oferta Média",
        averageOfferPlaceholder: "Oferta média",
        numberOfDays: "N° Diárias",
        numberOfDaysPlaceholder: "Número de diárias",
        value: "Valor",
        costPerKilogramDryMatterPlaceholder: "Valor por KgMS",
        valuePlaceholder: "Valor",
      },
      arrobaProductionContract: {
        report: "% Aprov. Carcaça Informe",
        byLot: "Por Lote",
        unique: "Único",
        cjt: "CJTO",
        carcassHarnessingPercentage: "% Aprov. Carcaça Entrada",
        carcassHarnessingPercentagePlaceholder: "% Aprov. Carcaça Entrada",
        valuePerArroba: "Valor @",
        valuePerArrobaPlaceholder: "Valor @",
      },
      partnershipContract: {
        partnershipType: "Tipo de parceria",
        partnerPercentage: "Percentual do parceiro",
        numberOfDays: "N° Diárias",
        numberOfDaysPlaceholder: "Número de diárias",
        partnershipTypeOptions: {
          CARCASS_HARNESSING: "% Aprov. de Carcaça",
          ARROBA_PRODUCTION: "@ Produzida",
        },
        report: "Informe",
        byLot: "Por Lote",
        unique: "Único",
        cjt: "CJTO",
        carcassEntryPercentage: "% Aprov. Carcaça Entrada",
        carcassEntryPercentagePlaceholder: "% Aprov. Carcaça Entrada",
        agreedWeightLabel: "Selecione Peso Acordado",
        agreedWeightPvFaz: "PV Faz.",
        agreedWeightPvConf: "PV Conf.",
        maxBreak: "Quebra Máxima Permitida",
        maxBreakPlaceholder: "Quebra máxima",
      },
    },
    tabs: {
      contracts: "Contratos",
      slaughterSchedule: "Programação",
    },
  },
  slaughterSchedule: {
    title: "Programação de Abate",
    errorLoading: "Erro ao carregar dados de programação",
    drawer: {
      title: "Detalhes do Lote",
    },
    table: {
      column: {
        status: "Status",
        statusOptions: {
          active: "Ativo",
          inactive: "Inativo",
          sold: "Vendido",
        },
        picketName: "Piquete/Baia",
        lotName: "Lote",
        type: "Tipo",
        contractTypeOptions: {
          daily: "Diária",
          dryMatterConsume: "Cons. MS",
          arrobaProduction: "@ Produz.",
          partnership: "Parceria",
          own: "Próprio",
        },
        ownType: "Próprio",
        producerPartner: "Produtor/Parceiro",
        animalsAmount: "Qtde Animais",
        gender: "Sexo",
        genderOptions: {
          male: "Macho",
          female: "Fêmea",
          both: "Ambos",
        },
        breed: "Raça",
        entryDate: "Data Entrada",
        entryWeight: "Peso Entrada",
        contractForecast: {
          blockTitle: "Previsão Contrato",
          forecastAdg: "GMD Prev.",
          currentForecastWeight: "Peso Atual Prev.",
          stayTime: "Tempo Perm.",
          slaughterWeight: "Peso Abate",
          slaughterDays: "Dias Abate",
          slaughterDate: "Data Abate",
        },
        saleScenarioBlock: {
          blockTitle: "Cenário de Venda BovExo",
          projectedWeightEd: "Peso Proj. ED",
          saleScenario: "Cenário de Venda",
          cvProcessingDate: "Data Processamento CV",
          suggestedSaleDate: "Data Sugerida de Venda",
          estimatedSaleWeight: "Peso Estimado de Venda",
        },
      },
    },
  },
  boitelSaleScenario: {
    title: "Cenários venda",
    result: "Resultado(s)",
    btn: {
      newScenare: "Novo Cenário",
    },
    table: {
      column: {
        scenare: "Cenário",
        client: "Cliente",
        favorite: "Favorito",
        status: "Status",
        actions: "Ações",
        labelStatus: {
          analyzing: "Avaliando",
          processed: "Processado",
          canceled: "Cancelado",
          partialCanceled: "Cancelado Parc.",
          sold: "Vendido",
          partialSold: "Vendido Parc.",
        },
      },
      detailsRow: {
        identification: "Identificação",
        saleAnimals: "Animais à vender",
        receive: "A receber",
        margin: "Margem",
        processedAt: "Processado às",
      },
    },
    new: {
      title: "Criação: Boitel Venda",
      tabs: {
        lots: {
          title: "Seleção de lotes",
        },
        dietStrategy: {
          title: "Seleção de estratégia de dieta",
        },
        parameters: {
          title: "Definição dos parâmetros",
          form: {
            name: "Nome do cenário*",
            animalsInTruck: "Animais no caminhão*",
            minimumAge: "Idade minima para venda*",
            maximumAge: "Idade máxima para venda*",
            minimumWeight: "Peso minimo para venda*",
            maximumWeight: "Peso máximo para venda*",
            useDefaultMaximumWeight: "Peso máximo para venda*",
            allowSeparateSell: "Lotes podem sofrer descasca?",
            goalType: "Objetivo do cenário*",
            commitments: "O cenário possui algum compromisso?",
            newCommitment: "Adicionar novo compromisso",
            marketAnalysisId: "Análise de mercado*",
            useCustomCarcassHarnessing: "Informar novo % de Aprov. de Carcaça?",
            useCustomCarcassHarnessingHelp:
              "Por padrão, o sistema utiliza o % de Aproveitamento de Carcaça informado no processo de contratação dos animais.",
            carcassHarnessing: "Aprov. de Carcaça",
          },
        },
      },
    },
    edit: {
      title: "Edição: Boitel Venda",
    },
    details: {
      messageSelectDates:
        "Selecione uma(s) data(s) sugeridas no calendário para visualizar as informações dos animais.",
      calendarSuggested: "Calendário sugerido",
      weekDateNull: "Animais com violação Boitel",
      animalsToSell: "Animais a vender",
      planningIncome: "Receita planejada",
      dietStrategiesSuggested: "Estrat. de dieta sugerida",
      commitments: "Compromissos",
      violations: "Violações",
      parameters: "Parâmetros do cenário",
      marketValues: "Referência de valores",
      violationAge: "Idade",
      violationWeight: "Peso",
      violationBoitel: "Boitel",
      violationMinAge: "Idade mínima",
      violationMaxAge: "Idade máxima",
      violationMinWeight: "Peso mínimo",
      violationMaxWeight: "Peso máximo",
      table: {
        columns: {
          animalHandlingNumber: "Identificação",
          sellDate: "Data sugerida",
          weight: "Peso estim.",
          lastDailyWeight: "Último peso",
          averageWeightGain: "GMD",
          aggregateArroba: "@Liq. agregadas",
          saleIncome: "Receita",
          aggregateIncome: "Receita Agregada",
          cost: "Custo",
          aggregateMargin: "Lucro agregado",
          margin: "Lucro",
        },
      },
    },
  },
  importSupplements: {
    title: "Importar suplementos",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com os suplementos, <strong>faça a importação</strong> em seguida e clique em processar suplementos</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
  },
  importSuppliersClients: {
    title: "Importar fornecedores/clientes",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com os fornecedores/clientes, <strong>faça a importação</strong> em seguida e clique em processar</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
    groupFarmVisibility: "Onde os fornecedores/clientes serão importados?",
    success: {
      title: "Fornecedores/Clientes importados",
      description: "A importação foi processada com sucesso.",
    },
    error: {
      title: "Erro ao importar",
      description: "Nenhum fornecedor/cliente foi incluído.",
    },
  },
  eventLog: {
    fromValueLabel: "Modificado de",
    toValueLabel: "para",
    dateLabel: "Data",
    attributeLabel: "Propriedade",
    userLabel: "Usuário",
    nullLabel: "vazio",
    Supplement: {
      createdAt: "Criação do registro: ",
      name: "Nome",
      type: "Tipo",
      classification: "Classificação",
      industrialName: "Nome Industrial",
      status: "Situação",
      cost: "Custo",
      cp: "PB",
      tdn: "NDT",
      npn: "NNP",
      dryMatterPercentage: "MS",
      nitrogen: "Nitrogênio",
      calcium: "Cálcio",
      phosphorus: "Fósforo",
      zinc: "Zinco",
      sodium: "Sódio",
      minimumVoluntaryConsumption: "Consumo Vonluntário (Mínimo)",
      maximumVoluntaryConsumption: "Consumo Vonluntário (Máximo)",
      voluntaryConsumptionType: "Unidade",
      minimumPure: "Oferta Pura (Mínimo)",
      maximumPure: "Oferta Pura (Máximo)",
      minimumPureTrough: "Cocho Recomendado (Mínimo)",
      maximumPureTrough: "Cocho Recomendado (Máximo)",
      pureConsumptionType: "Unidade",
      minimumMix: "Oferta Mistura (Mínimo)",
      maximumMix: "Oferta Mistura (Máximo)",
      minimumMixTrough: "Cocho Recomendado (Mínimo)",
      maximumMixTrough: "Cocho Recomendado (Máximo)",
      mixConsumptionType: "Unidade",
      currentVersion: "Versão",
      proportion: "Proporção",
      additiveEffect: "Efeito Aditivo",
      additiveEffectUnit: "Unidade Efeito Aditivo",
      fda: "FDA",
      lignin: "Lignina",
      ee: "Extrato Etéreo",
    },
  },
  reproductionParameters: {
    title: "Parâmetros de Reprodução",
    parameters: {
      IDADE_INICIO_FASE_REPRODUTIVA: "Idade para início da fase reprodutiva*",
      PERIODO_DESCANSO_POS_PARTO: "Período de descanso pós parto*",
      TEMPO_APOS_COBERTURA_PARA_DG:
        "Tempo pós cobertura para Diagnóstico de Gestação*",
      TOURO_COBERTURAS_DESCONHECIDAS: "Touro de Coberturas Desconhecidas*",
      IDADE_DESMAMA: "Idade para Desmama*",
      CONSISTIR_TEMPO_GESTACAO_NO_PARTO:
        "Ao lançar partos de IA, com tempo de gestação acima do parametrizado, lançar automaticamente um MC/Repasse, de TOURO DESCONHECIDO, utilizando o tempo médio de gestação?*",
    },
    reproductionPeriod: {
      title: "Estações de Monta",
      titleHelper:
        "A Estação de Monta é o período reprodutivo da propriedade, sendo iniciado no D0 do protocolo do primeiro Lote de IATF e finalizando no Diagnostico de Gestação Final.",
    },
    score: {
      title: "Score de Probabilidade de Sucesso Reprodutivo",
      titleHelper:
        "Defina, com base na escala de 1 a 9 de score, a probabilidade em % de sucesso reprodutivo. Este score, será aplicado na tabela para geração da Curva de Idade X Peso X Score.",
    },
    breedScore: {
      title: "Curva de Idade X Peso X Score",
      titleHelper:
        "Defina para as Fêmeas de Reprodução, considerando a Idade, Peso Atual e Score de Probabilidade de Sucesso Reprodução, as variáveis necessárias para cálculo do custo para, até a próxima Estação de Reprodutiva, atingir cada score.",
      form: {
        title: "Nova entrada (Raça X Idade X Peso X Score)",
        breedId: "Raça*",
        age: "Idade*",
        startWeight: "Peso inicial*",
        endWeight: "Peso final*",
        weight: "Peso",
        score: "Score*",
        errors: {
          errorWithFieldWeights:
            'Existem alguns pesos sem "Score". Preencha-los para salvar o formulário.',
        },
      },
    },
  },
  semen: {
    title: "Listagem de Sêmens",
    buttonNewSemen: "Novo Sêmen",
    table: {
      columns: {
        name: "Nome",
        registration: "Registro",
        breedName: "Raça",
      },
    },
    form: {
      titleCreateNewSemen: "Novo Sêmen",
      titleEditSemen: "Editar Sêmen",
      name: "Nome",
      registration: "Registro",
      breedId: "Raça",
      genealogy: "Genealogia",
      father: "Pai",
      mother: "Mãe",
      identification: "Identificação",
    },
  },
  movimentAnimals: {
    title: "Movimentação entre lotes",
    description:
      'Selecione os animais na tabela e clique no botão "Movimentar" para realocar os animais',
    buttonMovementAnimals: "Movimentar",
    form: {
      title: "Nova movimentação - Lote de Destino",
    },
  },
  closedSalesReport: {
    form: {
      title: "Resultado de Vendas",
      salesPeriod: "Período das Vendas",
      clientId: "Cliente",
      supplierId: "Fornecedor",
      saleScenarioId: "Cenário de Venda(s)",
      animalGender: "Sexo",
      showOriginData: "Exibir origem dos animais vendidos?",
      dailyOperationalCostMode: "Diária Operacional",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "Calculado Custeio BovExo",
        USER_DEFINED: "Definido pelo Usuário (R$/Dia)",
      },
      additionalSlaughterCostValue: "Custos Adicionais de Abate",
    },
  },
  exportFinancialTransactions: {
    modal: {
      title: "Exportar movimentações financeiras",
      billingPeriod: "Faturamento",
      expirationPeriod: "Vencimento",
      suppliers: "Fornecedor(es)",
      costActivities: "Atividade(s)",
      clients: "Cliente(s)",
      transactionType: "Tipo",
      financialProjectId: "Projeto Financeiro",
      status: "Status",
    },
  },
  unit: {
    title: "Listagem de Unidades",
    buttonNew: "Nova Unidade",
    table: {
      columns: {
        name: "Abreviatura",
        description: "Descrição",
        basicUnit: "Unidade Básica",
        multiplier: "Multiplicador",
        status: "Status",
        createdAt: "Data Criação",
        createdBy: "Responsável Criação",
      },
    },
    form: {
      titleCreateNew: "Nova Unidade",
      titleEdit: "Editar Unidade",
      groupFarmVisibility: "Quem irá utilizar a Unidade?",
      name: "Abreviatura",
      description: "Descrição",
      basicUnit: "Unidade Básica",
      multiplier: "Multiplicador",
      status: "Status",
    },
  },
  measurement: {
    title: "Listagem de Medições",
    buttonNew: "Nova Medição",
    table: {
      columns: {
        name: "Nome",
        code: "Código",
        status: "Status",
        createdAt: "Data Criação",
        createdBy: "Responsável Criação",
      },
    },
    form: {
      titleCreateNew: "Nova Medição",
      titleEdit: "Editar Medição",
      name: "Nome",
      code: "Código",
      status: "Status",
      nameRequired: "Nome é obrigatório",
      codeRequired: "Código é obrigatório",
    },
  },
  veterinary: {
    title: "Listagem de Insumos Veterinários",
    buttonNew: "Novo insumo veterinário",
    table: {
      columns: {
        name: "Nome Comercial",
        type: "Tipo",
        supplierId: "Fornecedor",
        supplierName: "Fornecedor",
        status: "Status",
        createdAt: "Data Criação",
        createdBy: "Responsável Criação",
      },
    },
    form: {
      titleCreateNew: "Novo Insumo Veterinário",
      titleEdit: "Editar Insumo Veterinário",
      groupFarmVisibility: "Quem irá utilizar o Insumo Veterinário?",
      name: "Nome Comercial",
      type: "Tipo",
      supplierId: "Fornecedor",
      applicationGender: "Sexo",
      applicationAge: "Idade",
      applicationType: "Forma de Aplicação",
      applicationValue: "Qtd. de Aplicação",
      applicationWeightValueParam: "Peso",
      unitId: "Unidade de uso",
      applicationCost: "Custo Aplicação",
      status: "Status",
    },
  },
  handlingReproduction: {
    title: "Manejos",
    tabs: {
      reproductiveProtocol: "Protocolos",
      coverage: "Cobertura",
      pregnancyDiagnosis: "Diagnóstico de Gestação",
      animalBirth: "Partos e Perdas",
    },
    dashboards: {
      dashboardReproductionPeriod: {
        reproductionPeriodSelected: "Estação de Monta",
        lotIdsSelected: "Lotes",
        totalFemalesSuitable: "Fêmeas Aptas",
        totalCoverageFemales: "Fêmeas Trabalhadas",
        totalInserminatedFemales: "Fêmeas Inseminadas",
        totalInserminations: "N° de Inserminações",
        totalCoverageIatfPlusRepasseFemales: "Fêmeas sob Repasse",
        totalPregnancyFemales: "Fêmeas Prenhas",
        pregnancyRate: "Taxa de Prenhes",
        totalFemalesWithNoResult: "Sem Resultado",
        totalFemalesWithGestationalLosses: "Perdas Gestacionais",
      },
    },
  },
  handlingReproductionCoverage: {
    title: "Listagem de Coberturas",
    buttonHandlingReproductionCoverage: "Nova Cobertura",
    type: {
      iatf: "IA/IATF",
      repasse: "MC/REPASSE",
    },
    table: {
      columns: {
        animalHandlingNumber: "Fêmea",
        coverageDate: "Data",
        type: "Tipo",
        maleHandlingNumber: "Reprodutor",
        semenNameAndRegistration: "Sêmen",
        semenOrMaleIdentification: "Reprodutor/Sêmen",
        lotName: "Lote",
        dose: "Dose",
        reproductionPeriodDescription: "Estação de Monta",
        inseminatorName: "Inseminador",
        pregnancyDiagnosisResult: "Resultado",
        semenDeparture: "Partida",
        observation: "Observação",
        bodyConditionScore: "ECC",
        last_weight: "Última Pesagem",
        last_weight_date: "Data da Última Pesagem",
        animal_farm_function: "Finalidade",
      },
    },
    form: {
      type: "Tipo",
      animalId: "Identificação",
      category: "Categoria",
      femaleSituation: "Situação",
      semenDeparture: "Partida",
      observation: "Observação",
      bodyConditionScore: "ECC",
      semenId: "Sêmen",
      maleId: "Reprodutor",
      dose: "Dose",
      inseminatorId: "Inseminador",
      coverageDate: "Data da Cobertura",
      reproductionPeriodId: "Estação de Monta",
    },
    errorsAndMessages: {
      successMessage: "Cobertura salva/atualizada com sucesso!",
      femaleWithoutReproductionAge:
        "Fêmea não possui idade para início da fase reprodutiva, deseja continuar?",
      femaleDontHaveAgeToCoverage:
        "Atenção! Fêmea não tem idade suficiente para esta cobertura.",
      reproductionPeriodWithoutCurrentDate:
        "Atenção! Necessário ter uma Estação de Monta cadastrada no período da cobertura.",
      errorFemaleWithFutureCoverages: `Atenção! Fêmea possui coberturas em datas posteriores.`,
      errorFemaleWithCoverageInSameDateAndType:
        "Atenção! Cobertura já registrada anteriormente.",
      errorInternalError:
        "Erro ao fazer o cadastro/atualizar cobertura. Contate o suporte.",
    },
  },
  inseminator: {
    title: "Listagem de Inseminadores",
    buttonNewInseminator: "Novo Inseminador",
    table: {
      columns: {
        name: "Nome",
        code: "Código",
        status: "Status",
      },
    },
    form: {
      titleCreateNewInseminator: "Novo Inseminador",
      titleEditInseminator: "Editar Inseminador",
      name: "Nome",
      code: "Código",
    },
  },
  multipleBull: {
    title: "Touros Múltiplos",
    buttonNewMultipleBull: "Novo Touro Múltiplo",
    table: {
      columns: {
        name: "Nome",
        code: "Código",
        males: "Reprodutores",
        formationDate: "Data de Formação",
        status: "Status",
      },
    },
    form: {
      titleCreateNewMultipleBull: "Novo Touro Múltiplo",
      titleEditMultipleBull: "Editar Touro Múltiplo",
      name: "Nome",
      code: "Código",
      males: "Reprodutores",
      formationDate: "Data de Formação",
      status: "Status",
    },
  },

  ovarianResult: {
    SemAvaliacao: "Sem Avaliação",
    CorpoLuteo: "Corpo Lúteo",
    Foliculo: "Folículo",
    Cisto: "Cisto",
    Anestro: "Anestro",
    Normal: "Normal",
    Reabsorvendo: "Reabsorvendo",
    Gemelar: "Gemelar",
  },
  animalPregnancyDiagnosis: {
    title: "Diagnóstico de Gestação",
    buttonNew: "Novo Diagnóstico de Gestação",
    table: {
      columns: {
        animalHandlingNumber: "Fêmea",
        lotOriginalName: "Lote",
        diagnosisDate: "Data do DG",
        result: "Resultado",
        ovarianEvaluationResult: "Avaliação Ovariana",
      },
      export: {
        columns: {
          handling_number: "Identificação",
          tag_id: "Identificação Eletrônica",
          sisbov: "SISBOV",
          name: "Nome",
          status: "Status",
          last_lot: "Último Lote",
          move_date: "Data de Movimentação",
          current_lot: "Lote Atual",
          last_pregnancy_diagnosis_date: "Data Penúltimo DG",
          last_pregnancy_diagnosis_result: "Resultado Penúltimo DG",
          last_pregnancy_diagnosis_ovarian_evaluation_result:
            "Resultado Penúltimo DG Avaliação Ovariana",
          current_pregnancy_diagnosis_date: "Data Último DG",
          current_pregnancy_diagnosis_result: "Resultado Último DG",
          current_pregnancy_diagnosis_ovarian_evaluation_result:
            "Resultado Último DG Avaliação Ovariana",
          current_birth_date: "Data Último Parto",
          current_birth_type: "Tipo de Parto",
        },
      },
    },
    form: {
      titleCreateNew: "Novo Diagnóstico de Gestação",
      titleEdit: "Editar Diagnóstico de Gestação",
      diagnosisDate: "Data do Diagnóstico",
      animalId: "Identificação",
      animalReproductionCategory: "Categoria",
      femaleSituation: "Situação",
      lastCoverage: "Última cobertura",
      lotName: "Lote Atual",
      result: "Resultado",
      ovarianEvaluationResult: "Avaliação Ovariana",
      lastCoverageReproductionPeriodId: "Estação de Monta",
      lotDestination: "Lote Destino",
      timeGestationMC: "Tempo de Gestação MC",
      gestationDays: "Tempo de Gestação",
      birthForecast: "Previsão de Parto",
      shouldDiscardFemale: "Descartar Fêmea?",
      discardMotive: "Causa",
      defineCoverage: "Definir Cobertura",
      selectCoverageTitle: "Selecione a cobertura responsável pela prenhes:",
      coverageModalDate: "Data",
      coverageModalReproductor: "Reprodutor",
      coverageModalGestationDays: "Gestação(dias)",
      coverageModalInputPlaceholder: "Digite",
      newEntry: "Novo lançamento",
      editEntry: "Editar lançamento",
    },
    messages: {
      deleteSuccess: "Diagnóstico de gestação deletado com sucesso!",
      deleteErrorWithBirth:
        "Não é possível excluir o Diagnóstico de Gestação por ter registro de Parto.",
      deleteError:
        "Não foi possível deletar Diagnóstico de gestação. Contate o suporte.",
      saveSuccess: "Diagnóstico de Gestação salvo com sucesso!",
      validResultRequired: "Informe um resultado válido: Positivo ou Negativo",
      ovarianResultRequired: "Informe um resultado para a Avaliação Ovariana",
      selectCoverage:
        'Selecione uma cobertura através do botão "Definir Cobertura".',
      inconsistentGestationDays:
        "Atenção! Tempo de Gestação informado inconsistente, por compreender período em que a fêmea já possui cobertura(s) com resultado(s).",
      duplicateDiagnosisDate:
        "Atenção! Já existe um diagnóstico de gestação na mesma data selecionada.",
    },
  },
  animalWeightHistory: {
    title: "Lista de Pesagens",
    buttonExport: "Análise de Pesagens",
    buttonNew: "Nova Pesagem",
    table: {
      columns: {
        origination: "Origem",
        handlingNumber: "Animal",
        date: "Data",
        weight: "Peso",
        originationLotName: "Lote",
        originationPicketName: "Piquete",
        event: "Tipo",
      },
    },
    originEvents: {
      birthday: "Nascimento",
      sale: "Venda",
      weaning: "Desmama",
      purchase: "Compra",
    },
    form: {
      titleCreateNew: "Adicionar Pesagem",
      titleEdit: "Editar Pesagem",
      animalId: "Identificação Animal",
      date: "Data da Pesagem",
      weight: "Peso",
      gmd: "GMD",
      lotOriginalId: "Lote Atual",
      lotDestinationId: "Lote Destino",
      lastDateWeight: "Data da Última Pesagem",
      lastWeight: "Última Pesagem",
      weaningWeight: "Desmama?",
      editIdentifications: "Editar Identificações?",
    },
    modalExportReport: {
      title: "Análise de Pesagens",
      periodDate: "Período das Pesagens",
      gender: "Sexo",
      status: "Status dos Animais",
      periodAge: "Idade(meses)",
      lotId: "Lote",
      supplierId: "Fornecedor",
      listAnimalsWithoutWeight: "Listar animais sem pesagem no período?",
      showProjectedWeight:
        "Apresentar o peso projetado pela Estratégia de Dieta na Data atual?",
    },
    messages: {
      successMessage: "Pesagem salva/atualizada com sucesso!",
      errorMessage: "Erro ao salvar/atualizar pesagem. Contate o suporte.",
      error5029Message:
        "Atenção! Animal já possui uma movimentação entre lotes em data posterior.",
      weaningWeightError:
        "Atenção! Não é possível marcar a pesagem como desmama. O animal pode ter mais de 12 meses ou já ter peso de desmame.",
      deleteSuccess: "Pesagem deletada com sucesso!",
      deleteError: "Pesagem não foi deletada. Contate o suporte.",
      alreadyInLot: "Atenção! Animal já se encontra neste Lote.",
    },
  },
  animalMeasurement: {
    title: "Lista de Medições",
    buttonNew: "Nova Medição",
    tabs: {
      weights: "Pesagens",
      measurements: "Medições",
    },
    table: {
      columns: {
        origination: "Origem",
        handlingNumber: "Animal",
        breedName: "Raça",
        gender: "Sexo",
        measurementDate: "Data",
        originationLotName: "Lote",
        originationPicketName: "Piquete/Baia",
        measurementName: "Medição",
        value: "Valor",
      },
    },
    origination: {
      bovManager: "BovManager",
      import: "Importação",
      manual: "Manual",
    },
    gender: {
      M: "Macho",
      F: "Fêmea",
    },
    export: {
      columns: {
        status: "Status",
        handlingNumber: "Identificação",
        tagId: "Id. Eletrônico",
        gender: "Sexo",
        breedName: "Raça",
        lastWeightDate: "Data Última Pesagem",
        lastWeight: "Última Pesagem",
        measurementDate: "Data Avaliação",
        measurementName: "Medição",
        value: "Valor",
        tempPerm: "Temp. Perm.",
        exitDate: "Data de Saída",
        exitWeight: "Peso Saída",
      },
      filters: {
        status: "Status",
        gender: "Sexo",
        breed: "Raça",
        measurementDate: "Data Avaliação",
        measurement: "Medição",
        value: "Valor da Medição",
        lot: "Lote",
        picket: "Piquete/Baia",
      },
      statusOptions: {
        active: "Ativos",
        sold: "Vendidos",
        dead: "Mortos",
      },
      genderOptions: {
        male: "Machos",
        female: "Fêmeas",
      },
    },
    form: {
      titleCreateNew: "Nova Medição",
      titleEdit: "Editar Medição",
      date: "Data",
      measurement: "Medição",
      value: "Valor",
      currentLot: "Lote Atual",
      gender: "Sexo",
      breed: "Raça",
      lotDestination: "Lote Destino",
      lastMeasurement: "MEDIÇÃO ANTERIOR",
      lastDate: "Data da última medição",
      lastValue: "Valor da última medição",
      saveOptions: {
        onlySave: "Salvar somente",
        saveAndAddNew: "Salvar e adicionar nova medição",
      },
      messages: {
        successMessage: "Medição salva com sucesso!",
        errorMessage: "Erro ao salvar a medição. Tente novamente.",
        deleteSuccess: "Medição excluída com sucesso!",
        deleteError: "Erro ao excluir a medição. Tente novamente.",
      },
    },
  },
  dailyLiveCattlesDataAgro: {
    codes: {
      D_PEPR_GO_BR: "@ GO",
      D_PEPR_MG_BR: "@ MG",
      D_PEPR_MT_BR: "@ MT",
      D_PEPR_MS_BR: "@ MS",
      D_PEPR_SP_BR: "@ SP",
      D_PEPR_RO_BR: "@ RO",
      D_PEPR_TO_BR: "@ TO",
      D_PEPR_PA_BR: "@ PA",
      D_PEPR_BA_BR: "@ BA",
      D_PEPR_MT_N_BR: "@ MT N",
      D_PEPR_MT_S_BR: "@ MT S",
      D_PEPR_MT_NE_BR: "@ MT NE",
      D_PEPR_MT_SE_BR: "@ MT SE",
    },
  },
  animalBirth: {
    title: "Listagem de Partos e Perdas Reprodutivas",
    buttonNew: "Novo Parto/Perda",
    table: {
      columns: {
        matrizAnimalHandlingNumber: "Matriz",
        birthDate: "Data do parto",
        type: "Tipo",
        coverageDate: "Dt. Cobertura",
        coverageType: "Tipo Cobertura",
        reproductor: "Reprodutor",
        child_handling_number: "Cria",
        child_gender: "Gênero",
        child_birthday_weight: "Peso Nascimento",
        child_situation: "Situação",
        child_weaning_weight: "Peso Desmama",
        child_weaning_date: "Dt. Desmama",
        iep: "Interv. Partos",
        childs: {
          handlingNumber: "Identificação",
          gender: "Sexo",
          birthdayWeight: "Peso Nascimento",
          situation: "Situação",
        },
      },
    },
    types: {
      parto: "Parto",
      aborto: "Aborto",
      morteEmbrionaria: "Morte Embrionária",
    },
    form: {
      titleCreateNew: "Novo Parto/Perda",
      titleEdit: "Editar Parto/Perda",
      matrizAnimalId: "Identificação",
      type: "Tipo",
      birthDate: "Data",
      animalReproductionCategory: "Categoria",
      femaleSituation: "Situação",
      gestationDays: "Tempo de Gestação",
      coverageInfoType: "Tipo",
      coverageInfoDate: "Data",
      coverageInfoGestationTime: "Tempo de Gestação",
      coverageInfoBirthForecast: "Prev. Parto",
      coverageInfoReprodutor: "Reprodutor",
      coverageInfoDGDate: "Data do DG",
      coverageInfoDGResult: "Resultado do DG",
      shouldDiscardFemale: "Descartar Fêmea?",
      discardMotive: "Causa",
      lotMatrizDestinationId: "Lote de Produção",
      observation: "Observações",
      child: {
        nickname: "Nome",
        nicknamePlaceHolder: "Nome",
        sisbov: "SISBOV",
        sisbovPlaceHolder: "SISBOV",
        tagId: "Id. Eletrônica",
        tagIdPlaceHolder: "Id. Eletrônica",
        sex: "Sexo",
        male: "Macho",
        female: "Fêmea",
        acquisition: "Aquisição",
        handlingNumber: "Identificação",
        handlingNumberPlaceHolder: "N. de identificação do animal",
        breed: "Raça",
        breedPlaceHolder: "Selecione uma raça",
        cap: "Animal castrado?",
        birthday: "Data de nascimento",
        birthdayWeight: "Peso Nascimento",
        firstInseminationWeight: "Primeira inserminação",
        weaningWeight: "Peso Desmame",
        weaningDate: "Data Desmame",
        asymptoticWeight: "Peso Assintótico",
        asymptoticWeightInfoTooltip:
          "Peso assintótico é o peso que, com base nas informações que o usuário/produtor possui, sobre o histórico do Animal ou Lote de Animais, (considerando a genética, manejo anterior, interação genótipo-ambiente, frame, entre outras variáveis), acredite ser o potencial limite de peso. Ou seja, acima deste peso, dificilmente este animal ganhará peso, em condições normais.",
        acquisitionDate: "Data de aquisição",
        acquisitionEstimatedWeight: "Peso aquisição",
        carcassHarnessing: "Aproveitamento da Carcaça",
        animalFarmFunction: "Finalidade",
        animalReproductionCategory: "Categoria",
        sisbovIdentificationDate: "Data Identificação",
        sisbovInsertBNDDate: "Data Inclusão BND",
        sisbovSlaughterDate: "Data Liberação Abate",
        lotId: "Lote de Produção",
        farmOwner: "Proprietário",
        purchaseCost: "Valor de Entrada",
        stillborn: "Natimorto?",
      },
      newEntry: "Novo lançamento",
      editEntry: "Editar lançamento",
      newChild: "Nova Cria",
      childTab: "Cria",
      defineCoverage: "Definir Cobertura",
      selectCoverageTitle: "Selecione a cobertura responsável pela prenhes:",
      coverageModalDate: "Data",
      coverageModalReproductor: "Reprodutor",
      coverageModalGestationDays: "Gestação(dias)",
      coverageModalInputPlaceholder: "Digite",
      childStatusNatural: "Vivo",
      childStatusStillborn: "Nat.",
      coverageDataTitle: "Dados Cobertura",
    },
    messages: {
      deleteSuccess: "Parto deletado com sucesso!",
      deleteError: "Erro ao deletar parto.",
      deleteErrorWithChilds:
        "Este parto não pode ser excluído, pois a cria ({{childs}}) contem registros após a data de criação.",
      saveSuccess: "Parto salvo com sucesso!",
      saveErrorConflict:
        "Atenção! Este parto não pode ser salvo, existem conflitos de datas entre os eventos reprodutivos.",
      saveError: "Erro ao salvar Parto, contate o suporte.",
      selectCoverage:
        'Selecione uma cobertura através do botão "Definir Cobertura".',
      inconsistentGestationDays:
        "Atenção! Tempo de Gestação informado inconsistente, por compreender período em que a fêmea já possui cobertura(s) com resultado(s).",
      minGestationViolation:
        "Atenção! Tempo de gestação inferior ao tempo mínimo ({{days}} dias), definido nos parâmetros da raça da Matriz. Operação cancelada!",
      maxGestationViolation:
        "Atenção! Tempo de gestação superior ao tempo máximo ({{days}} dias), definido nos parâmetros da raça da Matriz. Operação cancelada!",
      gestationDaysRequired: 'Informe um valor para o campo "Gestação(dias)"',
    },
    discardMotives: {
      age: "Idade",
      reproductiveProblems: "Problemas Reprodutivos",
      diseaseOrPhysicalProblems: "Doenças ou Problemas Físicos",
      bodyCondition: "Condição corporal",
      negativePregnancy: "Prenhez Negativa",
      maternalAbility: "Habilidade Materna",
    },
    modal: {
      maleOperationError: "Esta operação não pode ser feitas em Machos!",
      gestationDaysError:
        "Data do parto está {differenceDays} dias acima do tempo máximo de gestação ({maxGestationDaysBreed} dias).",
      femaleAgeError: "Fêmea não possui idade para início da fase reprodutiva.",
      fattenFemaleConfirm: "Fêmea de finalidade Engorda, deseja continuar?",
      changeToReproductionConfirm: "Deseja alterar a fêmea para Reprodução?",
      emptyFemaleConfirm: "Fêmea vazia. Deseja fazer o Parto?",
    },
  },
  animalVaccination: {
    messages: {
      animalNotFound: "Nenhum animal encontrado!",
      saveSuccess: "Aplicação foi criada/atualizada com sucesso.",
      saveError: "Aplicação não foi criada/atualizada. Contate o suporte",
    },
  },
  animalReproductionState: {
    solteira: "Solteira",
    parida: "Parida",
  },
  animalReproductionCategory: {
    nulipara: "Nulípara", // Nulíparas, são fêmeas de reprodução, desmamadas, que não foram trabalhadas (inseminadas ou colocadas à disposição do touro).
    novilha: "Novilha", // Novilhas, são fêmeas de reprodução, desmamadas, que foram trabalhadas, mas inda não pariram.
    primipara: "Primípara", // Primíparas, são fêmeas de reprodução, que tiverem 1 parto.
    secundipara: "Secundípara", // Secundíparas, são fêmeas de reprodução, que tiverem 2 partos.
    multipara: "Multípara", // Multíparas, são fêmeas de reprodução, que tiveram 3 ou mais partos.
    // Macho
    reprodutor: "Reprodutor", // Reprodutor: Macho destinado para uso na reprodução.
  },
  femaleSituation: {
    vazia: "Vazia",
    prenha: "Prenha",
    servida: "Servida",
  },
  animalFarmFunction: {
    reproduction: "Reprodução",
    fatten: "Engorda",
  },
  birthTypes: {
    parto: "Parto",
    aborto: "Aborto",
    morteEmbrionaria: "Morte Embrionária",
  },
  animalStatus: {
    A: "Ativo",
    Active: "Ativo",
    S: "Vendido",
    Sold: "Vendido",
    D: "Morto",
    Dead: "Morto",
    I: "Inativo",
    Inactive: "Inativo",
    T: "Transferido",
    Transfer: "Transferido",
    P: "Pendente",
    Pending: "Pendente",
  },
  animalMovementEvents: {
    weight: "Pesagem",
    vacination: "Vacinação",
    coverage: "Cobertura",
    pregnancyDiagnosis: "Diagnóstico de Gestação",
    birth: "Parto",
    discard: "Descarte",
    lotEntry: "Entrada no Lote",
  },
  financialClass: {
    buttonNew: "Nova Classe",
    form: {
      titleCreateNew: "Nova Classe",
      titleEdit: "Editar Classe",
      financialNatureId: "Natureza",
      name: "Nome",
      shouldCost: "Considerado para Custeio?",
      shouldDisbursement: "Considerado para Desembolso?",
      depreciation: "Depreciação",
      costCenterName: "Centro de Custo",
      externalIntegrationCode: "Código de Integração",
    },
  },
  financialNature: {
    buttonNew: "Nova Natureza",
    form: {
      titleCreateNew: "Nova Natureza Financeira",
      titleEdit: "Editar Natureza Financeira",
      name: "Nome",
      type: "Tipo",
      typeIncome: "Receita",
      typeExpense: "Despesa",
      stock: "Estoque",
      stockTooltip:
        "Selecione se esta natureza financeira está relacionada a estoque.",
      canBudget: "Pode Orçar?",
      canBudgetTooltip:
        "Selecione se esta natureza financeira pode ser utilizada em orçamentos.",
      externalIntegrationCode: "Código de Integração",
      scope: "Escopo",
      scopeFarm: "Fazenda Atual",
      scopeGroup: "Grupo",
    },
    messages: {
      createSuccess: "Natureza financeira criada com sucesso.",
      updateSuccess: "Natureza financeira atualizada com sucesso.",
      error: "Erro ao criar/atualizar Natureza financeira. Contate o suporte.",
      adjustResultCenterWarning:
        "Recomendamos ajustar os Centros de Resultados criados para a fazenda, após salvar a natureza financeira.",
    },
  },
  costCenterDefaultNames: {
    PRODUCAO_ANIMAL: "Produção Animal",
    UTILIDADES: "Utilidades",
    INFRAEST_PRODUTIVA: "Infraest. Produtiva",
    INFRAEST_OPERACIONAL: "Infraest. Operacional",
    INFRAEST_APOIO: "Infraest. Apoio",
    TAXA_IMPOSTOS: "Taxas & Impostos",
    SERVICOS: "Serviços",
    INVSUMOS_OPERACIONAIS: "Insumos Operacionais",
    PRODUCAO_PASTO_AGRICOLA: "Produção Pasto/Agrícola",
  },
  financialProject: {
    title: "Projetos Financeiros",
    buttonNew: "Novo Projeto",
    messages: {
      deleteSuccess: "Projeto financeiro deletado com sucesso.",
      errorTitle: "Erro",
      linkedError:
        "Este Projeto Financeiro não pode ser excluído, ele já está ligado a Movimentações Financeiras.",
      deleteError: "Erro ao deletar projeto financeiro.",
    },
    table: {
      columns: {
        name: "Nome Projeto",
        description: "Observações",
        startProjectDate: "Data Início",
        finishProjectDate: "Término",
        status: "Status",
      },
    },
    form: {
      titleCreateNew: "Novo Projeto Financeiro",
      titleEdit: "Editar Projeto Financeiro",
      name: "Nome Projeto",
      description: "Observações",
      startProjectDate: "Data Início",
      finishProjectDate: "Término",
      status: "Ativo?",
    },
  },
  animalGender: {
    Female: "Fêmea",
    Male: "Macho",
  },
  lotItemEntry: {
    form: {
      entryDate: "Data de Entrada",
      amountAnimals: "Quantidade",
      averageWeight: "Peso Médio",
      ageInDays: "Idade (dias/meses/anos)",
      usePrefixedIdentification: "Usar identificação com prefixo",
      prefixIdentification: "Prefixo para Identificação",
      initialIdentificationSequence: "Sequência inicial de identificação",
      lotDestinationId: "Lote Destino",
      animalFarmFunction: "Finalidade",
      animalReproductionCategory: "Categoria",
    },
  },
  picketSupplyForecast: {
    buttonOpen: "Editar Previsão",
    title: "Editar Previsão de Fornecimento",
    forecastDate: "Data da previsão",
    table: {
      picket: "Baia/Piquete",
      lot: "Lote",
      baseDayTotalSupplied: "Ofertado (dia-base)",
      supplyNumber: "Trato",
      recipe: "Receita",
      calculatedQuantity: "Calculado",
      quantity: "A ofertar",
      realizedTooltip: "Trato já realizado nesta data",
      restoreCalculated: "Voltar ao valor calculado",
      empty: "Nenhuma baia na previsão desta data",
    },
    messages: {
      noSupply: "Não há fornecimento no dia anterior à data escolhida.",
      loadError: "Houve um erro ao carregar a previsão. Entre em contato com o suporte.",
      nothingToSave: "Nenhuma alteração para salvar.",
      saveSuccess: "Previsão salva com sucesso.",
      saveError: "Houve um erro ao salvar a previsão. Entre em contato com o suporte.",
    },
  },
  picketSupplementSupply: {
    title: "Fornecimento",
    buttonNew: "Informe de Fornecimento",
    table: {
      columns: {
        supplyDate: "Data",
        picketsCount: "Piquetes/Baias",
        totalSupplementSupplied: "Total Ofertado(Kg)",
        responsibleName: "Responsáveis",
        subTable: {
          retreatName: "Retiro/Linha",
          picketName: "Piquetes/Baias",
          lotName: "Lote",
          totalAnimals: "Qtde. Animais",
          supplementName: "Suplemento/Ração",
          weightedAverageDryMatter: "%MS",
          totalSupplementSupplied: "Qtde. Ofertada",
          productionSubSystem: "Subsistema de Produção",
          subTable: {
            supplyNumber: "N° Trato",
            supplementName: "Suplemento/Ração",
            dryMatterPercentage: "%MS",
            quantitySupplied: "Qtde. Ofertada",
            responsibleName: "Responsável",
            version: "Versão",
            prevSupplyHourInMinutes: "Hora prev.",
            supplyHourInMinutes: "Hora real",
            readFeederValue: "Leitura de Cocho",
          },
        },
      },
    },
    form: {
      titleCreateNew: "Novo/Editar Fornecimento",
      titleEdit: "Editar Fornecimento",
      filtersTitle: "Filtros",
      speedersTitle: "Aceleradores",
      applyFilterHint:
        "Ao clicar em Aplicar, os dados da seção 'Fornecimento' serão sobreescritos pelos os piquetes filtrados.",
      applyDefaultsHint:
        "Ao clicar em Aplicar, os campos da seção 'Fornecimento' que estiverem vazios serão sobreescritos pelos os valores escolhidos nos campos ao lado.",
      supplyDate: "Data",
      supplyNumber: "N° Trato",
      responsibleName: "Responsável",
      retreats: "Retiro/Linha",
      pickets: "Piquetes/Baias",
      lots: "Lotes",
      subSystems: "Subsistema de Produção",
      quantitySupplied: "Qtde Ofertada",
      supplement: "Suplemento/Ração",
      hourSupplied: "Horário de Fornecimento",
      searchPicketOrLot: "Buscar piquete/baia ou lote",
      noResults: "Nenhum resultado encontrado.",
      current: "Atual",
      previous: "Anterior",
      applyPreviousValue: "Aplicar valor anterior",
      saveOptions: {
        only_save: "Salvar somente",
        save_and_create_new: "Salvar e criar novo fornecimento",
      },
      tableSupplies: {
        picketName: "Piquete/Baia",
        lotName: "Lote",
        animalsCount: "Qtd. Animais",
        avgWeight: "Peso Estim.",
        avgGdp: "GDP Estim.",
        supplementId: "Suplemento/Ração",
        dryMatterPercentage: "MS: Matéria Seca",
        quantitySupplied: "Qtd. Ofertada",
        prevSuppliedPerAnimal: "Prev. cab/dia",
        prevSuppliedDryMatterByWeight: "Prev. MS %PV",
        prevSupplyHourInMinutes: "Hora Prev.",
        supplyHourInMinutes: "Hora Real",
        observation: "Observação",
      },
    },
    dashboard: {
      picketId: "Piquetes/Baias",
      lotId: "Lotes",
      periodType: "Período",
      startDate: "Data Início",
      endDate: "Data Fim",
      exibitionType: "Exibição",
      exibitionTypeOptions: {
        column: "Colunas/Barra",
        line: "Linha",
      },
      buttonProcessDashboard: "Filtrar/Processar Gráfico",
    },
  },
  partialPayment: {
    title: "Criar Pagamento Parcial",
    form: {
      valuePartialPayment: "Valor Pag. Parcial",
      settleDate: "Data Baixa",
      expirationDate: "Nova Data Vencimento",
      valuePendingPayment: "Valor Pend. Pgto",
      fees: "Valor Juros/Multas",
    },
  },
  financialDashboard: {
    resultCenter: "Centro de Resultado",
    costCenter: "Centro de Custo",
    costType: "Atividade",
    period: "Período",
    financialProject: "Projeto",
    bankAccount: "Conta Bancária",
    buttonConfirm: "Processar",
    periods: {
      lastSevenDays: "Últimos 7 dias",
      lastThirdyDays: "Últimos 30 dias",
      currentMonth: "Mês Atual",
      lastMonth: "Mês Anterior",
      currentYear: "Ano Atual",
      lastYear: "Ano Anterior",
      currentHarvest: "Safra Atual",
      lastHarvest: "Safra Anterior",
      customDateRange: "Especificar Data",
    },
  },
  animalHandlingAlert: {
    title: "Alertas de Manejo",
    buttonNew: "Novo Alerta",
    table: {
      columns: {
        status: "Status",
        handlingNumber: "Animal",
        visualizationType: "Tipo de Visualização",
        message: "Mensagem",
      },
    },
    form: {
      titleNew: "Novo Alerta de Manejo",
      titleEdit: "Editar Alerta de Manejo",
      animals: "Animais",
      message: "Mensagem",
      visualizationType: {
        label: "Tipo de Visualização",
        permanent: "Permanente",
        confirm: "Confirmação",
        expiration: "Expiração",
      },
      expirationDate: "Data de Expiração",
      notifications: {
        saveSuccess: "Alerta cadastrado/atualizado com sucesso.",
        saveError: "Erro ao cadastrar/editar Alerta de Manejo.",
        inactivateSuccess: "Alerta inativado com sucesso!",
        inactivateError: "Erro ao inativar Alerta. Contate o suporte.",
        deleteSuccess: "Alerta excluído com sucesso!",
        deleteError: "Erro ao excluir Alerta. Contate o suporte.",
        activateSuccess: "Alerta ativado com sucesso!",
        activateError: "Erro ao ativar Alerta. Contate o suporte.",
        validationAnimals: "Selecione ao menos um animal.",
      },
    },
  },
  reproductiveProtocol: {
    title: "Protocolos Reprodutivos",
    buttonNew: "Nova Protocolo",
    table: {
      columns: {
        status: "Status",
        name: "Nome",
        duration: "Duração",
        createdAt: "Data de Criação",
        createdBy: "Responsável Criação",
        applicationDays: {
          orderApplication: "Ordem",
          dayApplication: "D?",
          product: "Produto/Hormônio",
        },
      },
    },
    form: {
      titleCreateNew: "Nova Protocolo",
      titleEdit: "Editar Protocolo",
      groupFarmVisibility: "Quem irá utilizar o Protocolo?",
      name: "Nome genérico",
      duration: "Duração Protocolo",
      newApplicationDay: "Linha",
      observations: "Observações",
      applicationDays: {
        orderApplication: "Ordem",
        dayApplication: "D?",
        product: "Produto/Hormônio",
      },
    },
  },
  animalFarmReproductiveProtocol: {
    title: "Lançamentos de Protocolos",
    buttonNew: "Aplicar Protocolo",
    table: {
      columns: {
        handlingNumber: "Fêmea",
        dateApplication: "Data",
        reproductiveProtocolName: "Protocolo",
        reproductionPeriodDescription: "Estação de Montar",
        lotOriginName: "Lote de Origem",
        lotDestinationName: "Lote Destino",
      },
    },
    form: {
      titleCreateNew: "Aplicar Protocolo",
      titleEdit: "Editar Protocolo",
      buttonApply: "Aplicar",
      applyForAnimalsGroupForm: {
        dateApplication: "Data D0",
        reproductiveProtocolId: "Protocolo",
        reproductionPeriodId: "Estação de Monta",
        lotDestinationId: "Lote Destino",
      },
      groupTitle: "Aplicações",
      animalsTable: {
        handlingNumber: "Identificação",
        lotName: "Lote",
        breedName: "Raça",
        age: "Idade",
        femaleSituation: "Situação",
        animalFarmFunction: "Finalidade",
        animalReproductionState: "Estado",
        animalReproductionCategory: "Categoria",
        lastBirthDate: "Dt. Último Parto",
      },
      selectAllAnimals: "Selecionar todos os animais",
      clearSelections: "Limpar seleções",
    },
    messages: {
      deleteSuccess: "Lançamento do protocolo foi excluído com sucesso.",
      deleteError: "Erro ao excluir lançamento de protocolo.",
      saveSuccess: "Protocolo aplicado com sucesso.",
      saveErrorConflict:
        "Atenção! Existe algum(ns) animais que possuem protocolo registrado na mesma data informada.",
      saveError: "Erro ao aplicar Protocolo",
      allAnimalsAlreadySelected:
        "Todos os animais ativos da fazenda já foram selecionados.",
    },
  },
  currency: {
    AED: "Dirham dos Emirados",
    AFN: "Afghani do Afeganistão",
    ALL: "Lek Albanês",
    AMD: "Dram Armênio",
    ANG: "Guilder das Antilhas",
    AOA: "Kwanza Angolano",
    ARS: "Peso Argentino",
    AUD: "Dólar Australiano",
    AZN: "Manat Azeri",
    BAM: "Marco Conversível",
    BBD: "Dólar de Barbados",
    BDT: "Taka de Bangladesh",
    BGN: "Lev Búlgaro",
    BHD: "Dinar do Bahrein",
    BIF: "Franco Burundinense",
    BND: "Dólar de Brunei",
    BOB: "Boliviano",
    BRL: "Real Brasileiro",
    BRLT: "Real Brasileiro Turismo",
    BSD: "Dólar das Bahamas",
    BTC: "Bitcoin",
    BWP: "Pula de Botswana",
    BYN: "Rublo Bielorrusso",
    BZD: "Dólar de Belize",
    CAD: "Dólar Canadense",
    CHF: "Franco Suíço",
    CHFRTS: "Franco Suíço",
    CLP: "Peso Chileno",
    CNH: "Yuan chinês offshore",
    CNY: "Yuan Chinês",
    COP: "Peso Colombiano",
    CRC: "Colón Costarriquenho",
    CUP: "Peso Cubano",
    CVE: "Escudo cabo-verdiano",
    CZK: "Coroa Checa",
    DJF: "Franco do Djubouti",
    DKK: "Coroa Dinamarquesa",
    DOGE: "Dogecoin",
    DOP: "Peso Dominicano",
    DZD: "Dinar Argelino",
    EGP: "Libra Egípcia",
    ETB: "Birr Etíope",
    ETH: "Ethereum",
    EUR: "Euro",
    FJD: "Dólar de Fiji",
    GBP: "Libra Esterlina",
    GEL: "Lari Georgiano",
    GHS: "Cedi Ganês",
    GMD: "Dalasi da Gâmbia",
    GNF: "Franco de Guiné",
    GTQ: "Quetzal Guatemalteco",
    HKD: "Dólar de Hong Kong",
    HNL: "Lempira Hondurenha",
    HRK: "Kuna Croata",
    HTG: "Gourde Haitiano",
    HUF: "Florim Húngaro",
    IDR: "Rupia Indonésia",
    ILS: "Novo Shekel Israelense",
    INR: "Rúpia Indiana",
    IQD: "Dinar Iraquiano",
    IRR: "Rial Iraniano",
    ISK: "Coroa Islandesa",
    JMD: "Dólar Jamaicano",
    JOD: "Dinar Jordaniano",
    JPY: "Iene Japonês",
    JPYRTS: "Iene Japonês",
    KES: "Shilling Queniano",
    KGS: "Som Quirguistanês",
    KHR: "Riel Cambojano",
    KMF: "Franco Comorense",
    KRW: "Won Sul-Coreano",
    KWD: "Dinar Kuwaitiano",
    KYD: "Dólar das Ilhas Cayman",
    KZT: "Tengue Cazaquistanês",
    LAK: "Kip Laosiano",
    LBP: "Libra Libanesa",
    LKR: "Rúpia de Sri Lanka",
    LSL: "Loti do Lesoto",
    LTC: "Litecoin",
    LYD: "Dinar Líbio",
    MAD: "Dirham Marroquino",
    MDL: "Leu Moldavo",
    MGA: "Ariary Madagascarense",
    MKD: "Denar Macedônio",
    MMK: "Kyat de Mianmar",
    MNT: "Mongolian Tugrik",
    MOP: "Pataca de Macau",
    MRO: "Ouguiya Mauritana",
    MUR: "Rúpia Mauriciana",
    MVR: "Rufiyaa Maldiva",
    MWK: "Kwacha Malauiana",
    MXN: "Peso Mexicano",
    MYR: "Ringgit Malaio",
    MZN: "Metical de Moçambique",
    NAD: "Dólar Namíbio",
    NGN: "Naira Nigeriana",
    NGNI: "Naira Nigeriana",
    NGNPARALLEL: "Naira Nigeriana",
    NIO: "Córdoba Nicaraguense",
    NOK: "Coroa Norueguesa",
    NPR: "Rúpia Nepalesa",
    NZD: "Dólar Neozelandês",
    OMR: "Rial Omanense",
    PAB: "Balboa Panamenho",
    PEN: "Sol do Peru",
    PGK: "Kina Papua-Nova Guiné",
    PHP: "Peso Filipino",
    PKR: "Rúpia Paquistanesa",
    PLN: "Zlóti Polonês",
    PYG: "Guarani Paraguaio",
    QAR: "Rial Catarense",
    RON: "Leu Romeno",
    RSD: "Dinar Sérvio",
    RUB: "Rublo Russo",
    RUBTOD: "Rublo Russo",
    RUBTOM: "Rublo Russo",
    RWF: "Franco Ruandês",
    SAR: "Riyal Saudita",
    SCR: "Rúpias de Seicheles",
    SDG: "Libra Sudanesa",
    SDR: "DSE",
    SEK: "Coroa Sueca",
    SGD: "Dólar de Cingapura",
    SOS: "Shilling Somaliano",
    STD: "Dobra São Tomé/Príncipe",
    SVC: "Colon de El Salvador",
    SYP: "Libra Síria",
    SZL: "Lilangeni Suazilandês",
    THB: "Baht Tailandês",
    TJS: "Somoni do Tajiquistão",
    TMT: "TMT",
    TND: "Dinar Tunisiano",
    TRY: "Nova Lira Turca",
    TTD: "Dólar de Trinidad",
    TWD: "Dólar Taiuanês",
    TZS: "Shilling Tanzaniano",
    UAH: "Hryvinia Ucraniana",
    UGX: "Shilling Ugandês",
    USD: "Dólar Americano",
    USDT: "Dólar Americano",
    UYU: "Peso Uruguaio",
    UZS: "Som Uzbequistanês",
    VEF: "Bolívar Venezuelano",
    VND: "Dong Vietnamita",
    VUV: "Vatu de Vanuatu",
    XAF: "Franco CFA Central",
    XAGG: "Prata",
    XBR: "Brent Spot",
    XCD: "Dólar do Caribe Oriental",
    XOF: "Franco CFA Ocidental",
    XPF: "Franco CFP",
    XRP: "XRP",
    YER: "Riyal Iemenita",
    ZAR: "Rand Sul-Africano",
    ZMK: "Kwacha Zambiana",
    ZWL: "Dólar Zimbabuense",
    XAU: "Ouro",
  },
  importFinancialTransaction: {
    title: "Importar Movimentações Financeiras",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com as movimentações financeiras, <strong>faça a importação</strong> em seguida e clique em processar.</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
    importNewSupplierClientLabel: "Importar novos Fornecedores/Clientes?",
  },
  importPicketSupplementSupplyAndFeedReader: {
    title: "Importar Fornecimento e Leitura de Cocho",
    buttonImport: "Importar Fornecimento/Leitura",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com os fornecimentos e leituras de cocho, <strong>faça a importação</strong> em seguida e clique em processar.</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
    messages: {
      templateGenerating:
        "O seu template para importação está sendo gerado e logo será feito o download. Aguarde o download.",
      templateError: "Houve um erro ao gerar template. Contate o suporte.",
      importedAndUpdated:
        "Fornecimentos e leituras de cocho importados e atualizados",
      importedAndUpdatedDesc:
        "Houve alguns fornecimentos/leituras de cocho que foram atualizados/inseridos.",
      imported: "Fornecimentos e leituras de cocho importados",
      partiallyImported:
        "Fornecimentos e leituras de cocho importados parcialmente",
      partiallyImportedDesc:
        "Houve alguns fornecimentos/leituras de cocho que não foram importados.",
      processedWithError: "Arquivo processado com erro !",
      processedWithErrorDesc:
        "Todos os fornecimentos/leituras de cocho não foram importados.",
      importError: "Erro ao importar",
      importErrorDesc: "Nenhum fornecimento/leitura de cocho foi incluído.",
    },
  },
  confinementResultReport: {
    form: {
      title: "Resultado do Confinamento",
      salesPeriod: "Período das Vendas",
      clientId: "Cliente",
      supplierId: "Fornecedor",
      saleScenarioId: "Cenário de Venda(s)",
      documentNumber: "N° do Documento",
      lotIds: "Lotes",
      showDeathData: "Exibir dados de Mortes no período?",
      showOriginData: "Exibir origem dos animais vendidos?",
      dailyOperationalCostMode: "Diária Operacional",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "Calculado Custeio BovExo",
        USER_DEFINED: "Definido pelo Usuário (R$/Dia)",
      },
      additionalSlaughterCostValue: "Custos Adicionais de Abate",
    },
  },
  farmDayScaleTreatmentParameter: {
    title: "Listagem de Sêmens",
    buttonNewSemen: "Novo Sêmen",
    table: {
      columns: {
        name: "Nome",
        registration: "Registro",
        breedName: "Raça",
      },
    },
    form: {
      titleCreateNewSemen: "Novo Sêmen",
      titleEditSemen: "Editar Sêmen",
      name: "Nome",
      registration: "Registro",
      breedId: "Raça",
      genealogy: "Genealogia",
      father: "Pai",
      mother: "Mãe",
      identification: "Identificação",
    },
  },
  troughFeedingAssessment: {
    title: "Leitura de Cocho",
    buttonNew: "Informe de Leitura de Cocho",
    table: {
      columns: {
        readingDate: "Data",
        supplyDate: "Data Trato",
        responsibleName: "Responsáveis",
        picketName: "Piquetes/Baias",
        lotName: "Lote",
        dietStrategyName: "Est. Dieta",
        totalAnimals: "Qtde. Animais",
        quantitySupplied: "Qtde. Ofertada(Kg)",
        readValue: "Leitura Cocho",
      },
    },
    form: {
      titleCreateNew: "Novo/Editar Leitura Cocho",
      filtersTitle: "Filtros",
      speedersTitle: "Aceleradores",
      applyFilterHint:
        "Ao clicar em Aplicar, os dados da seção 'Leituras' serão sobreescritos pelos os piquetes filtrados.",
      applyDefaultsHint:
        "Ao clicar em Aplicar, os campos da seção 'Leituras' que estiverem vazios serão sobreescritos pelos os valores escolhidos nos campos ao lado.",
      readingAlreadyDone: "Leitura de cocho já realizada nesta data.",
      dietWithoutDryMatter:
        "Dieta sem MS cadastrada: o ajuste não será aplicado.",
      dietWithoutDryMatterOnSave:
        "Os piquetes/baias {{pickets}} estão com dieta sem MS cadastrada. A leitura será salva, mas o ajuste não será aplicado a eles.",
      searchPicketOrLot: "Buscar piquete/baia ou lote",
      noResults: "Nenhum resultado encontrado.",
      daysUnit: "Dias",
      daysConfinementUnit: "Dias Conf.",
      informType: "Informar por",
      informTypeValues: {
        byDate: "Data",
        byPicket: "Piquete/Curral",
      },
      readingType: "Formato de Leitura",
      readingTypeValues: {
        unique: "Única",
        perSupply: "Trato",
      },
      readingResult: "Resultado Leitura",
      readingDate: "Data Leitura",
      readingHour: "Hora Leitura",
      supplyNumber: "N° Trato(s)",
      supplyDates: "Data Trato",
      responsibleName: "Responsável",
      retreats: "Retiro/Linha",
      pickets: "Piquetes/Baias",
      lots: "Lotes",
      tableSupplyNumber: "#Trato",
      amountAnimals: "#Cab",
      confinementTime: "Temp. Perm.",
      supplement: "Suplemento/Ração",
      realHour: "Hora Real",
      prevHour: "Hora Prev",
      prevQuantitySupplied: "Prev Lote (Kg)",
      realQuantitySupplied: "Qtd. Ofertada (Kg)",
      observation: "Observação",
      saveOptions: {
        only_save: "Salvar somente",
        save_and_create_new: "Salvar e criar nova Leitura",
      },
    },
  },
  processTransferAnimalTransactionModal: {
    title: "Processar Transferência de Animais",
    form: {
      origin: "Origem",
      amountAnimals: "Qtd. Cab.",
      sellDate: "Data",
      animalValue: "Valor Med.",
      totalValue: "Valor Total",
      totalInstallments: "Qtd. Parc.",
      firstInstallmentDate: "Data 1° Parc.",
      firstInstallmentValue: "Valor 1° Parc.",
      resultCenter: "Centro de Resultado",
      lotDestinationId: "Lote Destino",
      financialNatureId: "Natureza",
      financialClassId: "Classe",
      farmOwnerId: "Proprietário",
      dividerTitle: "DADOS COMPLEMENTARES",
      useFarmOwnersFromOrigin: "Manter proprietários da Fazenda de Origem",
    },
    messages: {
      rejectModalTitle: "Alerta",
      rejectModalContent:
        "Você realmente deseja rejeitar esta movimentação? Esta ação é irreversível!",
      successSubmit:
        "A transferência foi confirmada com sucesso, e está em processamento. Logo a movimentação será completada.",
      errorSubmit:
        "Houve um erro ao tentar confirmar transferência. Contate o suporte.",
      successReject:
        "A transferência está sendo rejeitada. Logo a movimentação será rejeitada com sucesso.",
      errorReject:
        "Houve um erro ao tentar rejeitar transferência. Contate o suporte.",
      errorNotSelectFarmOwnerOrCheckUseOriginalFarmOwner:
        "É necessário selecionar um Proprietário ou marcar para manter proprietários da Fazenda de Origem.",
      errorFarmOwnerNotCreated:
        "Atenção! Existem proprietários (listados abaixo) de animais, não cadastrados nesta fazenda. Para ajustar, acesse [Administração/Fazendas]",
    },
  },
  weightRanking: {
    top: "Cabeceira",
    middle: "Meio",
    bottom: "Fundo",
  },
  menuNavigation: {
    menu_stock: "ESTOQUE",
    menu_diet_strategy: "ESTRATÉGIA DE DIETA",
    menu_picket_supplement_supply: "FORNECIMENTO",
    menu_trough_feeding_assessment: "LEITURA DE COCHO",
    menu_weights: "PESAGENS E MEDIÇÕES",
    menu_veterinary: "VETERINÁRIO",
    menu_reproductive: "REPRODUTIVO",
    menu_dashboard: "DASHBOARD",
    menu_purchase_scenario: "CENÁRIO COMPRA",
    menu_sale_scenario: "CENÁRIO VENDA",
    menu_purchase_scenario_boitel: "CENÁRIO COMPRA",
    menu_sale_scenario_boitel: "CENÁRIO VENDA",
    menu_nutritional: "NUTRICIONAL",
    menu_entry: "ENTRADA",
    menu_technician_veterinary: "VETERINÁRIO",
    menu_exit: "SAÍDA",
    menu_manager: "GESTÃO",
    menu_handling: "MANEJOS",
    menu_purchase: "COMPRA",
    menu_sale: "VENDA",
    menu_purchase_boitel: "COMPRA",
    menu_sale_boitel: "VENDA",
    menu_recreate_fatten_extensive: "R/E PASTO",
    menu_growth: "CRIA",
    menu_confinement: "R/E CONFINAMENTO",
    menu_boitel: "BOITEL",
    menu_commercial_boitel: "COMERCIAL",
    menu_contracts_boitel: "CONTRATOS",
    menu_contracts_boitel_confinament: "COMERCIAL",
  },
  weather: {
    title: "Dados Climáticos",
  },
  arrobaPrice: {
    title: "Dados Financeiro",
    dataAgro: {
      selectDate: "Selecione uma data: ",
    },
    marketAnalysisDash: {
      title: "Curva de preços",
      selectCurve: "Selecione a curva que deseja visualizar:",
      emptyMessage: "Selecione uma curva para que seja exibido o gráfico",
    },
  },
  alertPanel: {
    title: "alertas & pendências",
    emptyMessage: "Nenhum alerta encontrado nessa data",
  },
  viewTransferAnimalTransactionModal: {
    title: "Detalhes Transferência de Animais",
    form: {
      origin: "Origem",
      amountAnimals: "Qtd. Cab.",
      sellDate: "Data",
      animalValue: "Valor Med.",
      totalValue: "Valor Total",
      totalInstallments: "Qtd. Parc.",
      firstInstallmentDate: "Data 1° Parc.",
      firstInstallmentValue: "Valor 1° Parc.",
      resultCenter: "Centro de Resultado",
      lotDestinationId: "Lote Destino",
      financialNatureId: "Natureza",
      financialClassId: "Classe",
      farmOwnerId: "Proprietário",
      dividerTitle: "DADOS COMPLEMENTARES",
    },
    table: {
      columns: {
        handlingNumber: "Animal",
        dateTransferCreation: "Data de Registro",
        dateTransferAccept: "Data de Confirm.",
        weightTransfer: "Peso",
        priceTransfer: "Valor",
        lotOriginName: "Lote de Origem",
        lotDestinationName: "Lote de Destino",
        responsibleCreateTransfer: "Responsável Origem",
        responsibleAcceptTransfer: "Responsável Destino",
      },
    },
  },
  movementAnimalReportParameter: {
    title: "Dinâmica de rebanho por idade",
    classification: "Classificação",
    externalIntegrationCode: "Código de Integração Externa",
    messages: {
      errorLenghtEqualZero:
        "É necessário ter ao menos uma classificação de idade por gênero.",
      errorClassificationWithoutMinAge:
        "É necessário que as classificações tenham idade minima.",
      errorClassificationWithManyMaxAgeNull:
        "Só é permitido uma classificação sem idade máxima por gênero",
      errorClassificationWithMaxAgeLessThanOrEqualToMinAge:
        "É necessário que a idade máxima seja maior que a idade mínima",
      errorClassificationWithWrongOrder:
        "É necessário que as classificações sigam uma ordem de idade, onde a idade mínima de uma classificação deve ser maior que a máxima da anterior.",
    },
  },
  movementAnimalReportModalRequest: {
    title: "Movimentações de Animais",
    form: {
      onlyFinalStock: "Estoque Atual de Animais",
      allFarmGroups: "Todas as Fazendas",
      datePeriod: "Período",
      breedId: "Raça",
      ownerId: "Proprietário",
      supplierId: "Fornecedor",
      lotIds: "Lotes",
    },
  },
  successGenerateReport: "Relatório gerado com sucesso",
  errorGenerateReport:
    "Houve um erro ao gerar relatório. Entre em contato com o suporte",
  reports: {
    tabs: {
      favorite: "Favoritos",
      animal: "Animais",
      produciton: "Produção",
      financial: "Financeiros",
      management: "Gerenciais",
      operational: "Operações",
    },
    titles: {
      SimpleAnimalReport: "Relatório Simples de Animais",
      ListAnimalReportReproduction:
        "Relatório de listagem de animais (Reprodução)",
      ListAnimalReportFatten: "Relatório de listagem de animais (Engorda)",
      AnimalWeightImportReport: "Relatório para importação de pesagens",
      AnimalManagementObservation: "Relatório de Observações de Manejo",
      ReportMovementAnimals: "Relatório de Movimentações",
      ReportNutritionalConsumption:
        "Relatório de Tratos/Consumo de Ração/Suplemento",
      ReportPicketFeedingAssessment: "Planilha de Fornecimento",
      IntensiveResultReport: "Relatório de Resultado de Confinamento",
      FarmSalesReport: "Relatório de Resultado de Vendas",
      FinancialTransactionsReport: "Exportação de Movimentações Financeiras",
      FinancialCashFlowReport: "Relatório de Fluxo de Caixa",
      DisbursementReport: "Relatório de Desembolso",
      ReportAnimalWeightHistory: "Relátorio de Pesagens",
      ReportLotStock: "Relatório de Estoque por Lote",
      ReportTroughReadingSheet: "Ficha de Leitura de Cocho",
      ContractsReport: "Análise de Contratos",
      ContractsSaleResultReport: "Resultado de Venda – Contratos",
    },
    messages: {
      errorUpdateFavorite:
        "Houve um erro ao atualizar/remover o relatório de favoritos",
    },
  },
  financialCashFlowReportModalRequest: {
    title: "Relatório de Fluxo de Caixa",
    form: {
      transactionType: "Tipo",
      periodStartDate: "Inicio",
      periodEndDate: "Fim",
      periodType: "Período",
      intervalType: "Intervalo",
      farmIds: "Fazenda(s)",
      financialNatureId: "Natureza",
      financialClassId: "Classe",
      costActivityType: "Atividade",
      showZeroValues: "Exibir Classes sem movimentações no período?",
      showAnalyticalData: "Gerar relatório analítico?",
    },
    periods: {
      lastSevenDays: "Últimos 7 dias",
      lastThirdyDays: "Últimos 30 dias",
      currentMonth: "Mês Atual",
      lastMonth: "Mês Anterior",
      currentYear: "Ano Atual",
      lastYear: "Ano Anterior",
      currentHarvest: "Safra Atual",
      lastHarvest: "Safra Anterior",
      customDateRange: "Especificar Data (Máx. 12 meses)",
    },
    intervals: {
      daily: "Diário",
      weakly: "Semanal",
      monthly: "Mensal",
      yearly: "Anual",
    },
    messages: {
      errorPeriodMoreThanTwelveMonths: "Período não pode passar de 12 meses.",
      errorNoDataFound:
        "Não foi encontrado nenhum resultado com o filtro informado",
    },
  },
  disbursementReportModalRequest: {
    title: "Relatório de Desembolso",
    form: {
      transactionType: "Tipo",
      periodStartDate: "Inicio",
      periodEndDate: "Fim",
      periodType: "Período",
      intervalType: "Intervalo",
      farmIds: "Fazenda(s)",
      financialNatureId: "Natureza",
      financialClassId: "Classe",
      costActivityType: "Atividade",
      showZeroValues: "Exibir Classes sem movimentações no período?",
      showAnalyticalData: "Gerar relatório analítico?",
    },
    periods: {
      lastSevenDays: "Últimos 7 dias",
      lastThirdyDays: "Últimos 30 dias",
      currentMonth: "Mês Atual",
      lastMonth: "Mês Anterior",
      currentYear: "Ano Atual",
      lastYear: "Ano Anterior",
      currentHarvest: "Safra Atual",
      lastHarvest: "Safra Anterior",
      customDateRange: "Especificar Data (Máx. 12 meses)",
    },
    intervals: {
      daily: "Diário",
      weakly: "Semanal",
      monthly: "Mensal",
      yearly: "Anual",
    },
    messages: {
      errorPeriodMoreThanTwelveMonths: "Período não pode passar de 12 meses.",
      errorNoDataFound:
        "Não existem movimentações financeiras e/ou animais no período informado.",
    },
  },
  reportTroughReadingSheetModalRequest: {
    title: "Ficha de Leitura de Cocho",
    form: {
      date: "Data",
      pickets: "Piquetes/Baias",
    },
    messages: {
      informData:
        "Informe os dados abaixo para gerar a ficha de leitura de cocho.",
      preparingReport:
        "O seu relatório está sendo preparado e logo será feito o download! Por favor, não feche esta aba do navegador.",
      noDataFound: "Não foram encontrados dados com os filtros informados.",
    },
  },
  financialPaymentMethod: {
    parameter4004: "Utilizar forma de pagamento?",
    title: "Forma de Pagamento",
    buttonNew: "Nova Forma",
    table: {
      columns: {
        name: "Forma de Pagamento",
        code: "Código",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Quem irá utilizar Forma de Pagamento?",
      titleCreateNew: "Nova Forma de Pagamento",
      titleEdit: "Editar Forma de Pagamento",
      name: "Nome",
      code: "Código",
      status: "Ativo?",
    },
    messages: {
      successMessage: "Forma de Pagamento salva/atualizada com sucesso.",
      errorMessage:
        "Não foi possível salvar/atualizar a forma de pagamento.Contate o suporte.",
      activateMessage: "Forma de Pagamento ativada",
      inactivateMessage: "Forma de Pagamento inativada",
      deleteSuccess: "Forma de Pagamento deletada com sucesso.",
      errorTitle: "Erro",
      linkedError:
        "Esta Forma de Pagamento não pode ser excluída, ela já está ligada a Movimentações Financeiras.",
      deleteError: "Erro ao deletar forma de pagamento.",
    },
  },
  financialIssue: {
    parameter4003: "Utilizar pendências financeiras?",
    title: "Pendência Financeira",
    buttonNew: "Nova Pendência",
    table: {
      columns: {
        name: "Pendência Financeira",
        code: "Código",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Quem irá utilizar Pendêcia Financeira?",
      titleCreateNew: "Nova Pendência Financeira",
      titleEdit: "Editar Pendência Financeira",
      name: "Nome",
      code: "Código",
      status: "Ativo?",
    },
    messages: {
      successMessage: "Pendência Financeira salva/atualizada com sucesso.",
      errorMessage:
        "Não foi possível salvar/atualizar a pendência financeira.Contate o suporte.",
      activateMessage: "Pendêcia Financeira ativada",
      inactivateMessage: "Pendêcia Financeira inativada",
      deleteSuccess: "Pendência Financeira deletada com sucesso.",
      errorTitle: "Erro",
      linkedError:
        "Esta Pendência Financeira não pode ser excluída, ela já está ligada a Movimentações Financeiras.",
      deleteError: "Erro ao deletar pendência financeira.",
    },
  },
  financialTaxableDeductible: {
    parameter4005: "Utilizar tributável e dedutível IR?",
    title: "Tributável e Dedutível",
    buttonNew: "Novo tributo e dedutível",
    table: {
      columns: {
        name: "Tributável e Dedutível",
        code: "Código",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Quem irá utilizar Tributável e Dedutível?",
      titleCreateNew: "Nova Tributável e Dedutível",
      titleEdit: "Editar Tributável e Dedutível",
      name: "Nome",
      code: "Código",
      status: "Ativo?",
    },
    messages: {
      successMessage: "Tributável e dedutível salva/atualizada com sucesso.",
      errorMessage:
        "Não foi possível salvar/atualizar o tributável e dedutível.Contate o suporte.",
      activateMessage: "Tributável e dedutível ativada",
      inactivateMessage: "Tributável e dedutível inativada",
      deleteSuccess: "Tributável e dedutível deletado com sucesso.",
      errorTitle: "Erro",
      linkedError:
        "Este Tributável e Dedutível não pode ser excluído, ele já está ligado a Movimentações Financeiras.",
      deleteError: "Erro ao deletar tributável e dedutível.",
    },
  },
  radiogroup: {
    farm: "Somente esta fazenda",
    group: "Fazendas do grupo",
  },
  importAnimalCoverage: {
    title: "Importar Coberturas e DG's",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com as coberturas e/ou DGs, <strong>faça a importação</strong> em seguida e clique em processar.</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
  },
  bankAccountFarm: {
    parameter4006: "Utilizar conta bancária?",
    title: "Conta Bancária",
    buttonNew: "Nova Forma",
    table: {
      columns: {
        description: "Nome",
        bankName: "Banco",
        bankCode: "Código do Banco",
        bankAccountNumber: "Nr. da Conta",
        bankAgencyNumber: "Nr. da Agência",
        initialBalanceDate: "Data de Saldo Inicial",
        initialBalance: "Saldo Inicial",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Quem irá utilizar Conta Bancária?",
      titleCreateNew: "Nova Conta Bancária",
      titleEdit: "Editar Conta Bancária",
      description: "Nome",
      bankId: "Banco",
      bankAccountNumber: "Nr. da Conta",
      bankAgencyNumber: "Nr. da Agência",
      initialBalanceDate: "Data de Saldo Inicial",
      initialBalance: "Saldo Inicial",
      status: "Ativo?",
      type: "Tipo de Conta",
      types: {
        PESSOA_FISICA: "Pessoa Física",
        PESSOA_JURIDICA: "Pessoa Jurídica",
      },
    },
    messages: {
      successMessage: "Conta Bancária salva/atualizada com sucesso.",
      errorMessage:
        "Não foi possível salvar/atualizar a conta bancária.Contate o suporte.",
      activateMessage: "Conta Bancária ativada",
      inactivateMessage: "Conta Bancária inativada",
    },
  },
  bankConciliation: {
    tabs: {
      bankConciliation: "Conciliar",
      bankStatement: "Extrato",
    },
  },
  statement: {
    title: "Extratos",
    buttonNew: "Importar Extrato",
    table: {
      columns: {
        bankCode: "Código do Banco",
        bankName: "Banco",
        bankAccountNumber: "Nr. da Conta",
        bankAgencyNumber: "Nr. da Agência",
        fileName: "Nome do Arquivo",
        startTransactionsDate: "Data de Início",
        endTransactionsDate: "Data de Fim",
        transactionDate: "Data",
        type: "Tipo",
        name: "Descrição",
        amount: "Valor",
        accountFarmDescription: "Conta Bancária",
        status: "Status",
      },
    },
    form: {
      steps: {
        step1: "Carga",
        step2: "Revisão",
        step3: "Importar BovExo",
      },
      bankCode: "Código do Banco",
      bankName: "Banco",
      bankAccountNumber: "Nr. da Conta",
      bankAgencyNumber: "Nr. da Agência",
      fileName: "Nome do Arquivo",
      startTransactionsDate: "Data de Início",
      endTransactionsDate: "Data de Fim",
      transactionDate: "Data",
      type: "Tipo",
      name: "Descrição",
      amount: "Valor",
      accountFarmDescription: "Conta Bancária",
      status: "Status",
      period: "Período",
      transactions: "Transações",
    },
    types: {
      DEBIT: "Débito",
      CREDIT: "Crédito",
      XFER: "Transferência",
      CHECK: "Cheque",
      PAYMENT: "Pagamento",
      CASH: "Dinheiro",
      DIRECTDEP: "Depósito Direto",
      DIRECTDEBIT: "Débito Direto",
      HOLD: "Aguardando",
      OTHER: "Outro",
      DEP: "Depósito",
    },
    messages: {
      reviewMessage:
        "Revise os dados do extrato importado e seleicione os lançamentos que serão posteriormente conciliados.",
      successMessage: "Conta Bancária salva/atualizada com sucesso.",
      errorMessage:
        "Não foi possível salvar/atualizar a conta bancária.Contate o suporte.",
      activateMessage: "Conta Bancária ativada",
      inactivateMessage: "Conta Bancária inativada",
    },
  },
  conciliation: {
    form: {
      statementTransactionType: "Tipo",
      statementTransactionDate: "Data",
      statementTransactionAmount: "Valor",
      statementTransactionDescription: "Descrição",
      statementTransactionBankAccountFarmName: "Fonte Pagadora",
    },
    table: {
      columns: {
        statementTransactionType: "Tipo",
        statementTransactionBankAccountFarmName: "Fonte Pagadora",
        statementTransactionDate: "Data",
        statementTransactionAmount: "Valor",
        statementTransactionDescription: "Descrição",
        expirationDate: "Data",
        billingDate: "Data",
        value: "Valor",
        documentNumber: "N° do Documento",
        installmentNumber: "Parcela",
        transactionType: "Tipo",
        supplierClientName: "Fornecedor/Cliente",
        paymentMethodName: "F. Pagamento",
        bankAccountFarmName: "Fonte Pagadora",
      },
    },
    transactionTypes: {
      income: "Receita",
      expense: "Despesa",
    },
    selectFinancialInstallmentsModal: {
      statementTransactionType: "Tipo",
      statementTransactionBankAccountFarmName: "Fonte Pagadora",
      statementTransactionDate: "Data",
      statementTransactionAmount: "Valor",
      statementTransactionDescription: "Descrição",
      selectedRows: "Selecionados",
      selectedRowsSum: "Total Selecionados",
      differenceLabel: "Diferença",
    },
    messages: {
      successConciliation: "Conciliação feita com sucesso",
      errorConciliation: "Error ao fazer conciliação. Contate o suporte",
      errorNoTransactionsSelectedMessage: "Nenhum lançamento selecionado",
      errorNoTransactionsSelectedDescription:
        "Por favor, selecione pelo menos um lançamento para conciliar.",
      errorSelectedStatementsWithoutTransactionsSelected:
        "Existem lançamentos sem movimentação financeira selecionada",
      errorTransactionsWithWrongSumValueMessage:
        "Valores inválidos nas movimentações financeiras",
      errorTransactionsWithWrongSumValueDescription:
        "Todos os valores das movimentações financeiras devem estar preenchidos e a soma deve ser igual ao valor do lançamento.",
      errorWrongSumValuesMessageOnSelectInstallmentModal: "Erro",
      errorWrongSumValuesDescriptionOnSelectInstallmentModal:
        "A soma dos valores selecionados é diferente do valor do extrato.",
      successRemoveConciliation:
        "Foi removido a conciliação bancária deste registro",
      errorRemoveConciliation:
        "Não foi possível remover a conciliação bancária deste registro. Contate o suporte",
      successAddNewConciliation: "Foi adicionado registro para conciliação",
      errorAddNewConciliation:
        "Não foi possível adicionar registro para conciliação. Contate o suporte",
    },
  },
  contractsReportModal: {
    title: "Relatório: Análise de Contratos",
    form: {
      cattleProducerId: "Produtor",
      contractDate: "Data do Contrato",
      identificationContract: "Número do Contrato",
      identificationContractPlaceholder: "Digite a identificação do contrato",
      cattleProducerRequired: "Produtor é obrigatório",
    },
    messages: {
      errorNoDataFound:
        "Não foi encontrado nenhum resultado com o filtro informado",
      checkVigente:
        "Confirme se os contratos do filtro estão com status VIGENTE",
      checkActiveLot:
        "Confirme se todos os animais selecionados nos contratos possuem um Lote com status Ativo",
    },
  },
  contractsSaleResultReportModal: {
    title: "Relatório: Resultado de Venda – Contratos",
    form: {
      salesPeriod: "Período de Vendas",
      contractType: "Tipo Contrato",
      contractTypeOptions: {
        ARROBA_PRODUCTION: "Parceria (@ Produzida)",
      },
      cattleProducerId: "Parceiro",
      dailyOperationalCostMode: "Diária Operacional",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "Calculado Custeio BovExo",
        USER_DEFINED: "Definido pelo Usuário (R$/Dia)",
      },
      additionalSlaughterCostValue: "Custos Adicionais de Abate",
      splitByOriginLot: "Separar por Lote de Origem",
    },
    messages: {
      errorNoDataFound:
        "Não foi encontrado nenhum resultado com o filtro informado",
    },
  },
  exportReportLotStockModal: {
    title: "Relatório de Estoque por Lote",
    form: {
      breedIds: "Raças",
      lotIds: "Lotes",
      supplierIds: "Fornecedores",
      farmOwnerIds: "Proprietários",
    },
    messages: {
      errorNoDataFound:
        "Não foi encontrado nenhum resultado com o filtro informado",
    },
  },
  farmReadFeederTreatmentParameter: {
    form: {
      freeScale: "Escala de Leitura de Cocho",
      freeScaleOption: {
        default: "Padrão",
        free: "Livre",
      },
      readFrequency: "Frequência de Leitura de Cocho",
      readFrequencyOption: {
        readOnceADay: "1x ao dia",
        readAtEveryTreat: "A cada Trato",
        readInTreat: "Nos Tratos",
      },
      applicationType: "Ajuste da Quantidade deve aplicar-se",
      applicationTypeOption: {
        apply_equal_for_all_treats: "Uniforme por todos tratos",
        concentrated_on_last_treat: "Concentrada no último trato",
      },
      adjustmentType: "Cálculo da Leitura de Cocho",
      adjustmentTypeOption: {
        percent_original_matter: "% MO (Matéria Original)",
        percent_dry_matter: "% MS (Matéria Seca)",
        kg_dry_matter: "kg MS (Matéria Seca)",
      },
    },
    messages: {
      confirmAdjustmentTypeChange:
        "Ao trocar o cálculo da leitura de cocho, os valores da escala serão apagados e precisarão ser informados novamente. Deseja continuar?",
      percentAboveLimit:
        'O valor da porcentagem da escala "{{scale}}" ultrapassou 25%, deseja confirmar?',
      successSave: "Parâmetros de Leitura de Cocho salvos com sucesso!",
      errorSave: "Erro ao salvar os parâmetros de Leitura de Cocho",
    },
  },
  areaMap: {
    title: "Mapa de Áreas",
    newArea: "Nova Área",
    clearAllAreas: "Limpar Todas as Áreas",
    totalAreas: "Total",
    form: {
      title: "Nova Área",
      editTitle: "Editar Área",
      identificationCode: "Código de Identificação",
      identificationCodePlaceholder: "Digite o código de identificação",
      type: "Tipo",
      typePlaceholder: "Selecione o tipo",
      picketSelection: "Seleção de Piquete",
      picketPlaceholder: "Selecione um piquete",
      retreatSelection: "Seleção de Retiro",
      retreatPlaceholder: "Selecione um retiro",
      observation: "Observação",
      observationPlaceholder: "Digite uma observação sobre a área",
      color: "Cor da marcação do mapa",
      colorPlaceholder: "Selecione uma cor",
      area: "Área em hectares",
      areaPlaceholder: "0.00",
      areaDescription:
        "Área calculada automaticamente a partir do polígono desenhado",
      save: "Salvar",
      update: "Atualizar",
      cancel: "Cancelar",
    },
    colors: {
      red: "Vermelho",
      green: "Verde",
      blue: "Azul",
      yellow: "Amarelo",
      magenta: "Magenta",
      cyan: "Ciano",
      orange: "Laranja",
      purple: "Roxo",
      darkGreen: "Verde Escuro",
      darkBlue: "Azul Escuro",
      brown: "Marrom",
      pink: "Rosa",
    },
    types: {
      AGRICULTURA: "Agricultura",
      BENFEITORIAS: "Benfeitorias",
      CONFINAMENTO: "Confinamento",
      INTEGRACAO_LAVOURA_PECUARIA: "Integração Lavoura-Pecuária",
      INTEGRACAO_LAVOURA_PECUARIA_FLORESTA:
        "Integração Lavoura-Pecuária-Floresta",
      INTEGRACAO_LAVOURA_FLORESTA: "Integração Lavoura-Floresta",
      PASTAGEM: "Pastagem",
      RESERVA: "Reserva",
      SILVICULTURA: "Silvicultura",
    },
    messages: {
      mapLoadError: "Erro ao carregar o mapa",
      mapLoadErrorDescription:
        "Verifique se a chave da API do Google Maps está configurada corretamente.",
      areasLoadError: "Erro ao carregar áreas",
      areasLoadErrorDescription:
        "Não foi possível carregar as áreas existentes do mapa.",
      polygonRequired: "Polígono necessário",
      polygonRequiredDescription:
        "Desenhe um polígono no mapa antes de salvar.",
      drawingHint: "Modo de desenho ativo",
      drawingHintDescription:
        "Clique no mapa para adicionar os vértices. Para concluir, dê um duplo-clique ou use o botão abaixo (mínimo de 3 vértices).",
      drawingVerticesLabel: "Vértices",
      drawingFinishButton: "Concluir polígono",
      areaSaved: "Área salva com sucesso",
      areaSavedDescription: "Área de {area} hectares foi salva.",
      areaUpdated: "Área atualizada com sucesso",
      areaUpdatedDescription: "Área de {area} hectares foi atualizada.",
      areaSaveError: "Erro ao salvar área",
      areaSaveErrorDescription:
        "Não foi possível salvar a área. Contate o suporte.",
      picketAlreadySelected:
        "O Piquete ou Retiro selecionado já foi selecionado em outra área",
      areaDeleteError: "Erro ao excluir área",
      areaDeleteErrorDescription:
        "Não foi possível excluir a área. Contate o suporte.",
      loadingAreas: "Carregando áreas...",
      areaDeleted: "Área excluída com sucesso",
    },
    validation: {
      colorRequired: "Cor é obrigatória",
      areaRequired: "Área é obrigatória",
      areaMin: "Área deve ser maior que 0",
    },
    centerCard: {
      infoMessage:
        "Para centralizar o mapa corretamente, configure os dados de localização da sua propriedade.",
      configureLocation: "Configurar Localização",
      formTitle: "Configurar Centralização do Mapa",
      savedLocation: "Localização Configurada",
      coordinates: "Coordenadas",
      edit: "Editar",
      savedAt: "Salvo em",
      form: {
        locationType: "Tipo de Localização",
        coordinates: "Coordenadas (Lat/Lng)",
        address: "Endereço",
        addressPlaceholder: "Digite o endereço da propriedade",
        latitude: "Latitude",
        latitudePlaceholder: "Ex: -15.7801",
        longitude: "Longitude",
        longitudePlaceholder: "Ex: -47.9292",
        description: "Descrição (opcional)",
        descriptionPlaceholder: "Ex: Sede da fazenda, Portão principal",
        save: "Salvar",
        cancel: "Cancelar",
        loadingPlaces: "Carregando serviço de endereços...",
        geocoding: "Obtendo coordenadas...",
      },
      validation: {
        locationTypeRequired: "Tipo de localização é obrigatório",
        addressRequired: "Endereço é obrigatório",
        latitudeRequired: "Latitude é obrigatória",
        longitudeRequired: "Longitude é obrigatória",
        latitudeMin: "Latitude deve ser maior que -90",
        latitudeMax: "Latitude deve ser menor que 90",
        longitudeMin: "Longitude deve ser maior que -180",
        longitudeMax: "Longitude deve ser menor que 180",
      },
      messages: {
        saved: "Localização salva com sucesso",
        savedDescription:
          "O mapa será centralizado na localização configurada.",
        saveError: "Erro ao salvar localização",
        saveErrorDescription:
          "Não foi possível salvar a localização. Tente novamente.",
        placesApiError: "Erro ao carregar Google Places",
        placesApiErrorDescription:
          "Não foi possível carregar o serviço de autocompletar endereços.",
        geocodingWarning: "Aviso de Geocoding",
        geocodingWarningDescription:
          "Não foi possível obter as coordenadas do endereço. Verifique se o endereço está correto.",
      },
    },
    modal: {
      title: "Informações da Área",
      identificationCode: "Código de Identificação",
      type: "Tipo",
      picketName: "Nome do Piquete",
      retreatName: "Nome do Retiro",
      areaSquareMeters: "Área (m²)",
      areaHectares: "Área (hectares)",
      observation: "Observação",
      deleteButton: "Excluir Área",
      deleteConfirmTitle: "Confirmar Exclusão",
      deleteConfirmMessage:
        "Tem certeza que deseja excluir esta área? Esta ação não pode ser desfeita.",
      deleteConfirmOk: "Sim, excluir",
      deleteConfirmCancel: "Cancelar",
      tabs: {
        details: "Detalhes da Área",
        production: "Produção",
        history: "Histórico",
        observations: "Observações",
      },
      details: {
        status: "Status",
        picketProductionSubSystem: "Atividade",
        identificationCode: "Código de Identificação",
        type: "Tipo",
        picketName: "Nome Piquete/Baia",
        areaSquareMeters: "Área (m²)",
        areaHectares: "Área (hectares)",
        picketPastureName: "Forrageira",
        areaObservations: "Observações da Área",
      },
      production: {
        stockingRate: "Taxa de Lotação",
        animalInfo: "Informações de Animais",
        activeAnimals: "ANIMAIS ATIVOS",
        dataReference: "Dados referentes a",
        averageWeight: "Peso médio",
        averageWeightProjected: "Peso projetado atual",
        averageGdp: "GDP médio",
        averageAge: "Idade média",
        months: "Meses",
        kg: "kg",
      },
      history: {
        title: "Histórico de Lotes",
        recentLot: "Histórico de Lotes - Lote mais recente",
        lotName: "Nome do Lote",
        entryDate: "Entrada",
        exitDate: "Saída",
        totalDays: "Total de dias",
        viewAll: "Visualizar tudo",
      },
      observations: {
        title: "Observações do Piquete",
        timeline: "Linha do Tempo",
      },
      status: {
        A: "Ativo",
        B: "Descanso",
        P: "Pastejo",
        R: "Reforma",
        M: "Manutenção",
        L: "Arrendado",
        D: "Excluído",
        X: "Excluído da Fazenda",
        I: "Inativo",
        Break: "Descanso",
        Pasturage: "Pastejo",
        Renovation: "Reforma",
        Maintenance: "Manutenção",
        Leased: "Arrendado",
        Deleted: "Excluído",
        Active: "Ativo",
        Inactive: "Inativo",
      },
      picketProductionSubSystem: {
        extensive: "Extensivo",
        semiIntensive: "Semi-Intensivo",
        intensive: "Intensivo",
      },
    },
  },
  excelExport: {
    buttonText: "Exportar",
    modalTitle: "Exportar para Excel",
    fields: {
      exportName: "Nome do Relatório",
      columns: "Colunas",
      filters: "Filtros",
    },
    placeholders: {
      exportName: "Digite o nome do relatório",
      inOperator: "Separado por vírgulas",
    },
    operators: {
      EQ: "Igual",
      NEQ: "Diferente",
      GT: "Maior que",
      LT: "Menor que",
      GTE: "Maior ou igual",
      LTE: "Menor ou igual",
      LIKE: "Contém",
      IN: "Em",
      BETWEEN: "Entre",
    },
    buttons: {
      export: "Exportar",
    },
    validation: {
      exportNameRequired: "Nome do relatório é obrigatório",
    },
    successMessage: "Arquivo exportado com sucesso!",
    errorMessage: "Erro ao exportar arquivo. Tente novamente.",
    selectAllColumns: "Marcar todas",
    deselectAllColumns: "Desmarcar todas",
  },
  importAnimalBirth: {
    title: "Importação de Partos e Perdas Reprodutivas",
    message:
      "Importe o arquivo de partos e perdas reprodutivas para o sistema.",
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
  },
  stockItem: {
    pageTitle: "Estoque de Insumos",
    tabs: {
      stockItems: "Itens Estoque",
      materialMovements: "Movimentações",
      pendencies: "Pendências",
      audit: "Auditoria",
      parameters: "Parâmetros",
    },
    summaryCards: {
      stockValue: "Valor do Estoque",
      totalQty: "Qtd Total",
      items: "Itens",
      belowReplenishment: "Abaixo Repos.",
    },
    table: {
      internalId: "Identificação",
      abbreviation: "Abrev",
      group: "Grupo",
      subgroup: "Subgrupo",
      currentQty: "Qtd Atual",
      unit: "Unidade",
      replenishmentPoint: "Pto Repos.",
      currentCost: "Custo Atual",
      value: "Valor",
      actions: "Ações",
    },
    searchPlaceholder: "Buscar por ID, abreviação ou descrição...",
    toggleInactive: "Inativos",
    toggleActive: "Ativos",
    newItem: "Novo Item",
    drawerLabels: {
      internalId: "Identificação",
      abbreviation: "Abreviação",
      description: "Descrição",
      group: "Grupo",
      subgroup: "Subgrupo",
      unit: "Unidade",
      currentQty: "Qtd Atual",
      replenishmentPoint: "Pto Reposição",
      currentCost: "Custo Atual",
      lastPurchaseCost: "Custo Últ. Aquis.",
      lastPurchaseDate: "Data Últ. Aquis.",
      lastSupplier: "Últ. Fornecedor",
      notes: "Notas",
      variantControl: "Ctrl Variante",
      batchControl: "Ctrl Lote",
      variantsAndBatches: "Variantes & Lotes",
      variants: "Variantes",
      batches: "Lotes",
      dietItem: "Item de Dieta",
      supplementSupplierId: "Fornecedor",
      supplementGroup: "Grupo do Suplemento",
      supplementSubGroup: "Subgrupo do Suplemento",
      supplementPresentation: "Apresentação",
      nutritionalDetails: "DADOS NUTRICIONAIS",
      cost: "Custo",
      dryMatterPercentage: "MS: Matéria Seca",
      ndt: "NDT: Nutrientes Digest. Totais",
      pb: "PB: Proteína Bruta",
      ee: "Extrato Etéreo",
      fdn: "FDN",
      fda: "FDA",
      ca: "Cálcio",
      p: "Fósforo",
      k: "Potássio",
      s: "Enxofre",
      na: "Sódio",
      zinc: "Zinco",
      manufacturer: "Fabricante",
      veterinarySupplement: "Item Veterinário",
      type: "Tipo",
      name: "Nome Comercial",
      supplierId: "Fornecedor",
      applicationGender: "Sexo",
      applicationType: "Forma de Aplicação",
      applicationValue: "Qtd. de Aplicação",
      applicationWeightValueParam: "Peso",
      unitId: "Unidade de uso",
      applicationCost: "Custo Aplicação",
      originalSupplement: "Matéria Prima/Suplemento Original",
    },
    journal: {
      tabs: { details: "Detalhes", movements: "Movimentações" },
      searchPlaceholder: "Buscar por NF ou solicitante...",
      filter: {
        type: "Tipo",
        origin: "Origem",
        startDate: "Data inicial",
        endDate: "Data final",
        clear: "Limpar filtros",
      },
      sort: {
        label: "Ordenar por",
        movementDate: "Data da movimentação",
        createdAt: "Data de registro",
        amount: "Quantidade",
        unitCost: "Custo unitário",
        cost: "Custo total",
        ascending: "Ordem crescente",
        descending: "Ordem decrescente",
      },
      card: {
        amount: "Quantidade",
        unitCost: "Custo Unit.",
        cost: "Custo Total",
        cmpResult: "Custo Médio (CMP)",
        amountBalance: "Saldo Qtd.",
        costBalance: "Saldo Custo",
        invoice: "NF",
        requester: "Solicitante",
        createdAt: "Registrado em",
      },
      viewInvoice: "Ver NF-e",
      total: "{count} movimentação(ões)",
      empty: "Nenhuma movimentação encontrada.",
      loadError: "Erro ao carregar as movimentações do item.",
    },
    form: {
      internalId: "Identificação",
      abbreviation: "Abreviação",
      description: "Descrição",
      group: "Grupo",
      subgroup: "Subgrupo",
      measurementUnit: "Unidade Medida",
      replenishmentPoint: "Ponto Reposição",
      currentCost: "Custo Atual (R$)",
      variantControl: "Controle de Variante",
      batchControl: "Controle de Lote",
      notes: "Notas Complementares",
      dietItem: "Item de Dieta",
      product: "Produto",
      supplementSupplierId: "Fornecedor do Suplemento",
      supplementGroup: "Grupo do Suplemento",
      supplementSubGroup: "Subgrupo do Suplemento",
      supplementPresentation: "Apresentação",
      nutritionalDetails: "DADOS NUTRICIONAIS",
      supplementTypeNew: "Novo",
      supplementTypeExisting: "Já existente",
      veterinarySupplement: "Item Veterinário",
      veterinaryDetails: "DADOS DO SUPLEMENTO VETERINÁRIO",
      veterinarySupplementTypeNew: "Novo",
      veterinarySupplementTypeExisting: "Já existente",
      veterinarySupplementId: "Item Veterinário",
      type: "Tipo",
      name: "Nome Comercial",
      supplierId: "Fornecedor",
      applicationGender: "Sexo",
      applicationType: "Forma de Aplicação",
      applicationValue: "Qtd. de Aplicação",
      applicationWeightValueParam: "Peso",
      unitId: "Unidade de uso",
      applicationCost: "Custo Aplicação",
      cost: "Custo",
      dryMatterPercentage: "MS: Matéria Seca",
      ndt: "NDT: Nutrientes Digest. Totais",
      pb: "PB: Proteína Bruta",
      ee: "Extrato Etéreo",
      fdn: "FDN",
      fda: "FDA",
      ca: "Cálcio",
      p: "Fósforo",
      k: "Potássio",
      s: "Enxofre",
      na: "Sódio",
    },
    auditWarning:
      "Campos marcados com ⚡ requerem aprovação de outro usuário para entrar em vigor.",
    pendingAuditAlert:
      "Item bloqueado — Existem alterações pendentes de aprovação na auditoria. Edição e movimentação bloqueadas até a resolução.",
    confirmInactivate:
      'Tem certeza que deseja inativar "{description}"? O item não aparecerá mais na lista de itens ativos.',
    confirmReactivate: 'Tem certeza que deseja reativar "{description}"?',
    confirmDelete:
      'Tem certeza que deseja excluir "{description}"? Esta ação não pode ser desfeita.',
    saveOptions: {
      savedSuccess: "Item salvo com sucesso!",
      deletedSuccess: "Item excluído com sucesso.",
      inactivatedSuccess: "Item inativado.",
      reactivatedSuccess: "Item reativado.",
    },
    error: {
      loadError: "Erro ao carregar itens de estoque.",
      saveError: "Erro ao salvar item.",
      deleteError: "Erro ao excluir item.",
    },
    movements: {
      summary: { entries: "Entradas", exits: "Saídas", pending: "Pendentes" },
      searchPlaceholder: "Buscar por item, ID ou NF...",
      filter: {
        all: "Todos",
        entries: "Entradas",
        exits: "Saídas",
        inactive: "Inativados",
      },
      buttons: { newEntry: "Entrada", newExit: "Saída" },
      table: {
        id: "ID",
        type: "Tipo",
        origin: "Origem",
        item: "Item",
        batch: "Lote",
        quantity: "Quantidade",
        measurementUnit: "Unidade",
        unitCost: "Custo Unit.",
        nf: "NF",
        status: "Status",
        date: "Data",
        user: "Usuário",
        actions: "Ações",
        totalCost: "Custo Total",
        createdAt: "Criado em",
      },
      type: { entry: "Entrada", exit: "Saída" },
      status: {
        pending: "Pendente",
        completed: "Realizado",
        audit: "Auditoria",
        inactive: "Inativo",
        processing: "Processando",
        error: "Erro",
      },
      entryOrigins: {
        purchase: "Compra",
        adjustment: "Ajuste",
        transfer: "Transferência",
        return: "Devolução",
        production: "Produção",
      },
      exitOrigins: {
        sale: "Venda",
        withdrawal: "Retirada",
        loss: "Perda",
        adjustment: "Ajuste",
        transfer: "Transferência",
        productionConsumption: "Consumo Produção",
      },
      form: {
        title: { entry: "Entrada de Material", exit: "Saída de Material" },
        origin: "Origem",
        documentType: "Tipo Documento",
        nfReference: "Nº Documento",
        documentTypes: {
          invoice: "NF",
          simpleRemittance: "SR (Simples Remessa)",
          internalDoc: "Doc. Interno",
        },
        nfDate: "Data Emissão",
        issueDate: "Data Retirada",
        productionDate: "Data de Produção",
        receiptDate: "Data Recebimento",
        supplier: "Fornecedor",
        cpfCnpj: "CPF/CNPJ",
        requester: "Solicitante",
        materials: "Materiais",
        addItem: "Adicionar Item",
        totalCost: "Custo Total dos Itens",
        stockItem: "Item de Estoque",
        variant: "Variante",
        newVariant: "+ Criar nova variante",
        batch: "Lote",
        newBatch: "+ Criar novo lote",
        manufacturer: "Fabricante",
        batchNumber: "Número do Lote",
        serialNumber: "Número de Série",
        specification: "Especificação",
        measurementUnit: "Unidade de Medida",
        quantity: "Quantidade",
        unitCost: "Custo Unitário",
        expiration: "Expiração",
        expirationMode: { date: "Data", days: "Dias" },
        locations: "Localizações",
        location: {
          warehouse: "Armaz.",
          shelf: "Estante",
          rack: "Pratel.",
          drawer: "Gaveta",
          deposit: "Depósito",
          tank: "Tanque",
        },
        conversion: {
          title: "Conversão de Unidade (NF → Estoque)",
          nfQty: "Qtd NF",
          nfUnit: "Unid. NF",
          factor: "Fator",
          nfUnitCost: "Custo Unit. NF",
          stockUnit: "Unid. Estoque",
        },
        observations: "Observações",
        loadXml: "Carregar XML",
        loadPdf: "Carregar PDF",
        view: "Visualizar",
        pendingHint:
          'Se a NF ainda não foi registrada no módulo Financeiro, o movimento ficará com status "Pendente".',
        auditHint:
          "Este movimento criará uma pendência para aprovação por outro usuário.",
        financialTransaction: {
          title: "Despesa Financeira Vinculada",
          mainValueHelp:
            "Valor calculado automaticamente com base no custo total dos itens desta movimentação (quantidade x custo unitário).",
        },
      },
      detail: {
        title: "Detalhes do Movimento",
        generalInfo: "Informações Gerais",
        itemInfo: "Item",
        observations: "Observações",
        viewNfe: "Ver NF-e",
        delete: "Excluir",
        blocked:
          "Movimento bloqueado — Existe uma solicitação de exclusão pendente de auditoria.",
      },
      deleteConfirm: {
        title: "Solicitar Exclusão de Movimento",
        description:
          "Um registro de auditoria será criado e a exclusão precisará ser aprovada por um segundo usuário. Enquanto pendente, este movimento e os itens relacionados ficarão bloqueados.",
        confirm: "Confirmar Exclusão",
      },
      duplicateNf: {
        title: "NF já registrada",
        cancel: "Cancelar movimento",
        continue: "Continuar mesmo assim",
      },
      saveOptions: {
        savedSuccess: "Movimento(s) salvo(s) com sucesso!",
        deleteRequested: "Solicitação de exclusão enviada para auditoria.",
      },
      error: {
        loadError: "Erro ao carregar movimentos.",
        saveError: "Erro ao salvar movimento.",
        originRequired: "Selecione a origem do movimento.",
        requesterRequired: "Informe o solicitante.",
        receiptDateRequired: "Informe a data de recebimento.",
        supplierRequired: "Selecione o fornecedor.",
        stockItemRequired: "Selecione o item de estoque.",
        manufacturerRequired: "Selecione o fabricante.",
        measurementUnitRequired: "Selecione a unidade de medida.",
        conversionFactorRequired: "Informe o fator de conversão.",
        quantityRequired: "Informe a quantidade.",
        costRequired: "Informe o custo unitário.",
        lineRequired: "Adicione ao menos um item com quantidade.",
      },
      emptyTable: "Nenhum movimento encontrado.",
      notifications: {
        batchCreated: "Lote criado com sucesso",
        errorBatchCreated: "Erro ao criar lote",
        variantCreated: "Variante criada com sucesso",
        errorVariantCreated: "Erro ao criar variante",
      },
    },
  },
  importAnimalVaccination: {
    title: "Importar Veterinários",
    message:
      '<p class="message">Faça <strong>download do template abaixo, complete a planilha</strong> com as veterinários, <strong>faça a importação</strong> em seguida e clique em processar veterinários</p>',
    draggerMessage:
      "Clique ou arraste o arquivo para esta área para fazer o upload",
    identificationLabel: "Identificação*",
    identification: "Identificação",
    electronicId: "Id. Eletrônica",
    sisbov: "SISBOV",
    successMessage: "Veterinários em processamento",
    successDescription:
      "O seu arquivo esta sendo processado, aguarde. Você será notificado quando todas as veterinários forem processadas.",
    errorMessage: "Erro ao importar",
    errorDescription: "Nenhuma vacinação foi incluída.",
  },
  register: {
    title: "Cadastro de usuário",
    subtitle: "Informe os campos abaixo para iniciar o cadastro",
    form: {
      registrationEmail: "E-mail de cadastro",
      fullname: "Nome completo",
      document: "CPF",
      contact: "Contato",
      address: "Endereço",
      addressNumber: "Número",
      neighborhood: "Bairro",
      placeholder: "Informe aqui...",
    },
    step2: {
      title: "Confirmação de cadastro",
      subtitle:
        "Por favor, copie e cole no campo abaixo, o código enviado para o seu e-mail.",
      codePlaceholder: "Insira o código aqui",
      resendCode: "Enviar código novamente",
      password: "Senha",
      confirmPassword: "Confirme a senha",
      confirmPasswordPlaceholder: "Confirme a senha",
    },
    step4: {
      title: "Escolha a forma de pagamento",
      creditCard: "Cartão de Crédito",
      bankSlip: "Boleto",
      differentHolderData: "Dados do titular do cartão diferentes do cadastro",
      holderName: "Nome do titular/portador",
      cardNumber: "Número do Cartão",
      cardExpiration: "Data do vencimento",
      cardCVV: "Código de segurança",
      dueDateTitle: "Escolha a data de vencimento da fatura",
      dueDatePlaceholder: "Selecione uma data",
      form: {
        dayPrefix: "Dia",
      },
    },
    messages: {
      emailAlreadyRegistered: "E-mail já cadastrado em nossa base de dados",
      emailInvalid: "E-mail inválido.",
      emailInvalidUrl: "E-mail passado na Url está em um formato inválido",
      emailRequired: "Informe um e-mail.",
      nameRequired: "É necessário informar um nome.",
      cpfInvalid: "O CPF informado é invalido, informe outro.",
      phoneInvalid: "O Telefone informado é invalido, informe outro.",
      validationCodeSent: "Código de validação enviado para o e-mail.",
      internalError: "Erro interno. Contate o suporte.",
      registrationErrorCpf:
        "Erro ao efetuar o cadastro. CPF já cadastrado em nosso sistema.",
      registrationError: "Erro ao efetuar o cadastro",
      notRobot: "Prove que você não é um robô",
      codeInvalid: "Código inválido",
      dueDateInvalid: "Dia de vencimento da fatura inválido.",
      holderNameRequired: "Nome do titular/portardor é obrigatório.",
      cpfInvalidPayment: "CPF inválido.",
      cardNumberInvalid: "Número do Cartão inválido.",
      cardExpirationInvalid: "Data do Vencimento inválida.",
      cardCvvInvalid: "Código de segurança inválido.",
      trialEnvironmentReady:
        "Seu ambiente demo está pronto e você já pode fazer o login.",
      trialEnvironmentCreating:
        "Seu ambiente demo está sendo criado, lhe enviaremos um e-mail quando estiver pronto.",
      registerGroupFarm: "Agora cadastre um grupo e uma fazenda",
      codeVerified: "Código verificado com sucesso",
    },
    drawer: {
      title: "Completar dados",
      codeInstructions:
        "Foi enviado um código para o e-mail informado, copie e cole no campo abaixo",
      codeInputPlaceholder: "INFORME O CÓDIGO AQUI",
      resendCode: "ENVIAR CÓDIGO NOVAMENTE",
      verified: " Verificado",
      validate: "Validar",
      definePassword: "Defina sua senha de acesso",
      newPassword: "Nova senha",
      confirmNewPassword: "Confirme a nova senha",
      address: "Endereço",
      processing: "Processando",
    },
  },
  changePassword: {
    title: "Resgatar minha senha",
    subtitle: "Informe o seu e-mail de cadastro abaixo",
    back: "Voltar",
    registrationEmail: "E-mail de cadastro",
    placeholder: "Informe aqui...",
    submitButton: "Resgatar senha",
    emailNotRegistered:
      "E-mail informado não cadastrado, favor informar um e-mail válido",
    messages: {
      codeSent: "O código de verificação foi enviado no e-mail informado",
      somethingWentWrong: "Algo deu errado, favor tentar mais tarde",
    },
    drawer: {
      title: "Trocar senha",
      codeInstructions:
        "Foi enviado um código para o e-mail informado, copie e cole no campo abaixo",
      codeInputPlaceholder: "INFORME O CÓDIGO AQUI",
      resendCode: "ENVIAR CÓDIGO NOVAMENTE",
      verified: " Verificado",
      validate: "Validar",
      definePassword: "Defina sua senha de acesso",
      newPassword: "Nova senha",
      confirmNewPassword: "Confirme a nova senha",
      messages: {
        codeSent: "Código de validação enviado para o e-mail.",
        emailAlreadyRegistered: "E-mail já cadastrado em nossa base de dados",
        internalError: "Erro interno. Contate o suporte.",
        codeVerified: "Código verificado com sucesso",
        codeInvalid: "Código inválido",
        passwordChanged: "Senha redefinida com sucesso!",
        notRobot: "Prove que você não é um robô",
        passwordUsedBefore: "Senha já utilizada anteriormente.",
        errorResettingPassword: "Erro ao redefinir as senha.",
      },
    },
    logged: {
      title: "Redefinir senha",
      definePassword: "Defina sua senha de acesso",
      newPassword: "Nova senha",
      confirmNewPassword: "Confirme a nova senha",
      passwordMismatch: "Valores não corrrespondentes",
      messages: {
        passwordChanged: "Senha redefinida com sucesso!",
        passwordUsedBefore: "Senha já utilizada anteriormente.",
        errorResettingPassword: "Erro ao redefinir as senha.",
      },
    },
  },
  common: {
    marketingTagline: "Decisões que engordam o bolso",
    nav: {
      contactUs: "fale conosco",
      aboutUs: "sobre nós",
      support: "suporte",
    },
    address: {
      zipCode: "CEP",
      sectionTitle: "ENDEREÇO",
      numberAddon: "Nº",
      complementAddon: "Comp.",
    },
    cpf: "CPF",
    time: {
      days: "dias",
      months: "meses",
      dayPrefix: "Dia",
    },
  },
  login: {
    title: "Login",
    subtitle: "Faça login na plataforma e gerencie sua fazenda",
    loginLabel: "LOGIN",
    passwordLabel: "senha",
    usernamePlaceholder: "Digite o seu e-mail de cadastro",
    passwordPlaceholder: "Digite sua senha de cadastro",
    showPassword: "Exibir senha",
    submitButton: "Fazer login",
    forgotPassword: "Esqueceu a senha?",
    forgotPasswordLink: "Clique aqui!",
    messages: {
      notRobot: "Prove que você não é um robô",
    },
  },
  accessConfirmation: {
    title: "Parece que você ainda não possui cadastro",
    subtitle: "Informe os campos abaixo para cadastrar o seu usuário",
    passwordMismatch: "A senha e a confirmação de senha, estão diferentes",
    emailLabel: "Email",
    fullnameLabel: "Nome completo*",
    documentLabel: "CPF*",
    birthdayLabel: "Data de Nascimento*",
    contactLabel: "Contato*",
    newPasswordLabel: "Nova senha",
    confirmNewPasswordLabel: "Confirme a nova senha",
    termText: "Ao assinalar a caixa você concorda com as",
    termLink: "condições e regras de uso",
    termTextEnd: "do sistema Bovexo",
    placeholder: "Informe aqui...",
    messages: {
      registerError: "Não foi possível cadastrar usuário",
      documentAlreadyExists: "Já existe usuário cadastrado com este documento",
    },
    justConfirm: {
      title: "Convite foi confirmado!",
      subtitle: "Clique no botão abaixo e efetue o login.",
      button: "OK, ENTENDI",
    },
    alreadyConfirm: {
      title: "Convite já confirmado",
      subtitle: "Clique no botão abaixo e efetue o login.",
      button: "OK, ENTENDI",
    },
    expirated: {
      title: "Convite expirado!",
      subtitle:
        "Aguarde ou entre em contato com o responsável para reenviar o convite",
      button: "OK, ENTENDI",
    },
  },
  accessInvitations: {
    inviteButton: "Convidar",
    resendInvite: "Reenviar convite",
    statusSended: "Convite enviado",
    statusExpirated: "Convite expirado",
    statusAccepted: "Convite aceito",
    statusCanceled: "Convite cancelado",
    columnEmail: "E-mail",
    columnSentAt: "Enviado em",
    columnExpiresAt: "Expira em",
    messages: {
      fetchError: "Não foi possível retornar os convites",
      resubmitSuccess: "Convite reenviado",
      resubmitError: "Houve um erro ao reenviar o convite",
    },
  },
  supplierManagement: {
    buttons: {
      invite: "Convidar",
    },
    table: {
      columns: {
        businessName: "Razão Social",
        fantasyName: "Fantasia",
        documentNumber: "CNPJ",
      },
      menu: {
        edit: "Editar",
        resendInvite: "Reenviar convite",
      },
    },
    messages: {
      fetchError: "Não foi possível retornar os convites",
      resendSuccess: "Reenvio de email realizado com sucesso!",
      resendError: "Ocorreu um erro ao tentar reenviar os emails!",
      saveSuccess: "Contratação realizada com sucesso!",
      saveError: "Ocorreu um erro ao tentar salvar as informações do grupo!",
      loadError: "Ocorreu um erro ao acessar as informações.",
    },
    form: {
      back: "Voltar",
      title: "Grupos e empresas de fornecedores",
      subtitle:
        "Preencha o formulário abaixo para convidar um novo usuário do tipo fornecedor",
      groupNameLabel: "Razão Social*",
      groupFantasyNameLabel: "Nome Fantasia*",
      documentLabel: "CNPJ*",
      managerSectionTitle: "Responsável",
      nameLabel: "Nome*",
      emailLabel: "E-mail*",
      phoneLabel: "Telefone*",
      companiesSectionTitle: "Empresas",
      companyNameLabel: "Razão Social*",
      fantasyNameLabel: "Fantasia*",
      placeholder: "Informe aqui...",
      save: "Salvar",
    },
    validation: {
      groupNameRequired: "É necessário informar a Razão Social do Grupo.",
      groupFantasyNameRequired:
        "É necessário informar o Nome Fantasia do Grupo.",
      documentNumberRequired: "É necessário informar o CNPJ do Grupo.",
      documentNumberInvalid: "CNPJ do Grupo inválido.",
      managerRequired: "É necessário informar pelo menos 1 Responsável.",
      companyRequired: "É necessário informar pelo menos 1 Empresa.",
      managerNameRequired: "É necessário informar o Nome do Responsável.",
      managerEmailRequired: "É necessário informar o E-mail do Responsável.",
      managerEmailInvalid: "E-mail do Responsável Inválido.",
      managerPhoneRequired: "É necessário informar o Telefone do Responsável.",
      managerPhoneInvalid: "Telefone do Responsável Inválido.",
      companyNameRequired: "É necessário informar a Razão Social da Empresa.",
      companyFantasyNameRequired:
        "É necessário informar o Nome Fantasia da Empresa.",
      companyDocumentRequired: "É necessário informar o CNPJ da Empresa.",
      companyDocumentInvalid: "CNPJ da Empresa inválido.",
    },
  },
  supplierGroup: {
    invites: {
      title: "Convites",
      buttons: {
        invite: "Convidar",
      },
      table: {
        columns: {
          name: "Nome",
          email: "Email",
        },
        menu: {
          resendInvite: "Reenviar convite",
        },
      },
      status: {
        sent: "Enviado",
        confirmed: "Confirmado",
        cancelled: "Cancelado",
      },
      messages: {
        fetchError: "Não foi possível retornar os convites",
        resendSuccess: "Reenvio de email realizado com sucesso!",
        resendError: "Ocorreu um erro ao tentar reenviar os emails!",
        saveSuccess: "Convite cadastrado com sucesso",
        saveError: "Houve um erro ao cadastrar o convite",
      },
      drawer: {
        title: "Convidar",
        subtitle: "Preencha os campos abaixo para convidar um colaborador",
        labels: {
          name: "Nome*",
          email: "E-mail*",
          accessProfile: "Perfil de acesso*",
          companies: "Empresa(s)*",
          selectCompanyMessage:
            "Selecione a empresa a ser gerenciada por este usuário",
        },
        roles: {
          manager: "Responsável",
          collaborator: "Colaborador",
        },
      },
    },
    collaborators: {
      title: "Colaboradores",
      table: {
        columns: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          company: "Empresa",
        },
      },
      messages: {
        fetchError: "Não foi possível retornar os convites",
      },
      roles: {
        collaborator: "Colaborador",
        admin: "Responsável",
      },
    },
  },
  inviteUser: {
    drawerTitle: "Convidar usuário",
    subtitle: "Preencha os campos abaixo para convidar um colaborador",
    labels: {
      email: "E-mail*",
      accessProfile: "Perfil de acesso*",
      group: "Grupo*",
      farms: "Fazenda(s)*",
      selectFarmMessage:
        "Selecione a fazenda a ser gerenciada por este usuário",
    },
    roles: {
      farmAdmin: "Administrador de Fazenda",
      technician: "Técnico",
    },
    messages: {
      saveSuccess: "Convite cadastrado com sucesso",
      saveError: "Houve um erro ao cadastrar o convite",
    },
  },
  registerSupplierGroup: {
    pageTitle: "Cadastro de usuário",
    pageSubtitle: "Preencha o formulário abaixo para acessar bovexo",
    labels: {
      fullName: "Nome Completo*",
      contact: "Contato*",
      cpf: "CPF*",
      password: "Senha*",
      confirmPassword: "Confirme a senha*",
    },
    placeholders: {
      password: "Senha",
      confirmPassword: "Confirme a senha",
    },
    term: {
      checkboxText: "Ao assinalar a caixa você concorda com as",
      linkText: "condições e regras de uso",
      suffix: "do sistema Bovexo",
    },
    buttons: {
      save: "Salvar",
    },
    messages: {
      fetchError: "Não foi possível buscar as informações do convite",
      saveSuccess: "Cadastro realizado com sucesso!",
      cpfAlreadyExists:
        "Erro ao efetuar o cadastro. CPF já cadastrado em nosso sistema.",
      emailAlreadyExists:
        "Erro ao efetuar o cadastro. E-mail já cadastrado em nosso sistema.",
      saveError: "Ocorreu um erro ao tentar salvar as informações!",
    },
    validation: {
      fullNameRequired: "É necessário informar o Nome.",
      phoneRequired: "É necessário informar o Telefone.",
      phoneInvalid: "Telefone Inválido.",
      cpfInvalid: "O CPF informado é invalido, informe outro.",
      passwordRequired: "É necessário informar uma Senha.",
      confirmPasswordRequired: "É necessário informar confirmação da senha.",
      passwordMismatch: "Senha e Confirmação da Senha precisam ser iguais.",
      termRequired: "É necessário aceitar os termos de serviço.",
    },
  },
  changeEmail: {
    drawer: {
      title: "Alterar e-mail",
      codeFromInstructions:
        "Foi enviado um código para o seu e-mail, copie e cole no campo abaixo",
      codeFromPlaceholder: "Informe o código aqui",
      codeToInstructions:
        "Foi enviado um código para o seu novo e-mail, copie e cole no campo abaixo",
      codeToPlaceholder: "Informe o código aqui",
      newEmailInstructions: "Informe seu novo e-mail no campo abaixo",
      newEmailPlaceholder: "Informe o e-mail",
      resendCode: "Enviar código novamente",
      updateButton: "Atualizar",
      verified: " Verificado",
      validate: "Validar",
      messages: {
        codeSentFrom: "Código de validação enviado para o e-mail.",
        codeSentTo: "Código de validação enviado para o novo e-mail.",
        userNotFound: "Usuário não encontrado.",
        internalError: "Erro interno. Contate o suporte.",
        emailAlreadyExists: "E-mail informado já existe.",
        codeInvalid: "Código inválido.",
        emailInvalid: "E-mail inválido",
      },
    },
  },
  weightGainProjection: {
    title: "Projeções de Ganho de Peso",
    buttonNew: "Nova Projeção",
    table: {
      status: "Status",
      name: "Nome",
      informType: "Tipo de Informação",
    },
    form: {
      title: "Projeção de Ganho de Peso",
      name: "Nome",
      namePlaceholder: "Digite o nome",
      informType: "Tipo de Informação",
      timeUnitReference: "Unidade de Tempo",
      fixedGmdWeight: "GMD Fixo (kg)",
      supplement: "Suplemento",
      supplementPlaceholder: "Selecione um suplemento (opcional)",
      addPeriod: "Adicionar Período",
      period: "Período",
      gmdWeight: "GMD (kg)",
      deleteLastOnly: "Apenas o último período pode ser excluído",
      periodMustBeGreaterError:
        "O período informado ({period}) deve ser maior que o último período adicionado ({lastPeriod})",
      chart: {
        title: "GMD (kg)",
        fixed90days: "Projeção fixa de 90 dias",
      },
      radiogroup: {
        farm: "Fazenda",
        group: "Grupo",
      },
    },
    informType: {
      period: "Período",
      fixed: "Fixo",
    },
    timeUnit: {
      day: "Dia",
      week: "Semana",
    },
    status: {
      active: "Ativo",
      inactive: "Inativo",
    },
    notification: {
      success: {
        create: { message: "Projeção criada com sucesso" },
        update: { message: "Projeção atualizada com sucesso" },
        activate: { message: "Projeção ativada" },
        inactivate: { message: "Projeção inativada" },
      },
      error: {
        save: { message: "Falha ao salvar projeção" },
        activate: { message: "Falha ao ativar projeção" },
      },
    },
  },
  groupItem: {
    title: "Grupo",
    buttonNew: "Novo Grupo de Item",
    table: {
      columns: {
        status: "Status",
        name: "Nome",
      },
      inactivateSuccess: "Grupo de Item inativado com sucesso!",
      inactivateError: "Erro ao inativar Grupo de Item. Contate o suporte.",
      activateSuccess: "Grupo de Item ativado com sucesso!",
      activateError: "Erro ao ativar Grupo de Item. Contate o suporte.",
    },
    form: {
      titleCreateNew: "Novo Grupo de Item",
      titleEdit: "Editar Grupo de Item",
      groupFarmVisibility: "Visibilidade",
      name: "Nome",
      description: "Descrição",
      externalIntegrationCode: "Código de Integração",
      status: "Status",
      successMessage: "Grupo de Item cadastrado/atualizado com sucesso.",
      errorMessage: "Erro ao cadastrar/editar Grupo de Item.",
    },
  },
  itemsGroup: {
    title: "Subgrupo",
    buttonNew: "Novo Item do Grupo",
    table: {
      columns: {
        status: "Status",
        name: "Nome",
        groupItemName: "Grupo de Item",
      },
      inactivateSuccess: "Item do Grupo inativado com sucesso!",
      inactivateError: "Erro ao inativar Item do Grupo. Contate o suporte.",
      activateSuccess: "Item do Grupo ativado com sucesso!",
      activateError: "Erro ao ativar Item do Grupo. Contate o suporte.",
    },
    form: {
      titleCreateNew: "Novo Item do Grupo",
      titleEdit: "Editar Item do Grupo",
      groupFarmVisibility: "Visibilidade",
      name: "Nome",
      description: "Descrição",
      externalIntegrationCode: "Código de Integração",
      status: "Status",
      groupItemId: "Grupo de Item",
      successMessage: "Item do Grupo cadastrado/atualizado com sucesso.",
      errorMessage: "Erro ao cadastrar/editar Item do Grupo.",
    },
    select: {
      selectGroupItemFirst: "Selecione um Grupo de Item primeiro",
    },
    classify: {
      title: "Classificar Item do Grupo",
      classification: "Classificação",
      classificationPlaceholder: "Selecione uma classificação",
      supplement: "Suplemento",
      veterinarySupplement: "Insumos Veterinários",
      successMessage: "Item do Grupo classificado com sucesso!",
      errorMessage: "Erro ao classificar Item do Grupo. Contate o suporte.",
      name: "Nome",
      description: "Descrição",
      externalIntegrationCode: "Código de Integração",
      groupItemName: "Grupo de Item",
      status: "Status",
    },
  },
  wagon: {
    table: {
      title: "Misturadores",
      columns: {
        name: "Nome",
        integrationCode: "Código de Integração",
        capacityKg: "Capacidade (Kg)",
        observations: "Observações",
        status: "Status",
      },
    },
    buttonNew: "Novo Misturador",
    drawer: {
      titleNew: "Novo Misturador",
      titleEdit: "Editar Misturador",
      subTitle: "Preencha os campos abaixo para cadastrar um novo misturador",
      form: {
        name: "Nome",
        integrationCode: "Código de Integração",
        capacityKg: "Capacidade (Kg)",
        observations: "Observações",
      },
    },
    messages: {
      saveSuccess: "Misturador cadastrado com sucesso",
      saveError: "Houve um erro ao cadastrar o misturador",
      updateSuccess: "Misturador atualizado com sucesso",
      updateError: "Houve um erro ao atualizar o misturador",
      activateError: "Misturador não foi ativado. Contate o suporte",
      inactivateError: "Misturador não foi inativado. Contate o suporte",
      nameAlreadyExists: "Já existe um misturador com este nome",
      integrationCodeAlreadyExists:
        "Já existe um misturador com este código de integração",
    },
  },
};
